import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { CaretLeft, CaretRight, CaretDoubleUp, CaretDoubleDown } from "@phosphor-icons/react";
import PropTypes from "prop-types";
import {
  DocumentContentArea,
  DocumentContentHeaderWrapper,
  FileNameShort,
  FileConflictContent,
  StyledActionButton,
  TabContentArea,
  TabContentHeaderWrapper,
  TabHeaderWrapper,
  TabItem,
  TabViewWrapper,
  StyledRadioGroup,
  StyledRadio,
  TabSectionWrapper,
  VisibleTabsContainer,
  FixedActionsContainer,
  TabScrollButtonLeft,
  TabScrollButtonRight,
  FixedCollapseButtonContainer,
  ViewMSWrapper,
  ViewMSFileButton,
  WarningLabel,
  SpanBold,
  SpanName,
  ScrollButtonIconWrapper,
} from "./TabViewStyled";
import Table from "../Table/Table";
import MatterDetailsSkeleton from "../Table/MatterDetailsSkeleton";
import MatterDetailsTableColumn from "../Table/columns/MatterDetailsTableColumn";
import MatterProcessingStatus from "../MatterProcessingStatus/MatterProcessingStatus";
import MatterDashboard from "../MatterDashboard/MatterDashboard";
import MergeSelectedBar, {
  getSelectedDocumentRecords,
} from "./MergeSelectedBar";
import ClipboardPasteBar from "./ClipboardPasteBar";
import SaveAsCollectionModal from "./SaveAsCollectionModal";
import DocumentVersionHistoryModal from "./DocumentVersionHistoryModal";
import GeneratePackageFromMatterModal from "./GeneratePackageFromMatterModal";
import {
  addCollectionDocuments,
  bulkPrepareDocuments,
  createCollection,
  fetchMatterCollections,
  prepareCollection,
} from "../../service/documentCollections";
import { PaginationContainer } from "../../pages/Matter/MatterStyled";
import Pagination from "../Pagination/Pagination";
import UploadButton from "../UploadButton/UploadButton";
import EmptyTableComponent from "../EmptyTable/EmptyTableComponent";
import Document from "../Document/Document";
import { useDispatch, useSelector } from "react-redux";
import SendToVAModal from "./components/SendToVAModal";
import useWebViewerInstances from "../../hooks/useWebViewerInstances";
import useDocumentLoader from "../../hooks/useDocumentLoader";
import useTemplateMergeFieldDecorations from "../../hooks/useTemplateMergeFieldDecorations";
import useFieldFormatValidator from "../../hooks/useFieldFormatValidator";
import useTemplateMergeFieldAudit from "../../hooks/useTemplateMergeFieldAudit";
import { performTextHighlighting, configurePermissions, getFileType } from "../../services/webViewerOperations";
import {
  getDocumentStreamingUrl,
  downloadDocumentFile,
  isDeliberateRefusal,
} from "../Document/DocumentUtils";
import AddLetterheadModal from "./components/AddLetterheadModal";
import { cleanupScrollState } from "../../utils/scrollCleanup";
import { ensureViewerWordSearch } from "../../utils/viewerWordSearch";
import {
  fetchCategoryList,
  addOpenedDoc,
  fetchMatterDetail,
  fetchMatterDetailList,
  fetchOpenedDocs,
  renameFolders,
  setExpandedKeys,
  setSelectedKeys,
  setSelectedDetails,
  setTabClick,
  setUpdateMeta,
  deleteDoc,
  deleteFolder,
  remindReview,
  getShareRecipients,
  reviewAction,
  submitAction,
  postHighlightedMatter,
  deleteHighlightMatter,
  resetStatuses,
  sendForESign,
  initiateESign,
  resetMatterDetailList,
  fetchBreadCrumbs,
  getDocumentDetails,
  updateDocumentDetail,
  clearDocumentDetail,
  updateDocumentLastPageViewed,
  setDocListingPageSize,
  updateTabOrder,
  setDeleteDoc,
  postLastPageViewed,
  addBookmarks
} from "../../slice/MatterDetailsSlice";
import { setCurrentContext, clearAnnotationUpdate, clearDocumentContentUpdate } from "../../slice/WebsocketSlice";
import { sendWebSocketMessage } from "../../middleware/websocketMiddleware";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../BreadCrumbComponent/BreadCrumb";
import {
  appendAIPaneTo,
  buildPathWithAIPaneTab,
  isAIPaneOpen,
} from "../../utils/aiPaneUrl";
import {
  applyPageJump,
  applySearchHighlight,
  buildCrossDocumentCitationPath,
  landOnCitation,
  resolveCitationLanding,
  setPendingCitationLanding,
  subscribeCitationJump,
} from "../../utils/citationJump";
import { selectRunningAnalysisDocIds } from "../../slice/AISlice";
import {
  fetchCategorizationForDocuments,
  fetchCategories as fetchCategorizationCategories,
  selectCategorizationFlagsForDocuments,
  selectCategoriesStatus,
  selectGoldStandardForDocument,
} from "../../slice/CategorizationSlice";
import CategorizeDocumentModal from "../Categorization/CategorizeDocumentModal";
import useAuth from "../../hooks/useAuth";
import useDocumentAutoSave from "../../hooks/useDocumentAutoSave";
import {
  editPDFsLock,
  editPDFsunLock,
  pdfRenameDocuments,
  updateShowActions,
} from "../../slice/PDFEditSlice";
import InlineLoader from "../Loader/InlineLoader";
import InstanceLoader from "../Loader/InstanceLoader";
import FileProperties from "../Drawer/Drawer";
import ErrorToast from "../Notification/ErrorToast";
import {
  collectNestedDocuments,
  findDocumentById,
} from "../../utils/fetchDocument";
import CustomModal from "../common/CustomModal/CustomModal";
import { getAllChildDocumentIdsByFolderId } from "../../utils/findChildrenDocs";
import ShareModal from "../ShareModal";
import AssignTaskModal from "../Inbox/AssignTaskModal";
import CreateWorkItemModal from "../Inbox/CreateWorkItemModal";
import DocumentWorkItemBar from "../WorkItems/DocumentWorkItemBar";
import SendMessageModal from "../Inbox/SendMessageModal";
import ReviewActionModal from "../ReviewActions/ReviewActionModal";
import {
  getReviewActionConfig,
  REVIEW_STATUS,
} from "../ReviewActions/ActionConstants";
import ReviewNotesModal from "../ReviewNotes/ReviewNotesModal";
import DocumentVersionPill from "./DocumentVersionPill";
import ESignModal from "../ESignModal";
import SendForSignatureModal from "../ESignLauncher/SendForSignatureModal";
import AttorneySignatureModal from "../AttorneySignature/AttorneySignatureModal";
import { registerDocumentReplacePreparer, subscribeDocumentReplaced } from "../../utils/documentReplaced";
import ShareFileModal from "../ExternalShare/ShareFileModal";
import ShareWithExpertModal from "../PortalShare/ShareWithExpertModal";
import SharedOutsideBadge from "../PortalShare/SharedOutsideBadge";
import { useMatterShareSummary } from "../PortalShare/useMatterShareSummary";
import { Box } from "@mui/material";
import { MessageModal, ConfirmModal } from "../common/Modals";
import { WarningIcon } from "../../assets/icons";
import MoreButton from "../MoreButton/MoreButton";
import AddToBriefBankModal from "../BriefBank/AddToBriefBankModal";
import Delete from "../../assets/images/Delete.svg";
import Rename from "../../assets/images/Rename.svg";
import Merge from "../../assets/images/merge.svg";
import Approve from "../../assets/images/Approve.svg";
import Rework from "../../assets/images/Rework.svg";
import FilePropertiesIcon from "../../assets/images/File properties icon.svg";
import ReviewNotes from "../../assets/images/review notes.svg";
import ESignImage from "../../assets/images/E-sign.png";
import SendIcon from "../../assets/images/send.svg";
import ExternalShare from "../../assets/images/externalShare.svg";
import AddLetterHead from "../../assets/images/addLetterHead.svg";
import DownloadIcon from "../../assets/images/download.svg";
import { bulkDeleteMatterDocuments, copyDocumentsApi, sendVAFormData, compressAndSendVAFormData } from "../../service/matter";
import { getDocumentMarkdown } from "../../service/analysis";
import { refreshSharePointDocumentChanges } from "../../service/uploadService";
import { isCurrentVaAgencyMatter } from "../../utils/matterFields";
import {
  combinePackageForSigning,
  fetchPackages,
  mergePackage,
  previewMappingDocument,
  previewPackage,
  renameGeneratedDocument,
} from "../../service/settings";
import {
  createObjectURL,
  createUploads,
  extractFilesFromDrop,
  handleUploadFailure,
  handleUploadSuccess,
  processFiles,
  useUploadUtils,
} from "../../utils/uploadUtils";
import { useUploadNotification } from "../../context/UploadNotificationContext";
import { useCancellableUpload } from "../../hooks/useCancellableUpload";
import {
  checkFileConflicts,
  extractMatterAndFolderFromPath,
  getConflictText,
  getFolderConflictInfo,
  getFolderNameById,
  getModalConfig,
  getTabBackground,
  handleVisibleTabDropLogic,
  updateTitleName,
  resetEditingState,
  handleSubmitESign,
  handlePdfValidation,
  handleConfirmSubmit,
  handleVaFixAndSubmit,
  getVaFixOfferCopy,
  handleGoBackToVa,
  handleShowVaCancelModal,
  handleConfirmVaClose,
  handleGoBackToVA,
  handleReviewSubmit,
  handleGoBackToAction,
  handleCloseActionModal,
  handleCloseSendToVAModal,
  handleConfirmReviewAction,
  closeTabsByIds,
  updateBreadcrumb,
  createBreadcrumbFromTreeData,
  fetchFolderDetails,
  handleRemindClick,
  updateTabState,
  handleShowActions,
  handleConfirmOverwrite,
  handleCancelOverwrite,
  handleFolderConflictOption,
  openConflictModal,
  handleDragEnter,
  handlePageSizeChange,
  handleRenameResponse,
  handleDelete,
  deleteDocFunc,
  handleTabDragStart,
  handleTabDragOver,
  handleTabDragEnter,
  handleTabDragLeave,
  saveFolderRename,
  handleRemoveOpenedDoc,
  resetRenameFlag,
  handleDocumentUnlock,
  handleTabClosure,
  handleError,
  handleBlur as handleBlurUtil,
  createHandleSnackbar,
  getNameWithoutExtension,
  getExtension,
  checkAndUpdateRelativePath,
  navigateWithChatbox,
  handlePageChange,
} from "./TabViewUtils";
import DropTarget from "../DropTarget/DropTarget";
import { removeNotification, addNotification } from "../../slice/SnackbarSlice";
import {
  copyDocumentsToClipboard,
  selectClipboardItems,
} from "../../slice/DocumentClipboardSlice";
import {
  clipboardItemsFromRecords,
  copySuccessMessage,
  extractCopyApiError,
  folderIdForPaste,
  formatPasteNote,
  isTypingTarget,
  stripFolderPrefix,
} from "../../utils/documentClipboard";
import { collectDocumentsByUniqueIds } from "../TreeComponent/documentMoveUtils";
import TabCloseButton from "./TabCloseButton";
import {
  EMAIL_FILE_TYPES,
  IMAGE_FILE_TYPES,
  mimeToExtension,
  MS_FILE_TYPES,
  PDF_FILE_TYPES,
} from "../../utils/constants";
import FileMergeModalContainer from "../FileMergeModal/FileMergeModalContainer";
import usePdfTools from "../PdfTools/usePdfTools";
import { useTabDragHandlers } from "./hooks/useTabDragHandlers";
import { renderTabContent } from "./components/TabRenderers";
import {
  flattenMatterFolderOptions,
  generatedDocumentId,
  preserveOffPageDocumentSelection,
} from "./matterPackageUtils";
import { ConfirmButton } from "../ConfirmModal/ConfirmModalStyled";
import { Button, Popover, Segmented, Tooltip, message as antdMessage } from "antd";
import MarkdownViewer from "../MarkdownViewer/MarkdownViewer";
import PackageResultsModal from "../../pages/Settings/FileTemplates/PackageResultsModal";
import FinalizePdfButton from "./FinalizePdfButton";
import { mergeFinalizedDocumentIntoTabs } from "./pdfFinalize";
import {
  freshStorageIdentity,
  getSharePointOfficeExtension,
  openSharePointDocument,
  shouldOpenSharePointDocument,
} from "./sharePointOffice";

const SHAREPOINT_REFRESH_MAX_WAIT_MS = 30000;
const SHAREPOINT_REFRESH_POLL_MS = 2000;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const cacheBustDocumentUrlResult = (urlResult) => {
  if (!urlResult?.url) {
    return urlResult;
  }
  const separator = urlResult.url.includes("?") ? "&" : "?";
  return {
    ...urlResult,
    url: `${urlResult.url}${separator}refresh=${Date.now()}`,
  };
};

const TabView = ({showSideBar,setShowSideBar,setBreadcrumb,breadcrumb,uniqueId,setUniqueId,treeData,drawerError,setdrawerError,currentPage,setCurrentPage,checkTabLimitRef,cleanupDocumentRef,openTabRef,setActiveTabRef,onTabClosed,}) => {
  
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  // ``navigate`` MUST stay declared before any ``useEffect`` whose dep
  // array references it, otherwise the dep array hits ``navigate`` in
  // its TDZ during render and React fails to mount the entire matter
  // workspace ("Cannot access 'navigate' before initialization"). See
  // hotfix PR for the citation-jump useEffect a few hundred lines below.
  const navigate = useNavigate();
  const { dispatch : dispatchUpload } = useUploadUtils();
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [pastingClipboard, setPastingClipboard] = React.useState(false);
  // Ref to persist tab 1 selection state across tab switches
  const tab1SelectionRef = useRef([]);
  // Bulk AI prepare + "save as collection" from the selection bar.
  const [preparingSelectionForAi, setPreparingSelectionForAi] =
    React.useState(false);
  const [collectionModalOpen, setCollectionModalOpen] = React.useState(false);
  const [collectionCandidates, setCollectionCandidates] = React.useState([]);
  const [collections, setCollections] = React.useState([]);
  const [loadingCollections, setLoadingCollections] = React.useState(false);
  const [savingCollection, setSavingCollection] = React.useState(false);
  const bookmarkListenerRef = useRef(null);
  const bookmarksSaveTimerRef = useRef(null);
  const isImportingBookmarksRef = useRef(false);
  const [open, setOpen] = useState(false);
  const [fileProp, setFileProp] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showShareModal, setShowShareModal] = useState(false)
  const [showAssignModal, setShowAssignModal] = useState(false)
  const [showWorkItemModal, setShowWorkItemModal] = useState(false)
  const [showReviewActionModal, setShowReviewActionModal] = useState(false);
  const [reviewActionType, setReviewActionType] = useState(null);
  const [forwardRecipientOptions, setForwardRecipientOptions] = useState([]);
  const [selectedForwardRecipients, setSelectedForwardRecipients] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [hoveredRowName, setHoveredRowName] = useState(null);
  const [dropTargetName, setDropTargetName] = useState(null);
  const [isDraggingOverRow, setIsDraggingOverRow] = useState(false);
  const [confirmCloseModal, setConfirmCloseModal] = useState(false);
  const [confirmCloseTab, setConfirmCloseTab] = useState(false);
  const [actionComment, setActionComment] = useState("");
  const [confirmSubmit, setConfirmSubmit] = useState(false);
  // The server's 422 body ({ error, error_code, fixable }) when Submit was
  // refused for something WHG Docs can fix (oversized page / oversized
  // file); drives the Resize/Compress & Submit offer. null = no offer.
  const [vaFixOffer, setVaFixOffer] = useState(null);
  const {
    loader,
    matterDetails,
    selectedKeys,
    expandedKeys,
    matterDetailsTree,
    matterDetailsList,
    totalRecords,
    openDocs,
    openDocsStatus,
    matterDetailsStatus,
    matterDetailsLIstStatus,
    pageSize,
    deleteDocuId,
    documentDetail,
  } = useSelector((state) => state.matterDetails);
  const isVaAgencyMatter = isCurrentVaAgencyMatter(matterDetailsTree, id);
  const errorMessages = useSelector(state => state.snackbar.errorMessages);
  const clipboardItems = useSelector(selectClipboardItems);
  const { showActions } = useSelector((state) => state.editPDF);
  const annotationUpdate = useSelector((state) => state.websocket.annotationUpdate);
  const documentContentUpdate = useSelector((state) => state.websocket.documentContentUpdate);
  const [shareID, setShareID] = useState("")
  const [isLoading, setisLoading] = useState(false);
  const [shareContext, setShareContext] = useState({});
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [hasScrollableContent, setHasScrollableContent] = useState(false);
  const [maxWidth, setMaxWidth] = useState(null);
  const tabSectionWrapperRef = useRef(null);
  const tabHeaderWrapperRef = useRef(null);
  const hasUserScrolledRef = useRef(false); // Track if user has manually scrolled
  const shouldAutoScrollRef = useRef(new Map()); // Track which tabs/events should auto-scroll: Map<tabId, boolean>
  const [documentBreadcrumb, setDocumentBreadcrumb] = useState([]);
  // Store breadcrumbs per tab: tabId -> breadcrumb array
  const [tabBreadcrumbs, setTabBreadcrumbs] = useState(new Map());
  const [loadingStatus, setLoadingStatus] = useState("idle")
  const [refreshingSharePointDocumentId, setRefreshingSharePointDocumentId] = useState(null);
  // Which document/tab the "Version N" badge opened the history window for.
  const [versionHistoryTarget, setVersionHistoryTarget] = useState(null);
  const [viewModeByTab, setViewModeByTab] = useState({});
  // Cache markdown content per tab. `currentDocDetail` for a non-active tab
  // falls back to tabDocumentData, which is the result of merging
  // documentRecord over documentDetail; if documentRecord lacks
  // markdown_content it can clobber the real value. Caching here guarantees
  // each tab keeps its own content independently of that merge.
  const [markdownContentByTab, setMarkdownContentByTab] = useState({});
  const [tabs, setTabs] = useState([
    {
      id: "1",
      title: matterDetails?.matter_displayName,
      content: "Table of PDFs",
      relativePath: `/${location.pathname.split("/matter/")[1]}`
    },
  ]);
  const hasOpenedTabs = useRef(false);
  const didMount = useRef(false);
  // Lets the "Create Doc from Template" button open UploadButton's
  // existing template picker directly, skipping the "Add" dropdown.
  const templateUploadButtonRef = useRef(null);
  
  // Multi-instance WebViewer management (one instance per tab)
  const webViewerInstances = useWebViewerInstances();
  const documentLoader = useDocumentLoader();
  const { highlightEmptyMergeFields } = useTemplateMergeFieldDecorations();
  const { installFieldFormatValidators } = useFieldFormatValidator();
  const { installFieldAuditListener } = useTemplateMergeFieldAudit();

  // One-shot: each merged-from-template document gets empty-field highlighting
  // applied exactly once on first open. Subsequent re-opens of the same doc
  // (tab switches, page navigation, etc.) skip it because the merge-time
  // navigation state is gone and this ref remembers we've already decorated.
  const templateMergeDecoratedRef = useRef(new Set());
  const fieldValidatorCleanupsRef = useRef(new Map());
  const fieldAuditCleanupsRef = useRef(new Map());
  // Stores the cleanup fn returned by highlightEmptyMergeFields (removes the
  // fieldChanged listener that clears highlights on fill). Mirrors the pattern
  // used for validator/audit listeners so tab-close detaches all three.
  const fieldDecorationCleanupsRef = useRef(new Map());
  
  // Track current active document
  const currentDocumentIdRef = useRef(null);
  const prevActiveTabRef = useRef(null);
  // Documents the server is replacing (attorney signature); saving one before
  // its new version is loaded would write the old file back.
  const replacingDocumentIdsRef = useRef(new Set());
  // Track if user manually switched tabs to prevent race conditions
  const manualTabSwitchRef = useRef(false);
  // Ref to TabContentArea for scroll control
  const tabContentAreaRef = useRef(null);

  
  // Track listeners to clean them up
  const annotationListenerRef = useRef(null);
  const pageChangeListenerRef = useRef(null);
  const pagesUpdatedListenerRef = useRef(null);
  const annotationChangeDebounceRef = useRef({ timerId: null, documentId: null });
  const insertBatchRef = useRef({ timerId: null, pages: [], documentId: null });
  const reorderBatchRef = useRef({ timerId: null, moves: [], documentId: null });
  const removeBatchRef = useRef({ timerId: null, pages: [], documentId: null });
  const userInteractionCleanupRef = useRef(new Map()); // Map<documentId, cleanupFunction>
  const isApplyingRemoteUpdate = useRef(false);
  const [renameEditFlag, setRenameEditFlag] = useState({});
  const [docLoading, setDocLoading] = useState(false);
  const [pendingRename, setPendingRename] = useState(null);
  const [titleName, setTitleName] = useState({});
  const [activeTabState, setActiveTabState] = useState("1");
  const [isInstanceLoading, setIsInstanceLoading] = useState(false); // Track WebViewer instance initialization
  const [isPaginationLoading, setIsPaginationLoading] = useState(false); // Track pagination loading state
  
  // Wrapper for setActiveTab to log all calls
  const setActiveTab = useCallback((tabId) => {
    const stackTrace = new Error().stack;
    const caller = stackTrace?.split('\n')[2]?.trim() || 'unknown';
    console.log(`🎯 [setActiveTab] ========== CALLED ==========`);
    console.log(`🎯 [setActiveTab] New tab ID: ${tabId}`);
    console.log(`🎯 [setActiveTab] Previous tab ID: ${activeTabState}`);
    console.log(`🎯 [setActiveTab] Current URL: ${location.pathname}`);
    console.log(`🎯 [setActiveTab] manualTabSwitchRef: ${manualTabSwitchRef.current}`);
    console.log(`🎯 [setActiveTab] Called from: ${caller}`);
    console.log(`🎯 [setActiveTab] =================================`);
    setActiveTabState(tabId);
  }, [activeTabState, location.pathname]);
  
  // Use activeTabState as activeTab for the rest of the component
  const activeTab = activeTabState;

  // Expose WebViewer instances info to window for debugging
  useEffect(() => {
    if (typeof window !== 'undefined') {
      globalThis.window.webViewerInstances = {
        getInstanceInfo: () => {
          const activeTabIds = webViewerInstances.getActiveTabIds();
          const instanceInfo = activeTabIds.map(tabId => {
            const instance = webViewerInstances.getInstance(tabId);
            const documentData = webViewerInstances.getTabDocumentData(tabId);
            const container = webViewerInstances.getContainer(tabId);
            
            let documentInfo = null;
            if (instance?.Core?.documentViewer) {
              const doc = instance.Core.documentViewer.getDocument();
              if (doc) {
                documentInfo = {
                  filename: doc.getFilename ? doc.getFilename() : 'unknown',
                  pageCount: instance.Core.documentViewer.getPageCount(),
                  currentPage: instance.Core.documentViewer.getCurrentPage(),
                };
              }
            }
            
            return {
              tabId,
              hasInstance: !!instance,
              hasContainer: !!container,
              documentId: documentData?.id || documentData?.unique_id?.substring(1) || null,
              documentName: documentData?.name || null,
              documentInfo,
            };
          });
          
          return {
            totalInstances: activeTabIds.length,
            instances: instanceInfo,
            activeTab: activeTab,
          };
        },
      };
    }
  }, [webViewerInstances, activeTab]);

  // A signature burned in on the server replaces the file; an open tab must
  // show the new version, or its auto-save would write the unsigned one back.
  useEffect(() => {
    return subscribeDocumentReplaced(async ({ documentId, replaced }) => {
      const tabId = `D${documentId}`;
      const instance = webViewerInstances.getInstance(tabId);
      if (replaced && instance) {
        const tabData = webViewerInstances.getTabDocumentData(tabId) || {};
        try {
          await instance.Core.documentViewer.closeDocument();
          await documentLoader.loadDocument(instance, { ...tabData, id: documentId }, { tabId });
        } catch (error) {
          // Saves stay held until the tab closes: it may still show the unsigned file.
          console.error("Failed to reload the signed document:", error);
          dispatch(
            addNotification({
              id: `signed-reload-failed-${documentId}-${Date.now()}`,
              newMsg: "The signed copy was saved, but this tab couldn't show it. Close the tab and reopen the document before editing.",
              success: false,
            })
          );
          return;
        }
      }
      replacingDocumentIdsRef.current.delete(String(documentId));
    });
  }, [webViewerInstances, documentLoader, dispatch]);

  // Subscribe to citation-jump events emitted by `BriefingMarkdown` pills
  // inside the AI panel. Two payload shapes flow through the same bus:
  //
  //   * **Legacy** (no `shape`): the AI panel is bound to the active doc,
  //     and the citation page is for that doc. Resolve the active tab's
  //     WebViewer and jump page (no snippet info available).
  //
  //   * **New** (`shape === "new"`): the citation carries the
  //     authoritative target ``matterId``, ``targetDocumentId``, ``page``,
  //     and ``searchQuery`` (chunk-text snippet for highlight-on-arrival).
  //     The cited doc may be the active tab, a different tab in the same
  //     matter, or — in the cross-matter case — outside the current
  //     matter entirely.
  //
  // Routing for new-shape events:
  //
  //   1. Same active doc → ``applyPageJump`` + ``applySearchHighlightWithLadder``
  //      directly on the live instance. Fast-path, no navigation. The ladder
  //      progressively falls back from the full normalised snippet through
  //      the first 7 / 3 words so smart-quote / em-dash / line-break
  //      mismatches between the LLM-emitted snippet and the rendered PDF
  //      text layer don't silently kill the highlight.
  //
  //   2. Different doc in the same matter (``treeData`` has it under
  //      ``D<docId>``) → ``navigate`` with React Router state carrying
  //      ``highlightMetadata`` in the chat-driven format. The existing
  //      ``performTextHighlighting`` listener fires once the WebViewer
  //      finishes loading the new doc; this is the same path the chat
  //      citation flow uses, so we don't need a parallel deferred-jump
  //      mechanism.
  //
  //   3. Doc not found in the current matter's tree → ``navigate`` to
  //      ``/matter/<matterId>/D<docId>?page=N&q=...`` so the matter
  //      route can take over. Page-jump-on-initial-load via query
  //      params is a deliberate follow-on; for now the user lands on
  //      the right doc and can scroll, which is strictly better than
  //      the prior bug (citation opening the wrong tab entirely).
  useEffect(() => {
    return subscribeCitationJump((detail) => {
      if (!detail) return;
      const { shape, page, searchQuery, targetDocumentId, matterId } = detail;
      if (shape === "new") {
        if (!page || !targetDocumentId) return;
        const targetTabId = `D${targetDocumentId}`;
        if (activeTab && targetTabId === activeTab) {
          // Same document: land, confirm, then highlight (fenced to
          // the cited page). ``landOnCitation`` keeps re-asserting the
          // page for a short window if anything else moves it.
          const inst = webViewerInstances.getInstance(activeTab);
          landOnCitation(inst, { page, searchQuery });
          return;
        }
        // Another document has to open first. Register the landing so
        // the loader knows this open is citation-driven: it must skip
        // "restore the page you last had open" and land here instead.
        // The register is the source of truth; router state below is
        // kept for the chat-citation listeners that still read it.
        setPendingCitationLanding(targetDocumentId, { page, searchQuery });
        const docRecord = findDocumentById(treeData, targetTabId);
        if (docRecord && docRecord.relative_path) {
          // Same-matter cross-doc click. Pipe through the chat-style
          // highlight metadata so the existing post-doc-load listener
          // does the page-jump + search-highlight when the WebViewer
          // is ready. Always include ``page`` even when ``searchQuery``
          // is absent (e.g. legacy filename-resolved BE-link case
          // where the BE emits ``?page=N`` with no ``q=``); without
          // this the page would be silently dropped and the user
          // would land on page 1 of the correct document instead of
          // the cited page (Bugbot Medium #PR-106). The downstream
          // ``performTextHighlighting`` applies the page jump first,
          // independent of whether ``chunk_content`` is empty, so
          // page-only payloads still navigate correctly.
          const targetPath = buildPathWithAIPaneTab(
            `/matter${docRecord.relative_path}`,
            "analysis"
          );
          navigate(targetPath, {
            state: {
              highlightMetadata: [
                // ``documentId`` lets the location-keyed listeners
                // below refuse to act on a tab that is not this
                // document (they used to fire against whichever tab
                // happened to be active at click time).
                { page, chunk_content: searchQuery || "", documentId: targetDocumentId },
              ],
            },
          });
          return;
        }
        // Cross-matter (or doc not in the current tree). Navigate to
        // the matter URL so the matter route can take over loading
        // the doc. Page-jump query params are intentionally part of
        // the URL so a future enhancement can pick them up on initial
        // mount without changing this dispatcher.
        //
        // Preserve ``?ai=analysis`` alongside ``page`` / ``q`` so the
        // AI panel stays open on the new matter (was previously
        // dropped, which made the Brief disappear immediately when a
        // user clicked an evidence link that resolved to a different
        // matter — see "Brief disappears on cross-document
        // navigation" regression).
        if (matterId) {
          // Build the destination URL through the shared helper so the
          // AI tab (?ai=analysis) is preserved across the cross-doc
          // navigation. Without this, the new doc loads with no ?ai=
          // param, AIPane re-defaults to its briefing tab, and the
          // Brief the user just clicked from "disappears". Helper is
          // pure + unit-tested in citationJump.test.js.
          const target = buildCrossDocumentCitationPath({
            matterId,
            targetDocumentId,
            page,
            searchQuery,
          });
          if (target) navigate(target);
        }
        return;
      }
      // Legacy path: AI panel is bound to active doc, jump page only.
      if (!page || !activeTab) return;
      const inst = webViewerInstances.getInstance(activeTab);
      landOnCitation(inst, { page });
    });
  }, [activeTab, webViewerInstances, treeData, navigate]);

  const [editingKey, setEditingKey] = useState("");
  const [editingValue, setEditingValue] = useState("");
  const [sort, setSort] = useState("asc");
  const [sortBy, setSortBy] = useState("name");
  const [selectedDoc, setSelectedDoc] = useState(null)
  const [reviewers, setReviewers] = useState([]);
  const [remindInProgressIds, setRemindInProgressIds] = useState([]);
  const [remindStatusModal, setRemindStatusModal] = useState(null);
  const [remindStatusDrawer, setRemindStatusDrawer] = useState(null);
  const [openReviewNotes, setOpenReviewNotes] = useState(false);
  const [openESignModal, setOpenESignModal] = useState(false);
  const [showSignatureLauncher, setShowSignatureLauncher] = useState(false);
  const [attorneySignatureDoc, setAttorneySignatureDoc] = useState(null);
  const [eSignStartWithBoxes, setESignStartWithBoxes] = useState(false);
  const [showSendToVAModal, setShowSendToVAModal] = useState(false);
  const [showExternalShareModal, setShowExternalShareModal] = useState(false)
  // Sharing folders with an outside doctor through the portal. Distinct
  // from the external share above, which mints a public link to one
  // document: this is a named person signing in with a passkey.
  const [showExpertShareModal, setShowExpertShareModal] = useState(false)
  // Bumped when the share screen closes, so the badge reflects a share
  // that was just made or stopped without waiting for a page reload.
  const [expertShareVersion, setExpertShareVersion] = useState(0)
  const expertShare = useMatterShareSummary(id, expertShareVersion)
  const [showSendMessageModal, setShowSendMessageModal] = useState(false)
  const [briefBankModalOpen, setBriefBankModalOpen] = useState(false);
  const [showAddLetterheadModal, setShowAddLetterheadModal] = useState(false);
  const [draggedTabId, setDraggedTabId] = useState(null);
  const [dragOverTabId, setDragOverTabId] = useState(null);
  const [confirmOverwrite, setConfirmOverwrite] = useState(false);
  const [folderConflictOption, setFolderConflictOption] = useState("replace");
  const [pendingUpload, setPendingUpload] = useState(null);
  const [hoveredTab, setHoveredTab] = useState(null);
  const [deleteFolderId, setDeleteFolderId] = useState(null);
  
  // Expose checkTabLimit function to parent (MatterDetails) via ref and globally for notifications
  // Always returns false (no limit checking)
  useEffect(() => {
    const checkTabLimitFn = () => {
      return false; // No limit - always allow
    };
    
    if (checkTabLimitRef) {
      checkTabLimitRef.current = checkTabLimitFn;
    }
    
    // Also store globally for notification clicks (only if we're on a matter page)
    if (id && typeof window !== 'undefined') {
      globalThis.window.__checkTabLimit = checkTabLimitFn;
    }
    
    // Cleanup on unmount
    return () => {
      if (typeof window !== 'undefined') {
        delete globalThis.window.__checkTabLimit;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, id]);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);
  const [modalFolderHeader,setModalFolderHeader] = useState(null)
  const [isModalOpen,setIsModalOpen] = useState(false);
  const [selectedFile,setSelectedFile] = useState(null)
  // Records pre-seeded into the merge flow by the table's "Merge selected"
  // bar (null when the merge modal is opened from a single row's menu).
  const [mergeSeedFiles, setMergeSeedFiles] = useState(null);
  const [generatePackageOpen, setGeneratePackageOpen] = useState(false);
  const [matterPackages, setMatterPackages] = useState([]);
  const [matterPackagesLoading, setMatterPackagesLoading] = useState(false);
  const [packageGenerating, setPackageGenerating] = useState(false);
  const [packagePreviewing, setPackagePreviewing] = useState(false);
  const [packageMergeResult, setPackageMergeResult] = useState(null);
  const [packageActionBusy, setPackageActionBusy] = useState(false);
  const [autoSave, setAutoSave] = useState(null);
  // Export-as-PDF + page-builder navigation (shares the merge flow's
  // matter/folder identity rules; renders its own floating progress).
  const pdfTools = usePdfTools({
    navigate,
    matterUrlId: id,
    listContext: { page: currentPage, sort_direction: sort, sort_by: sortBy },
  });
  
  // Ref to store childDocIds at the time the folder-delete modal is shown
  // (treeData may no longer contain the deleted folder when OK is clicked)
  const childDocIdsRef = React.useRef([]);
  // Cleanup function for navigation (dispose all instances)
  const cleanupAllInstances = useCallback(async () => {
    console.log('🧹 [CLEANUP] Starting comprehensive cleanup...');
    
    // Use the hook's disposeAllInstances method for efficient cleanup
    await webViewerInstances.disposeAllInstances();
    
    // Clear all refs
    currentDocumentIdRef.current = null;
    loadingDocumentRef.current = null;
    firstLoadRef.current.clear();
    lockedDocsRef.current.clear();
    pageChangeListenerRef.current = null;
    if (annotationChangeDebounceRef.current?.timerId) clearTimeout(annotationChangeDebounceRef.current.timerId);
    annotationChangeDebounceRef.current = { timerId: null, documentId: null };
    annotationListenerRef.current = null;
    pagesUpdatedListenerRef.current = null;
    if (insertBatchRef.current?.timerId) clearTimeout(insertBatchRef.current.timerId);
    insertBatchRef.current = { timerId: null, pages: [], documentId: null };
    if (reorderBatchRef.current?.timerId) clearTimeout(reorderBatchRef.current.timerId);
    reorderBatchRef.current = { timerId: null, moves: [], documentId: null };
    if (removeBatchRef.current?.timerId) clearTimeout(removeBatchRef.current.timerId);
    removeBatchRef.current = { timerId: null, pages: [], documentId: null };
    bookmarkListenerRef.current = null;
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
      autoSaveTimerRef.current = null;
    }
    
    // Force garbage collection hint (if available - Chrome DevTools with --js-flags="--expose-gc")
    if (globalThis.window.gc) {
      try {
        globalThis.window.gc();
        console.log('💡 [CLEANUP] Garbage collection triggered');
      } catch (e) {
        // GC not available or not allowed
      }
    }
    
    console.log('✅ [CLEANUP] Cleanup complete - all instances disposed and memory cleared');
  }, [webViewerInstances]);
  
  // Expose cleanup function via ref to parent (MatterDetails) for navigation cleanup
  useEffect(() => {
    if (cleanupDocumentRef) {
      cleanupDocumentRef.current = cleanupAllInstances;
    }
  }, [cleanupAllInstances, cleanupDocumentRef]);
  
  
  // Track firstLoad per document for autosave
  const firstLoadRef = useRef(new Map()); // Map<documentId, boolean>
  const lockedDocsRef = useRef(new Set()); // Track which documents are locked by current user
  const autoSaveTimerRef = useRef(null);
  const bookmarkFetchCacheRef = useRef(new Map()); // Map<docId, { data: object|null, fetchedAt: number }>
  const inFlightBookmarkFetchRef = useRef(new Map()); // Map<docId, Promise<object|null>>
  const lastSavedBookmarksRef = useRef(new Map()); // Map<docId, string>
  const inFlightBookmarksSaveRef = useRef(new Map()); // Map<docId, string>
  const latestDocumentDetailRef = useRef(documentDetail);

  useEffect(() => {
    latestDocumentDetailRef.current = documentDetail;
  }, [documentDetail]);

  // Show all tabs (up to 10) - they will shrink automatically like browser tabs
  // Filter out collapse button (id "0") from scrollable tabs - it will be rendered separately as fixed
  const collapseButtonTab = tabs.find(tab => tab.id === "0");
  const visibleTabs = tabs.filter(tab => tab.id !== "0"); // Exclude collapse button from scrollable tabs

  const getBookmarkFromPayload = useCallback((bookmarksPayload) => {
    return (
      bookmarksPayload?.bookmarks?.[0] ??
      (bookmarksPayload && typeof bookmarksPayload === "object" && !Array.isArray(bookmarksPayload)
        ? bookmarksPayload
        : null)
    );
  }, []);

  const addBookmarksCache = useCallback((result, fallbackDocumentId) => {
    if (!result || result.type !== "getDocumentDetails/fetch/fulfilled") return null;
    const details = result.payload?.data;
    const resolvedDocId = String(details?.id ?? fallbackDocumentId ?? "");
    if (!resolvedDocId) return null;
    const bookmarks = getBookmarkFromPayload(details?.bookmarks) || null;
    bookmarkFetchCacheRef.current.set(resolvedDocId, {
      data: bookmarks,
      fetchedAt: Date.now(),
    });
    return bookmarks;
  }, [getBookmarkFromPayload]);

  // Fetch bookmarks from latest document details by document id.
  // Uses short-lived cache + in-flight de-duplication to avoid API bursts.
  const fetchBookmarksAPI = useCallback(async (documentId) => {
    if (!documentId) return null;

    const docIdKey = String(documentId);
    const BOOKMARKS_CACHE_TTL_MS = 15000;
    const now = Date.now();

    const cached = bookmarkFetchCacheRef.current.get(docIdKey);
    if (cached && now - cached.fetchedAt < BOOKMARKS_CACHE_TTL_MS) {
      return cached.data;
    }

    const latestDetail = latestDocumentDetailRef.current;
    const latestDetailId = latestDetail?.id != null ? String(latestDetail.id) : null;
    if (latestDetailId === docIdKey) {
      const localBookmarks = getBookmarkFromPayload(latestDetail?.bookmarks) || null;
      bookmarkFetchCacheRef.current.set(docIdKey, { data: localBookmarks, fetchedAt: now });
      return localBookmarks;
    }

    const inFlightRequest = inFlightBookmarkFetchRef.current.get(docIdKey);
    if (inFlightRequest) {
      return inFlightRequest;
    }

    const requestPromise = (async () => {
      try {
        const result = await dispatch(getDocumentDetails(documentId));
        if (result.type === "getDocumentDetails/fetch/rejected") {
          return null;
        }
        const apiPayload = result.payload?.data?.bookmarks;
        const apiBookmarksObject = getBookmarkFromPayload(apiPayload) || null;
        bookmarkFetchCacheRef.current.set(docIdKey, {
          data: apiBookmarksObject,
          fetchedAt: Date.now(),
        });
        return apiBookmarksObject;
      } catch (err) {
        console.warn(`Failed to get bookmarks for ${documentId}:`, err);
        return null;
      } finally {
        inFlightBookmarkFetchRef.current.delete(docIdKey);
      }
    })();

    inFlightBookmarkFetchRef.current.set(docIdKey, requestPromise);

    try {
      return await requestPromise;
    } catch (err) {
      console.warn(`Failed to get bookmarks for ${documentId}:`, err);
      return null;
    }
  }, [getBookmarkFromPayload]);

  /**
   * Check if a tab already has a WebViewer instance with a loaded document
   * @param {string} tabId - The tab ID (e.g., "D123")
   * @returns {boolean} - true if tab has instance with loaded document, false otherwise
   */
  const hasTabInstanceWithDocument = useCallback((tabId) => {
    if (!tabId || !tabId.startsWith("D")) {
      return false; // Not a document tab
    }
    
    const instance = webViewerInstances.getInstance(tabId);
    if (!instance) {
      return false; // No instance exists
    }
    
    // Check if document is actually loaded in the instance
    const { documentViewer } = instance.Core;
    const currentDoc = documentViewer?.getDocument();
    
    return !!currentDoc; // Return true if document is loaded
  }, [webViewerInstances]);

  // Capture markdown_content for each tab as soon as Redux has it for the
  // active tab. Stored per tab.id so non-active tabs can still render
  // Formatted/Source correctly when the user returns to them.
  useEffect(() => {
    if (!activeTab || activeTab === "1" || activeTab === "0") return;
    if (!documentDetail?.markdown_content) return;
    const detailId = documentDetail?.id?.toString() || documentDetail?.unique_id?.substring(1);
    const tabDocumentId = activeTab.startsWith('D') ? activeTab.substring(1) : activeTab;
    if (detailId !== tabDocumentId) return;
    setMarkdownContentByTab(prev =>
      prev[activeTab] === documentDetail.markdown_content
        ? prev
        : { ...prev, [activeTab]: documentDetail.markdown_content }
    );
  }, [activeTab, documentDetail]);

  // Fetch extracted markdown via the dedicated endpoint
  // (`GET /api/documents/<id>/markdown/`, BE PR #504) when a document tab
  // becomes active and we don't already have its markdown cached. The
  // generic detail payload (`documentDetail`) deliberately omits
  // `markdown_content` because extracted markdown can be megabytes per
  // doc — the toggle is opt-in, so the bytes only land for tabs the user
  // actually opens. The sibling useEffect above remains the fast path for
  // any caller that has already populated markdown_content on Redux state.
  //
  // Tracking the per-tab fetch lifecycle in a ref (rather than a Set in
  // state, or a derived dep on `markdownContentByTab`) avoids re-firing
  // this effect every time some other tab's cache entry updates. On
  // success-with-empty-markdown (extraction still pending) we leave the
  // tab off the cache and clear it from the ref so reopening the tab
  // re-tries — that's the cheapest way to pick up extraction completion
  // without polling.
  const markdownFetchInFlightRef = useRef(new Set());
  useEffect(() => {
    if (!activeTab || !activeTab.startsWith("D")) return;
    if (markdownContentByTab[activeTab]) return;
    if (markdownFetchInFlightRef.current.has(activeTab)) return;

    const documentId = activeTab.substring(1);
    if (!documentId) return;

    markdownFetchInFlightRef.current.add(activeTab);
    let ignored = false;

    getDocumentMarkdown(documentId)
      .then(response => {
        if (ignored) return;
        if (!response || response.status === 404) {
          // 404 = soft-deleted / missing doc; toggle stays hidden by design.
          // Leave the tab in the in-flight set so we don't refetch repeatedly
          // for a tab that will never resolve.
          return;
        }
        const markdown = response.data?.markdown_content;
        if (!markdown) {
          // 200 with empty markdown_content = extraction still in progress
          // upstream. Clear the in-flight marker so reopening the tab
          // (e.g. tab switch back) refetches and picks up completion.
          markdownFetchInFlightRef.current.delete(activeTab);
          return;
        }
        setMarkdownContentByTab(prev =>
          prev[activeTab] === markdown
            ? prev
            : { ...prev, [activeTab]: markdown }
        );
      })
      .catch(err => {
        if (ignored) return;
        // Transient / non-2xx (other than 404) — log and allow retry on
        // next tab activation. The toggle stays hidden in the meantime.
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch markdown for ${activeTab}:`, err);
        markdownFetchInFlightRef.current.delete(activeTab);
      });

    return () => {
      ignored = true;
    };
  }, [activeTab, markdownContentByTab]);

  const addBookmarksAPI = useCallback(async (documentId, bookmarks) => {
    if (!documentId) return;
    const docIdKey = String(documentId);
    try {
      let payloadBookmarks = null;
      if (!bookmarks) {
        payloadBookmarks = [];
      } else if (Array.isArray(bookmarks)) {
        payloadBookmarks = bookmarks;
      } else if (typeof bookmarks === "object") {
        payloadBookmarks = [bookmarks];
      } else if (typeof bookmarks === "string") {
        try {
          const parsed = JSON.parse(bookmarks);
          payloadBookmarks = Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
          payloadBookmarks = [];
      }
    } else {
        payloadBookmarks = [];
      }

      const serializedPayload = JSON.stringify(payloadBookmarks);
      const lastSavedPayload = lastSavedBookmarksRef.current.get(docIdKey);
      const inFlightPayload = inFlightBookmarksSaveRef.current.get(docIdKey);
      if (serializedPayload === lastSavedPayload || serializedPayload === inFlightPayload) {
        return;
      }

      inFlightBookmarksSaveRef.current.set(docIdKey, serializedPayload);
      await dispatch(addBookmarks({ doc_id: documentId, bookmarks: payloadBookmarks })).unwrap();
      lastSavedBookmarksRef.current.set(docIdKey, serializedPayload);
      const cachedBookmarksObject =
        payloadBookmarks?.[0] && typeof payloadBookmarks[0] === "object" ? payloadBookmarks[0] : null;
      bookmarkFetchCacheRef.current.set(docIdKey, {
        data: cachedBookmarksObject,
        fetchedAt: Date.now(),
      });
      console.log(`Bookmarks synced to API for document ${documentId}`);
    } catch (err) {
      console.warn(`Bookmarks added failed for ${documentId}:`, err);
      // LOUD failure (Matthew, 2026-07-21): bookmark saves 400'd
      // silently for two weeks after the UUID id migration — the only
      // trace was this console line, and users' bookmarks vanished on
      // reopen. A failed save must never look like a successful one.
      dispatch(
        addNotification({
          id: `bookmark-save-failed-${docIdKey}-${Date.now()}`,
          newMsg:
            "Bookmarks could not be saved. Your bookmark changes are NOT stored — copy them down and retry, or contact support.",
          success: false,
        })
      );
      // Rethrow so callers (persistBookmarks in useDocumentLoader)
      // don't fire their success toast on top of this failure.
      throw err;
    } finally {
      inFlightBookmarksSaveRef.current.delete(docIdKey);
    }
  }, [dispatch]);

  // Handle drop in visible tab area
const handleVisibleTabDrop = (e, targetIndex) => {
  e.preventDefault();
  const data = JSON.parse(e.dataTransfer.getData('text/plain'));
  // Updated logic without dropdown - all tabs are visible
  const { newTabs, activeTabId } = handleVisibleTabDropLogic({
    data,
    dropdownTabs: [], // No dropdown tabs anymore
    visibleTabs: tabs,
    targetIndex,
  });
  if (!newTabs) return; // No change needed
  setTabs(newTabs);
  setActiveTab(activeTabId);
};

  // Updated tab item props
const getTabItemProps = (tab, index) => ({
  showSideBar,
  tabbackground: getTabBackground(activeTab, tab.id),
  borderbottom: activeTab === tab.id ? "true" : "",
  collapsebtn: tab.id === "0" ? "true" : "",
  // `$isActive` is a styled-components transient prop read by `TabItem`
  // to gate the 2px brand "you are here" top bar. Using the transient
  // form (`$`-prefixed) keeps the prop from leaking onto the underlying
  // DOM `<div>`, which would emit a React "unknown DOM attribute"
  // warning for every rendered tab.
  $isActive: activeTab === tab.id,
  onClick: () => onTabClick(tab),
  draggable: tab.id !== "0" && tab.id !== "1",
  onDragStart: (e) => handleTabDragStart(e, tab.id, setDraggedTabId),
  onDragOver: (e) => {
    e.preventDefault();
    handleTabDragOver(e, tab.id, setDragOverTabId);
  },
  onDragEnter: (e) => handleTabDragEnter(e, tab.id, setDragOverTabId),
  onDragLeave: (e) => handleTabDragLeave(e, tab.id, dragOverTabId, setDragOverTabId),
  onDrop: (e) => {
    handleTabDrop(e, tab.id);
    handleVisibleTabDrop(e, index);
  },
  onDragEnd: handleTabDragEnd,
  onMouseEnter: () => setHoveredTab(tab.id),
  onMouseLeave: () => setHoveredTab(null),
  style: {
    cursor: tab.id !== "0" && tab.id !== "1" ? "pointer" : "default",
    opacity: draggedTabId === tab.id ? 0.5 : 1,
    borderLeft: dragOverTabId === tab.id && draggedTabId !== tab.id ? "3px solid #0C53BB" : "1px solid #dde2e9",
    transform: draggedTabId === tab.id ? "rotate(5deg)" : "none",
    transition: "all 0.2s ease"
  }
});

  const emptyTable = matterDetailsList?.length === 0;
  // Single modal state for all message modals
  const [messageModal, setMessageModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    buttonText: "Close",
    icon: null,
    variant: "confirmation",
    onClose: () => {},
    onClick: () => {}
  });

  const { uploads, addUpload, addUploadAbortController, updateUpload, removeUpload, cancelUpload, addFailedUpload, markUploadCompleted, clearCompletedUploadIds, isUploadCancelled } = useUploadNotification();
  const { uploadFile, uploadFileToSignedUrl } = useCancellableUpload();
  const completedUploadsKey = useMemo(
    () => (uploads || []).filter((upload) => upload.status === 'completed').map((upload) => upload.id).join(','),
    [uploads]
  );
  // ``navigate`` is declared near the top of the component (right after
  // ``useParams``) so that earlier useEffects can list it in their dep
  // arrays without hitting a TDZ ReferenceError on render.
  const runningAnalysisDocIds = useSelector(selectRunningAnalysisDocIds);

  // ----- Categorization gold-standard library (PR #512) -----
  // Right-click "Add to gold standard library" + "Report incorrect
  // categorization…" on every matter document row. Badge rendering reads
  // the same slice. Pre-fetched once per matter so the table never has
  // to wait on N×2 round-trips at render time.
  const { isAdmin, hasCapability } = useAuth();
  // Gold Standard library additions are Matthew-only (2026-08-05 access
  // control rollout). Everyone else's "Categorize…" row action still
  // works — it just opens the recategorize surface instead of the
  // gold-standard one, same distinction DocumentContextMenu draws.
  const canUseGoldStandard = hasCapability("ai.gold_standard");
  const canPlaceAttorneySignature = hasCapability("esign.attorney_signature");
  const visibleDocIds = useMemo(() => {
    if (!Array.isArray(matterDetailsList)) return [];
    const seen = new Set();
    matterDetailsList.forEach((row) => {
      if (!row || row.type !== "document") return;
      const rawId = row.id ?? row.document_id ?? row.documentId;
      if (rawId == null) return;
      seen.add(String(rawId));
    });
    return Array.from(seen);
  }, [matterDetailsList]);
  const categorizationFlags = useSelector((state) =>
    selectCategorizationFlagsForDocuments(state, visibleDocIds)
  );
  const categorizationCategoriesStatus = useSelector(selectCategoriesStatus);
  const [categorizeModalState, setCategorizeModalState] = useState({
    open: false,
    documentId: null,
    documentName: "",
    inferredCategory: "",
  });
  const categorizeGoldStandard = useSelector((state) =>
    selectGoldStandardForDocument(state, categorizeModalState.documentId)
  );

  useEffect(() => {
    if (!visibleDocIds.length) return;
    dispatch(fetchCategorizationForDocuments(visibleDocIds));
  }, [dispatch, visibleDocIds]);

  useEffect(() => {
    if (categorizationCategoriesStatus === "idle") {
      dispatch(fetchCategorizationCategories());
    }
  }, [dispatch, categorizationCategoriesStatus]);

  const handleCategorize = useCallback((record) => {
    if (!record) return;
    const rawDocId =
      record.id ?? record.document_id ?? record.documentId ?? null;
    if (rawDocId == null) return;
    setCategorizeModalState({
      open: true,
      documentId: String(rawDocId),
      documentName: record.name || "",
      inferredCategory: record.doc_category || record.category || "",
    });
  }, []);

  const handleCloseCategorize = useCallback(() => {
    setCategorizeModalState((prev) => ({ ...prev, open: false }));
  }, []);

  const docIdFromUrlState = location?.state?.document?.id;
  const urlIds = location.pathname.split("/matter/")[1].split("/");
  const folderId = selectedKeys[0]
  const currentFolder = getFolderNameById(folderId, breadcrumb);
  const [VAFormData, setVAFormData] = useState({});

  // Matter home (Matthew, 2026-07-22): at the MATTER ROOT the middle window
  // shows the dashboard (identity, AI readiness, recent docs, upload)
  // instead of the root folder table. Navigating into a folder (tree click
  // or "Browse the full folder listing") still shows the classic table, so
  // every table row action stays reachable while we iterate on the
  // dashboard. State resets to the dashboard per matter.
  const atMatterRoot = urlIds.length === 1 && urlIds[0] !== "";
  const [rootView, setRootView] = useState("dashboard");
  const [dashDropActive, setDashDropActive] = useState(false);
  useEffect(() => {
    setRootView("dashboard");
  }, [id]);
  const showMatterDashboard = atMatterRoot && rootView === "dashboard";
  const matterPackageFolderOptions = useMemo(
    () => flattenMatterFolderOptions(treeData),
    [treeData]
  );

  // Plain function on purpose: openTab is declared further down the
  // component body; recreating this per render keeps it current.
  const openDocumentFromDashboard = (doc) => {
    if (!doc?.unique_id) return;
    const pdfRecord = {
      type: "document",
      record: doc,
      file_type: doc.file_type,
      unique_id: doc.unique_id,
      name: doc.name,
      ...doc,
    };
    openTab(pdfRecord, false);
    setActiveTab(String(doc.unique_id));
    if (doc.relative_path) {
      navigate(
        appendAIPaneTo(`/matter${doc.relative_path}`, location.search)
      );
    }
  };

  // PR A — when the user clicks a row in the My Reviews / Shared for Review
  // tabs, HomeUtils.getRowProps tags the navigation state with
  // `autoOpenReviewNotes: true`. We watch for that flag together with a
  // loaded `documentDetail` and the `is_review_notes_available` server
  // signal; when all three line up, we pop the chronological comment
  // thread automatically rather than making the reviewer hunt for it
  // in the More menu. We also clear the navigation state via
  // history.replace so a back-navigation or refresh doesn't re-trigger
  // the modal in a confusing loop.
  useEffect(() => {
    const navState = location?.state;
    if (!navState?.autoOpenReviewNotes) return;
    if (openReviewNotes) return;
    if (!documentDetail?.id) return;

    // Only honor the auto-open if the loaded doc is the one the URL is
    // pointing at — otherwise we'd attach the modal to a stale doc.
    const lastSegment = urlIds?.at?.(-1);
    const docIdFromUrl = typeof lastSegment === "string" && lastSegment.startsWith("D")
      ? lastSegment.substring(1)
      : null;
    if (!docIdFromUrl) return;
    if (String(documentDetail.id) !== docIdFromUrl) return;

    const clearAutoOpenState = () => {
      navigate(`${location.pathname}${location.search || ""}`, {
        replace: true,
        state: {},
      });
    };

    if (!documentDetail.is_review_notes_available) {
      // The reviewer arrived expecting a thread but the server has no
      // history for this doc — silently clear the flag so it doesn't
      // ride along on subsequent in-app navigation.
      clearAutoOpenState();
      return;
    }

    setSelectedDoc(documentDetail);
    setOpenReviewNotes(true);
    clearAutoOpenState();
    // urlIds is omitted from the deps because it's derived synchronously
    // from location.pathname on every render — a fresh array reference
    // each time would re-run this effect endlessly. Watching pathname
    // is the correct lever.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location?.state,
    location?.pathname,
    location?.search,
    documentDetail?.id,
    documentDetail?.is_review_notes_available,
    openReviewNotes,
    navigate,
  ]);

  // Function to save tab 1 selection state
  const saveTab1Selection = useCallback((selection) => {
    tab1SelectionRef.current = selection;
  }, []);
  // Function to restore tab 1 selection state
  const restoreTab1Selection = useCallback(() => {
    setSelectedRowKeys(tab1SelectionRef.current);
  }, []);

  const showAutoSaveIndicator = useCallback((documentName) => {
    const resolvedName = documentName || documentDetail?.name || "Document";
    setAutoSave(`Saved to ${resolvedName}`);
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
    }
    // Hide only after user is idle for 5s
    autoSaveTimerRef.current = setTimeout(() => {
      setAutoSave(null);
      autoSaveTimerRef.current = null;
    }, 5000);
  }, [documentDetail?.name]);

  const handleAutoSaveStart = useCallback(() => setAutoSave("Saving..."), []);

  const handleAutoSaveSuccess = useCallback((documentName, response) => {
    showAutoSaveIndicator(documentName);
    const savedDocument = response?.data?.document;
    if (savedDocument) dispatch(setUpdateMeta(savedDocument));
  }, [dispatch, showAutoSaveIndicator]);

  const handleAutoSaveError = useCallback((error, documentName) => {
    console.error("Auto-save failed:", error);
    setAutoSave(null);
    // LOUD failure, same rule as bookmarks above: a failed save must never
    // look like a successful one. Silence here is exactly how typed form
    // values were lost while the banner read "Saved to <name>".
    dispatch(
      addNotification({
        id: `autosave-failed-${Date.now()}`,
        newMsg: `"${documentName || "Document"}" could NOT be saved. Your recent edits are not stored — keep this tab open and retry, or contact support.`,
        success: false,
      })
    );
  }, [dispatch]);

  const { scheduleAutoSave, flushAutoSave, settleAutoSave } = useDocumentAutoSave({
    onSaveStart: handleAutoSaveStart,
    onSaveSuccess: handleAutoSaveSuccess,
    onSaveError: handleAutoSaveError,
  });

  useEffect(() => {
    return registerDocumentReplacePreparer(async (documentId) => {
      replacingDocumentIdsRef.current.add(documentId);
      await settleAutoSave();
    });
  }, [settleAutoSave]);

  // AutoSave handler: queues a debounced export+upload of the open PDF.
  const handleAutoSave = useCallback((documentViewer, annotationManager, status, documentId, documentName) => {
    if (!documentViewer?.getDocument() || !documentId) return;
    // Gates preserved from the previous indicator-only implementation:
    // firstLoad is set in onDocumentLoaded, so edits dispatched during
    // initial document setup never trigger an upload.
    if (openESignModal || !status) return;
    if (replacingDocumentIdsRef.current.has(String(documentId))) return;
    if (firstLoadRef.current.get(documentId) !== true) return;

    scheduleAutoSave({ documentViewer, annotationManager, documentId, documentName });
  }, [openESignModal, scheduleAutoSave]);

  useEffect(() => {
  if (deleteDocuId?.startsWith("D")) {
    if (deleteDocuId === activeTab) {
      closeTab(deleteDocuId, true);
    } else {
      closeTabsByIds(tabs, setTabs, [deleteDocuId]);
    }
    dispatch(fetchMatterDetail(urlIds[0]));
    const listPage = Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;
    const lastSegment = urlIds.at(-1);
    if (urlIds.length > 1 && typeof lastSegment === "string" && lastSegment.startsWith("F")) {
      dispatch(fetchMatterDetailList({ id: urlIds[0], page: listPage, folder: lastSegment }));
    } else {
      dispatch(fetchMatterDetailList({ id: urlIds[0], page: listPage }));
    }
  }else{
    deleteDocFunc({
      deleteDocuId,
      dispatch,
      setDeleteDoc,
      setDeleteFolderId,
      setModalFolderHeader,
      setModalMessage,
      setShowFolderModal,
      getAllChildDocumentIdsByFolderId,
      treeData,
      activeTab,
      location,
      tabs,
      onChildDocIdsReady: (ids) => { childDocIdsRef.current = ids; },
    })
  }

   
  }, [deleteDocuId]);

  const handleFolderModalConfirm = () =>{
    const listPage = Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;
    const folderBeingDeleted = deleteFolderId;
    const childDocIds = childDocIdsRef.current.length > 0
      ? childDocIdsRef.current
      : getAllChildDocumentIdsByFolderId(treeData, folderBeingDeleted);
    // Clear modal state
    setShowFolderModal(false);
    setDeleteFolderId(null);
    setModalMessage(null);
    setModalFolderHeader(null);
    childDocIdsRef.current = [];
  
    if (!folderBeingDeleted) return;
  
    const segments = location.pathname.split("/matter/")[1].split("/").filter(Boolean);
    const matterId = segments[0];
  
    if (activeTab === "1") {
      // User was directly inside the deleted folder → redirect to matter root
      closeTabsByIds(tabs, setTabs, childDocIds);
      navigateWithChatbox(navigate, location, `/matter/${matterId}`);
    } else if (childDocIds.includes(activeTab)) {
      // User has a file/subfolder from inside the deleted folder open as active tab
      localStorage.setItem("relativePath", `/${matterId}`);
      closeTabsByIds(tabs, setTabs, childDocIds);
      navigateWithChatbox(navigate, location, `/matter/${matterId}`);
    } else {
      // User is on an unaffected tab — just close any background tabs from the deleted folder
      closeTabsByIds(tabs, setTabs, childDocIds);
    }
  
    dispatch(fetchMatterDetail(urlIds[0]));
    dispatch(fetchMatterDetailList({id: urlIds[0],page: listPage}));
  }

  // Effect to save selection when it changes and we're on tab 1
  useEffect(() => {
    if (activeTab === "1") {
      saveTab1Selection(selectedRowKeys);
    }
  }, [selectedRowKeys, activeTab, saveTab1Selection]);

  const openReviewActionModal = (type) => {
    setSelectedForwardRecipients([]);
    setReviewActionType(type); // approve / rework / submit
    setShowReviewActionModal(true);
  };

  useEffect(() => {
    if (reviewActionType !== "approve_forward" || !selectedDoc) {
      return;
    }
    const rawId =
      selectedDoc?.unique_id || selectedDoc?.id || selectedDoc?.document_id;
    const docId =
      typeof rawId === "string" && rawId.startsWith("D")
        ? rawId.substring(1)
        : rawId;
    if (!docId) return;

    dispatch(getShareRecipients({ docId })).then((response) => {
      const starterId =
        shareContext?.review_assignment_context?.chain?.started_by_id
        || shareContext?.review_assignment_context?.assigned_by?.user_id;
      const users = (response?.payload?.data?.users || [])
        .filter((user) => String(user.id) !== String(starterId))
        .map((user) => ({ ...user, already_added: false }));
      setForwardRecipientOptions(users);
    });
  }, [
    dispatch,
    reviewActionType,
    selectedDoc,
    shareContext?.review_assignment_context?.chain?.started_by_id,
    shareContext?.review_assignment_context?.assigned_by?.user_id,
  ]);

  const handleUpload = (files, targetId, folderNames = [], { aiProcess = false } = {}) => {
    if (Array.isArray(folderNames) && folderNames.length > 0) {
      // Folder upload
      const { conflictNames, conflictIds, siblingFolderNames } =
        getFolderConflictInfo(treeData, targetId, folderNames);

      if (conflictIds.length > 0) {
        openConflictModal(setPendingUpload, setFolderConflictOption, setConfirmOverwrite, "folder", {
          files,
          folderNames,
          targetId,
          conflictNames,
          siblingFolders: siblingFolderNames,
          conflictIds,
          aiProcess,
        });
        return;
      }

      handleProcessFiles(files, targetId, undefined, { aiProcess });
    } else {
      // File upload
      const fileConflicts = checkFileConflicts(treeData, targetId, files);

      if (fileConflicts.length > 0) {
        openConflictModal(setPendingUpload, setFolderConflictOption, setConfirmOverwrite, "file", {
          files,
          targetId,
          conflictNames: fileConflicts.map((conflict) => conflict.name),
          conflictIds: fileConflicts.map((conflict) => conflict.id),
          aiProcess,
        });
        return;
      }
      handleProcessFiles(files, targetId, undefined, { aiProcess });
    }
  };

  const handleSnackbar = createHandleSnackbar(
    setdrawerError,
    setShowNotification,
  );

  // Opens the send window for a document picked or generated in the
  // Send Doc for E-Signature window.
  const openSendForSignature = (document, { placeBoxes = false } = {}) => {
    if (!document?.id) return;
    setSelectedDoc({
      ...document,
      unique_id: document.unique_id || `D${document.id}`,
    });
    setESignStartWithBoxes(Boolean(placeBoxes));
    setOpenESignModal(true);
  };

  const handleRefreshSharePointDocument = useCallback(async (documentRecord, tabId) => {
    const documentId =
      documentRecord?.id ||
      (documentRecord?.unique_id ? documentRecord.unique_id.substring(1) : null);
    if (!documentId) {
      handleSnackbar("Unable to refresh this document. Missing document id.");
      return;
    }

    setRefreshingSharePointDocumentId(documentId);
    try {
      const startedAt = Date.now();
      let response = null;
      while (Date.now() - startedAt <= SHAREPOINT_REFRESH_MAX_WAIT_MS) {
        response = await refreshSharePointDocumentChanges(documentId);
        if (response?.data?.changed) {
          break;
        }
        const elapsedMs = Date.now() - startedAt;
        const remainingMs = SHAREPOINT_REFRESH_MAX_WAIT_MS - elapsedMs;
        if (remainingMs <= 0) {
          break;
        }
        await wait(Math.min(SHAREPOINT_REFRESH_POLL_MS, remainingMs));
      }

      if (!response?.data?.changed) {
        antdMessage.info(
          "Word is still saving your changes. Please refresh again in a moment."
        );
        return;
      }

      const refreshedDocument = response?.data?.document;
      if (!refreshedDocument) {
        throw new Error("Refresh response did not include the document.");
      }

      const mergedDocument = {
        ...(webViewerInstances.getTabDocumentData(tabId) || {}),
        ...documentRecord,
        ...refreshedDocument,
      };

      webViewerInstances.updateTabDocumentData(tabId, mergedDocument);
      dispatch(setUpdateMeta(mergedDocument));
      dispatch(updateDocumentDetail(mergedDocument));
      setTabs((currentTabs) =>
        currentTabs.map((tab) =>
          tab.id === tabId
            ? { ...tab, title: mergedDocument.name || tab.title, documentRecord: mergedDocument }
            : tab
        )
      );

      const instance = webViewerInstances.getInstance(tabId);
      if (instance && activeTab === tabId) {
        try {
          await instance.Core?.documentViewer?.closeDocument?.();
        } catch (closeError) {
          console.warn("Failed to close document before refresh reload", closeError);
        }
        await documentLoader.loadDocument(instance, mergedDocument, {
          tabId,
          resolvedUrlPromise: documentLoader
            .resolveDocumentUrl(mergedDocument)
            .then(cacheBustDocumentUrlResult)
            .catch(() => null),
        });
      }

      handleSnackbar(
        "Latest changes updated.",
        true
      );
    } catch (error) {
      console.error("Failed to refresh SharePoint document changes", error);
      handleSnackbar(
        error?.response?.data?.detail ||
          error?.message ||
          "Failed to refresh document changes."
      );
    } finally {
      setRefreshingSharePointDocumentId(null);
    }
  }, [
    activeTab,
    dispatch,
    documentLoader,
    handleSnackbar,
    webViewerInstances,
  ]);

  // After a version revert the file behind the open tab has changed, so
  // swap in the server's fresh record and reload the viewer on it.
  const handleVersionRestored = useCallback(async (restoreResponse) => {
    const target = versionHistoryTarget;
    const restoredDocument = restoreResponse?.document;
    if (!target || !restoredDocument) return;
    const { tabId, documentRecord } = target;

    const mergedDocument = {
      ...(webViewerInstances.getTabDocumentData(tabId) || {}),
      ...documentRecord,
      ...restoredDocument,
    };

    webViewerInstances.updateTabDocumentData(tabId, mergedDocument);
    dispatch(setUpdateMeta(mergedDocument));
    dispatch(updateDocumentDetail(mergedDocument));
    setTabs((currentTabs) =>
      currentTabs.map((tab) =>
        tab.id === tabId
          ? { ...tab, title: mergedDocument.name || tab.title, documentRecord: mergedDocument }
          : tab
      )
    );

    const instance = webViewerInstances.getInstance(tabId);
    if (instance && activeTab === tabId) {
      try {
        await instance.Core?.documentViewer?.closeDocument?.();
      } catch (closeError) {
        console.warn("Failed to close document before version reload", closeError);
      }
      await documentLoader.loadDocument(instance, mergedDocument, {
        tabId,
        resolvedUrlPromise: documentLoader
          .resolveDocumentUrl(mergedDocument)
          .then(cacheBustDocumentUrlResult)
          .catch(() => null),
      });
    }

    handleSnackbar(
      restoreResponse?.detail || "Earlier version restored.",
      true
    );
  }, [
    activeTab,
    dispatch,
    documentLoader,
    handleSnackbar,
    versionHistoryTarget,
    webViewerInstances,
  ]);

  const currentListFolderParam = useCallback(() => {
    const lastSegment = urlIds.at(-1);
    if (urlIds.length > 1 && typeof lastSegment === "string" && lastSegment.startsWith("F")) {
      return lastSegment;
    }
    return null;
  }, [urlIds]);

  const refreshMatterDocuments = useCallback(() => {
    const listPage = Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;
    const folder = currentListFolderParam();
    dispatch(fetchMatterDetail(id));
    dispatch(fetchMatterDetailList({
      id,
      page: listPage,
      sort_direction: sort,
      sort_by: sortBy,
      ...(folder ? { folder } : {}),
    }));
  }, [currentListFolderParam, currentPage, dispatch, id, sort, sortBy]);

  const handleCopyRecords = useCallback(
    (records) => {
      const items = clipboardItemsFromRecords(records);
      if (!items.length) return;
      dispatch(copyDocumentsToClipboard({ items, sourceMatterId: id }));
      dispatch(
        addNotification({
          id: `${Date.now()}-copy`,
          newMsg: copySuccessMessage(items),
          success: true,
        })
      );
    },
    [dispatch, id]
  );

  const handleCopyClipboardItems = useCallback(
    (items) => {
      if (!items?.length) return;
      dispatch(copyDocumentsToClipboard({ items, sourceMatterId: id }));
      dispatch(
        addNotification({
          id: `${Date.now()}-copy`,
          newMsg: copySuccessMessage(items),
          success: true,
        })
      );
    },
    [dispatch, id]
  );

  const handlePasteDocuments = useCallback(
    (targetFolderId, destinationName) => {
      if (pastingClipboard || !clipboardItems.length || !id) return;
      setPastingClipboard(true);
      copyDocumentsApi({
        documentIds: clipboardItems.map((item) => item.id),
        targetMatterId: id,
        targetFolderId: targetFolderId ?? null,
      })
        .then((response) => {
          const payload = response?.data || {};
          dispatch(
            addNotification({
              id: `${Date.now()}-paste`,
              newMsg: formatPasteNote({
                copied: payload.copied || 0,
                failed: payload.failed || 0,
                results: payload.results || [],
                destinationName,
              }),
              success: (payload.failed || 0) === 0,
            })
          );
          refreshMatterDocuments();
        })
        .catch((err) => {
          dispatch(
            addNotification({
              id: `${Date.now()}-paste-error`,
              newMsg: extractCopyApiError(err, "Paste failed"),
              success: false,
            })
          );
        })
        .finally(() => setPastingClipboard(false));
    },
    [clipboardItems, dispatch, id, pastingClipboard, refreshMatterDocuments]
  );

  const pasteDestinationName = atMatterRoot
    ? "this matter"
    : currentFolder || "this folder";

  const handlePasteHere = useCallback(() => {
    handlePasteDocuments(
      stripFolderPrefix(currentListFolderParam()),
      pasteDestinationName
    );
  }, [currentListFolderParam, handlePasteDocuments, pasteDestinationName]);

  const handlePasteIntoFolder = useCallback(
    (folderRecord) => {
      handlePasteDocuments(
        folderIdForPaste(folderRecord),
        folderRecord?.name || "this folder"
      );
    },
    [handlePasteDocuments]
  );

  useEffect(() => {
    const onKeyDown = (event) => {
      if (!(event.ctrlKey || event.metaKey) || event.altKey) return;
      if (isTypingTarget(event.target)) return;
      if (activeTab !== "1") return;
      const key = event.key?.toLowerCase();
      if (key === "c") {
        const selected = getSelectedDocumentRecords(
          selectedRowKeys,
          matterDetailsList
        );
        if (selected.length) {
          event.preventDefault();
          handleCopyRecords(selected);
          return;
        }
        const docKeys = (selectedKeys || []).filter((k) =>
          String(k).startsWith("D")
        );
        const items = collectDocumentsByUniqueIds(matterDetailsTree, docKeys);
        if (!items.length) return;
        event.preventDefault();
        handleCopyClipboardItems(items);
        return;
      }
      if (key === "v") {
        if (!clipboardItems.length) return;
        event.preventDefault();
        handlePasteHere();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [
    activeTab,
    clipboardItems,
    handleCopyRecords,
    handleCopyClipboardItems,
    handlePasteHere,
    matterDetailsList,
    matterDetailsTree,
    selectedKeys,
    selectedRowKeys,
  ]);

  const openGeneratePackageModal = useCallback(async () => {
    setGeneratePackageOpen(true);
    setMatterPackagesLoading(true);
    try {
      const res = await fetchPackages();
      setMatterPackages(res?.data || []);
    } catch (err) {
      console.error("Failed to load packages for Matter generation", err);
      handleSnackbar("Failed to load packages. Please refresh and try again.");
    } finally {
      setMatterPackagesLoading(false);
    }
  }, [handleSnackbar]);

  const handlePreviewPackageFromMatter = useCallback(async ({ packageId, folderId }) => {
    setPackagePreviewing(true);
    try {
      const res = await previewPackage(packageId, {
        matter_id: id,
        folder_id: folderId || null,
      });
      return res?.data || res;
    } finally {
      setPackagePreviewing(false);
    }
  }, [id]);

  const handlePreviewPackageTemplatePdf = useCallback(async ({ formstackId, fieldOverrides }) => {
    try {
      const res = await previewMappingDocument(formstackId, id, null, fieldOverrides || {});
      const blob = res?.data || res;
      const url = URL.createObjectURL(
        blob instanceof Blob ? blob : new Blob([blob], { type: "application/pdf" })
      );
      window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      console.error("Failed to preview package template PDF", err);
      handleSnackbar(
        err?.response?.data?.detail ||
          err?.response?.data?.error ||
          "Failed to preview this template."
      );
    }
  }, [handleSnackbar, id]);

  const handleGeneratePackageFromMatter = useCallback(async ({
    packageId,
    folderId,
    fieldOverrides,
    documentName,
    poaAttorney,
  }) => {
    const pkg = matterPackages.find((item) => String(item.id) === String(packageId));
    setPackageGenerating(true);
    try {
      const payload = {
        matter_id: id,
        folder_id: folderId || null,
        field_overrides: fieldOverrides || {},
      };
      if (documentName) {
        payload.document_name = documentName;
      }
      if (poaAttorney) {
        payload.poa_attorney = poaAttorney;
      }
      const res = await mergePackage(packageId, payload);
      const data = res?.data || res;
      const result = {
        ...data,
        matter_id: id,
        folder_id: folderId || null,
        package_id: packageId,
        package: data?.package || pkg || null,
      };
      setPackageMergeResult(result);
      setGeneratePackageOpen(false);
      refreshMatterDocuments();
      const count = result?.documents?.length || 0;
      const errorCount = result?.errors?.length || 0;
      if (count > 0) {
        handleSnackbar(
          `${count} document${count !== 1 ? "s" : ""} generated from package${errorCount ? ` (${errorCount} template error${errorCount !== 1 ? "s" : ""})` : ""}.`,
          true
        );
      } else {
        handleSnackbar("Package ran, but no documents were generated.");
      }
    } catch (err) {
      console.error("Failed to generate package from Matter", err);
      handleSnackbar(
        err?.response?.data?.detail ||
          err?.response?.data?.error ||
          "Failed to generate package."
      );
    } finally {
      setPackageGenerating(false);
    }
  }, [handleSnackbar, id, matterPackages, refreshMatterDocuments]);

  const updatePackageResultDocuments = useCallback((updater) => {
    setPackageMergeResult((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        documents: updater(prev.documents || []),
      };
    });
  }, []);

  const handleDownloadDocument = useCallback(async (doc) => {
    try {
      await downloadDocumentFile(doc);
      handleSnackbar("Download started. Large files can take a few minutes.", true);
    } catch (err) {
      console.error("Failed to download document", err);
      handleSnackbar("Failed to download file.");
    }
  }, [handleSnackbar]);

  const handleDownloadGeneratedMatterDocument = useCallback(async (doc) => {
    const documentId = generatedDocumentId(doc);
    if (!documentId) return;
    try {
      await downloadDocumentFile({
        ...doc,
        id: documentId,
        name: doc?.name || "generated-document",
      });
    } catch (err) {
      console.error("Failed to download generated document", err);
      handleSnackbar("Failed to download generated document.");
    }
  }, [handleSnackbar]);

  const handleRenameGeneratedMatterDocument = useCallback(async (doc, newName) => {
    const documentId = generatedDocumentId(doc);
    if (!documentId) return;
    setPackageActionBusy(true);
    try {
      const res = await renameGeneratedDocument(documentId, newName);
      const updated = res?.data || { ...doc, name: newName };
      updatePackageResultDocuments((docs) =>
        docs.map((item) =>
          String(generatedDocumentId(item)) === String(documentId)
            ? { ...item, ...updated }
            : item
        )
      );
      refreshMatterDocuments();
      handleSnackbar("Generated document renamed.", true);
    } catch (err) {
      console.error("Failed to rename generated document", err);
      handleSnackbar(err?.response?.data?.error || "Failed to rename generated document.");
    } finally {
      setPackageActionBusy(false);
    }
  }, [handleSnackbar, refreshMatterDocuments, updatePackageResultDocuments]);

  const handleDeleteGeneratedMatterDocuments = useCallback(async (docs) => {
    const documentIds = docs.map(generatedDocumentId).filter(Boolean);
    if (!documentIds.length) return;
    setPackageActionBusy(true);
    try {
      const res = await bulkDeleteMatterDocuments(id, documentIds);
      const data = res?.data || {};
      const deletedItems = data.deleted || [];
      const deletedIds = new Set(
        deletedItems
          .flatMap((item) => [item.id, item.unique_id])
          .filter(Boolean)
          .map(String)
      );
      updatePackageResultDocuments((items) =>
        items.filter((item) => !deletedIds.has(String(item.id)) && !deletedIds.has(String(item.unique_id)))
      );
      refreshMatterDocuments();
      const errorCount = data.errors?.length || 0;
      handleSnackbar(
        errorCount
          ? `Deleted ${deletedItems.length} document(s), ${errorCount} failed.`
          : "Generated document deleted.",
        errorCount === 0
      );
    } catch (err) {
      console.error("Failed to delete generated documents", err);
      handleSnackbar(err?.response?.data?.error || "Failed to delete generated document.");
    } finally {
      setPackageActionBusy(false);
    }
  }, [handleSnackbar, id, refreshMatterDocuments, updatePackageResultDocuments]);

  const handleCombineGeneratedMatterDocuments = useCallback(async (docs, outputName) => {
    if (!packageMergeResult?.package_id || !packageMergeResult?.matter_id) return;
    setPackageActionBusy(true);
    try {
      const res = await combinePackageForSigning(packageMergeResult.package_id, {
        matter_id: packageMergeResult.matter_id,
        folder_id: packageMergeResult.folder_id || null,
        document_ids: docs.map(generatedDocumentId).filter(Boolean),
        output_name: outputName,
      });
      const result = res?.data || res;
      if (result?.document) {
        updatePackageResultDocuments((items) => [...items, result.document]);
      }
      refreshMatterDocuments();
      handleSnackbar("Combined PDF created.", true);
    } catch (err) {
      console.error("Failed to combine generated documents", err);
      handleSnackbar(err?.response?.data?.error || "Failed to combine generated documents.");
    } finally {
      setPackageActionBusy(false);
    }
  }, [handleSnackbar, packageMergeResult, refreshMatterDocuments, updatePackageResultDocuments]);

  // drag-and-drop
  const handleDragAndDrop = async (e, explicitTargetId) => {
    e.preventDefault();
    e.stopPropagation?.();

    setIsDraggingOverRow(false);
    setHoveredRowName(null);

    const targetId = explicitTargetId ?? null;

    const { files, folderNames } = await extractFilesFromDrop(e);
    handleUpload(files, targetId, folderNames);
  };

  const handleProcessFiles = (files, targetId, overwrite, { aiProcess = false } = {}) => {
    const setShowDragNotification = null;

    processFiles({
      files,
      createUploads,
      addUpload,
      setShowDragNotification,
      addUploadAbortController,
      uploadFile,
      uploadFileToSignedUrl,
      createObjectURL,
      handleUploadSuccess,
      handleUploadFailure,
      matterDetails,
      id,
      uniqueId: targetId,
      updateUpload,
      uploads,
      removeUpload,
      cancelUpload,
      addFailedUpload,
      markUploadCompleted,
      clearCompletedUploadIds,
      isUploadCancelled,
      setErrorToastMsgAndShow: null,
      setisLoading: null,
      currentPage,
      setCurrentPage,
      dispatch: dispatchUpload,
      parentId: currentFolder ? folderId : null,
      overwrite,
      aiProcess,
    });
  };

  useEffect(() => {
    if (!showSideBar) {
      const newTab = {
        id: "0",
        title: "sideBAr",
        content: "sideBAr",
      };
      setTabs([newTab, ...tabs]);
    }
    // eslint-disable-next-line
  }, [showSideBar]);

  // Track which matter details have been fetched (to avoid duplicate calls)
  const fetchedMatterDetailsRef = useRef(new Set());

  // Fetch matter detail on initial component mount and when matter ID changes (first time for each matter)
  useEffect(() => {
    const urlIds = location.pathname.split("/matter/")[1]?.split("/");
    const currentMatterId = urlIds && urlIds[0];
    
    if (currentMatterId && !fetchedMatterDetailsRef.current.has(currentMatterId)) {
      dispatch(fetchMatterDetail(currentMatterId));
      fetchedMatterDetailsRef.current.add(currentMatterId);
    }
  }, [location.pathname, dispatch]); // Fetch when pathname changes (new matter)

  useEffect(()=>{
    console.log(`🌐 [URL EFFECT] ========== useEffect triggered ==========`);
    console.log(`🌐 [URL EFFECT] Current URL: ${location.pathname}`);
    console.log(`🌐 [URL EFFECT] Current activeTab: ${activeTab}`);
    console.log(`🌐 [URL EFFECT] manualTabSwitchRef: ${manualTabSwitchRef.current}`);
    
    // Check if we're navigating to a different matter (different matter ID)
    const currentMatterId = urlIds[0];
    const previousMatterId = location.pathname.split("/matter/")[1]?.split("/")[0];
    const currentUniqueId = urlIds.at(-1);
    console.log(`🌐 [URL EFFECT] Current unique ID from URL: ${currentUniqueId}`);
    console.log(`🌐 [URL EFFECT] URL IDs length: ${urlIds.length}`);

    // Check if this tab already has an instance with loaded document
    // If instance exists, skip fetchMatterDetail to avoid unnecessary API calls
    const hasInstance = hasTabInstanceWithDocument(currentUniqueId);

    // If navigating to a different matter, clear the selection state
    if (previousMatterId && currentMatterId !== previousMatterId) {
      tab1SelectionRef.current = [];
      setSelectedRowKeys([]);
      // Note: fetchMatterDetail for new matter is handled by the mount useEffect above
    }
      const { matterId, folderId } = extractMatterAndFolderFromPath(location);
      dispatch(setCurrentContext({ matterId, folderId }));
    if(urlIds.length==1) {
      console.log(`🌐 [URL EFFECT] URL has only 1 segment, calling setActiveTab("1")`);
      setActiveTab("1");
      dispatch(setSelectedKeys([]));
      // Restore tab 1 selection state when navigating to root matter URL
      localStorage.setItem("relativePath",location.pathname.split("/matter")[1])
      restoreTab1Selection();
      // Call folder-hierarchy API when navigating to root matter
      const listPage = Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;
      dispatch(fetchMatterDetailList({id: urlIds[0], page: listPage}));
      // Commented out fetchMatterDetail API call - not needed when navigating to root matter
      // Initial fetch is handled by the mount useEffect above
      // dispatch(fetchMatterDetail(urlIds[0]))
    } else {
        
        if (hasInstance) {
          console.log(`✅ Tab ${currentUniqueId} already has instance with loaded document, skipping fetchMatterDetail`);
        } else {
          // Commented out fetchMatterDetail API call - not needed when opening folder/document
          // Initial fetch is handled by the mount useEffect above
          // dispatch(fetchMatterDetail(urlIds[0]));
        }
        
        dispatch(setSelectedKeys([currentUniqueId]));
        if(currentUniqueId.startsWith("F")){
          dispatch(setExpandedKeys([...expandedKeys, ...urlIds]));
          localStorage.setItem("relativePath",location.pathname.split("/matter")[1])
          // setTimeout(() => {
            const nextListPage = 1;
            if (currentPage !== nextListPage) {
              setCurrentPage(nextListPage);
            }
            dispatch(fetchMatterDetailList({id: urlIds[0],page: nextListPage,folder: currentUniqueId,}));
          // }, 1000);
       } else {
        const hasInstance = hasTabInstanceWithDocument(currentUniqueId);
        
        if (hasInstance) {
          console.log(`✅ Tab ${currentUniqueId} already has instance with loaded document, skipping fetchMatterDetail`);
        } else {
          // Only fetch matter detail if tab doesn't have instance yet
        
        const docIdFromUrl = urlIds.at(-1)?.substring(1);
        const expectedTabId = urlIds.at(-1); // Capture the expected tab ID
        console.log(`📄 [DOC LOAD] ========== START async document load ==========`);
        console.log(`📄 [DOC LOAD] Document ID from URL: ${docIdFromUrl}`);
        console.log(`📄 [DOC LOAD] Expected tab ID: ${expectedTabId}`);
        console.log(`📄 [DOC LOAD] Current active tab: ${activeTab}`);
        console.log(`📄 [DOC LOAD] Current URL: ${location.pathname}`);
        console.log(`📄 [DOC LOAD] manualTabSwitchRef before reset: ${manualTabSwitchRef.current}`);
        manualTabSwitchRef.current = false; // Reset manual switch flag before async operation
        console.log(`📄 [DOC LOAD] manualTabSwitchRef after reset: ${manualTabSwitchRef.current}`);
        console.log(`📄 [DOC LOAD] Starting getDocumentDetails API call...`);
        dispatch(getDocumentDetails(docIdFromUrl)).then(async (res) => {
          console.log(`📄 [DOC LOAD] ========== getDocumentDetails API response received ==========`);
          console.log(`📄 [DOC LOAD] Current active tab: ${activeTab}`);
          console.log(`📄 [DOC LOAD] Current URL: ${location.pathname}`);
          console.log(`📄 [DOC LOAD] manualTabSwitchRef: ${manualTabSwitchRef.current}`);
          console.log(`📄 [DOC LOAD] Expected tab ID: ${expectedTabId}`);
          
          // Check if user has manually switched tabs or URL changed
          if (manualTabSwitchRef.current) {
            console.log(`⚠️ [DOC LOAD] User manually switched tabs during document load, skipping setActiveTab`);
            // Still open the tab, but don't force it to be active
            const docData = res?.payload?.data;
            if (docData) {
              console.log(`📄 [DOC LOAD] Opening tab without setting it active`);
              openTab(docData);
            }
            console.log(`📄 [DOC LOAD] ========== END async document load (manual switch detected) ==========`);
            return;
          }
          
          const currentUrlIds = location.pathname.split("/matter/")[1]?.split("/").filter(Boolean);
          const currentUrlTabId = currentUrlIds?.at(-1);
          console.log(`📄 [DOC LOAD] Current URL tab ID: ${currentUrlTabId}`);
          
          // Only set active tab if URL still matches the document we're loading
          if (currentUrlTabId !== expectedTabId) {
            console.log(`⚠️ [DOC LOAD] URL changed during document load, skipping setActiveTab. Expected: ${expectedTabId}, Current URL: ${currentUrlTabId}`);
            const docData = res?.payload?.data;
            if (docData) {
              console.log(`📄 [DOC LOAD] Opening tab without setting it active (URL mismatch)`);
              openTab(docData);
            }
            console.log(`📄 [DOC LOAD] ========== END async document load (URL mismatch) ==========`);
            return;
          }
          
          const docData = res?.payload?.data;
          if(localStorage.getItem("newPdf")){
          setEditingKey(docData?.unique_id);
          setEditingValue(docData?.name);
          }
          const docId = docData?.id;
          if (!docId) {
            return;
          }           
          // Reuse already-fetched details response to seed bookmarks cache.
          addBookmarksCache(res, docId);
          // Removed addOpenedDoc call - tab_action is now included in postHighlightedMatter for documents
          // dispatch(addOpenedDoc({ matterId: id, docId }));
          
          // Check and update relativePath in localStorage if root ID doesn't match
          const currentRelativePath = `/${location.pathname.split("/matter/")[1]}`;
          checkAndUpdateRelativePath(currentRelativePath);
          
          // Reset tabs state before fetching opened documents
          const urlRoot = currentRelativePath.split("/")[1];


          const result = tabs.some(item => {
            if (!item.relativePath) return false;
            const pathRoot = item.relativePath.split("/")[1];
            return pathRoot !== urlRoot;
          });

          if(result){
            globalThis.location.reload();
            return;
          }
          
          // Final check before setting active tab
          console.log(`📄 [DOC LOAD] Final check before setActiveTab`);
          console.log(`📄 [DOC LOAD] Current active tab: ${activeTab}`);
          console.log(`📄 [DOC LOAD] manualTabSwitchRef: ${manualTabSwitchRef.current}`);
          
          if (manualTabSwitchRef.current) {
            console.log(`⚠️ [DOC LOAD] User switched tabs during async operations, skipping setActiveTab`);
            console.log(`📄 [DOC LOAD] Opening tab without setting it active`);
            openTab(docData);
            console.log(`📄 [DOC LOAD] ========== END async document load (manual switch in final check) ==========`);
            return;
          }
          
          const finalUrlIds = location.pathname.split("/matter/")[1]?.split("/").filter(Boolean);
          const finalUrlTabId = finalUrlIds?.at(-1);
          console.log(`📄 [DOC LOAD] Final URL tab ID: ${finalUrlTabId}`);
          
          if (finalUrlTabId === expectedTabId) {
            console.log(`✅ [DOC LOAD] URL matches, calling openTab and setActiveTab`);
            console.log(`📄 [DOC LOAD] Calling openTab(${docData?.name || docData?.unique_id})`);
            // dispatch(fetchOpenedDocs(urlIds[0])).then((res)=>{
            // When clicking from sidebar, open the tab and set it as active immediately
            console.log(`📄 [DOC LOAD] Calling openTab(${docData?.name || docData?.unique_id})`);
            openTab(docData); 
            console.log(`📄 [DOC LOAD] Calling setActiveTab(${expectedTabId})`);
            console.log(`📄 [DOC LOAD] Current activeTab before setActiveTab: ${activeTab}`);
            setActiveTab(expectedTabId);
            console.log(`📄 [DOC LOAD] setActiveTab called, activeTab should now be: ${expectedTabId}`);
              // Reset manual switch flag after successfully setting active tab
              manualTabSwitchRef.current = false;
              console.log(`📄 [DOC LOAD] Reset manualTabSwitchRef to false`);
              console.log(`📄 [DOC LOAD] ========== END async document load (success) ==========`);
            // })
          } else {
            console.log(`⚠️ [DOC LOAD] Skipping setActiveTab - URL changed. URL: ${finalUrlTabId}, Expected: ${expectedTabId}`);
            console.log(`📄 [DOC LOAD] Opening tab without setting it active`);
            openTab(docData);
            // Reset flag even if we didn't set active tab
            manualTabSwitchRef.current = false;
            console.log(`📄 [DOC LOAD] ========== END async document load (URL mismatch in final check) ==========`);
          }
        })
      }
    }

    }
    
    // Cleanup document when activeTab becomes "1" (useEffect dependency)
    // Note: With multi-instance architecture, each tab has its own instance
    // When switching to tab "1", the previous tab's instance is automatically paused
    // No explicit cleanup needed here as instances are managed per-tab
    if(currentUniqueId.startsWith("F")) {
      // Create breadcrumb from treeData for folders
      try {
        const breadcrumb = createBreadcrumbFromTreeData(treeData, matterDetails, currentUniqueId);
        setBreadcrumb(breadcrumb);
      } catch (error) {
        console.error('Failed to create breadcrumb from treeData for folder:', error);
        // Fallback to API if treeData doesn't have the folder
      dispatch(fetchBreadCrumbs({item_id:currentUniqueId})).then((response)=>{
        setBreadcrumb([{ id: 0, name: "Matters" },...(response?.payload?.data || [])])
        }).catch((apiError) => {
          console.error('Failed to fetch breadcrumb from API:', apiError);
        });
      }
    } else if (!currentUniqueId.startsWith("D")) {
       if (urlIds.length === 1 && matterDetails?.matter_displayName) {
        setBreadcrumb([{ id: 0, name: "Matters" }, { id: urlIds[0], name: matterDetails.matter_displayName }]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[location.pathname])

  useEffect(() => {
    if (urlIds.length === 1 && matterDetails?.matter_displayName) {
      setBreadcrumb([{ id: 0, name: "Matters" }, { id: urlIds[0], name: matterDetails.matter_displayName }]);
    }
  }, [matterDetails.matter_displayName, urlIds.length, urlIds[0]])

  useEffect(() => {
    const pathIds = location.pathname.split("/matter/")[1]?.split("/").filter(Boolean);
    if (!pathIds || pathIds.length < 2) return;
    const currentUniqueId = pathIds.at(-1);
    if (!currentUniqueId?.startsWith("F")) return;
    if (!treeData || (Array.isArray(treeData) && treeData.length === 0)) return;
    if (!matterDetails?.matter_displayName) return;
    try {
      const newBreadcrumb = createBreadcrumbFromTreeData(treeData, matterDetails, currentUniqueId);
      if (newBreadcrumb && newBreadcrumb.length > 1) {
        setBreadcrumb(newBreadcrumb);
      }
    } catch (e) {
      console.error('Failed to create breadcrumb from treeData for folder (sync):', e);
    }
  }, [location.pathname, treeData, matterDetails?.matter_displayName, matterDetails?.id])

  useEffect(() => {
    if (!docLoading && pendingRename) {
      const { docID, type, oldName } = pendingRename;
      renameDocument({ key: "Enter" }, docID, type, oldName);
      setPendingRename(null);
    }
  }, [docLoading, pendingRename]);

  useEffect(() => {
    dispatch(fetchCategoryList()).then((response) => {
      if (response.payload?.status === 200) {
      }
    });
    const urlIds = location.pathname.split("/matter/")[1].split("/"); // split the URL by "/"
    const matter = urlIds[0];
    
    // Check and update relativePath in localStorage if root ID doesn't match
    const currentRelativePath = `/${location.pathname.split("/matter/")[1]}`;
    checkAndUpdateRelativePath(currentRelativePath);
    
    // Reset tabs state before fetching opened documents
    const urlRoot = currentRelativePath.split("/")[1];
    const result = tabs.some(item => {
      if (!item.relativePath) return false;
      const pathRoot = item.relativePath.split("/")[1];
      return pathRoot !== urlRoot;
    });

    if(result){
      globalThis.location.reload();
    }
    
    // eslint-disable-next-line
    dispatch(fetchOpenedDocs(matter)).then((response) => {
      if (response.payload?.status === 200) {
      }
    });
     //setActiveTab("1")
  }, [docIdFromUrlState, id,]);


  // Bookmark panel: truncation, cursor, hover tooltip - inject directly into iframe
  useEffect(() => {
    const injectGlobalHideStyles = (targetDoc = document) => {
      if (targetDoc.getElementById('hide-undefined-page-styles')) return;
      const style = targetDoc.createElement('style');
      style.id = 'hide-undefined-page-styles';
      style.textContent = `
        .panel-list-grid:has(button[aria-label="Page undefined"]),
        .panel-list-grid:has(button[aria-label*="undefined"]) {
          visibility: hidden !important;
          pointer-events: none !important;
        }
      `;
      (targetDoc.head || targetDoc.documentElement).appendChild(style);
    };
  
    // Inject into main document immediately
    injectGlobalHideStyles(document);
  
    // Skip non-document tabs immediately; for document tabs we may need to
    // wait for the instance to be initialised (loadDocument runs async).
    if (!activeTab || activeTab === "1" || activeTab === "0") return;
  
    const applyTitleToDescriptions = (root) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          root.querySelectorAll('.BookmarksPanel .panel-list-description').forEach((el) => {
            const fullText = (el.innerText || el.textContent || '').trim();
            if (!fullText) return;
            const row = el.closest('.panel-list-item') || el.closest('.bookmark-outline-row');
            if (el.scrollWidth > el.clientWidth) {
              el.setAttribute('title', fullText);
              if (row) row.setAttribute('title', fullText);
            } else {
              el.removeAttribute('title');
              if (row) row.removeAttribute('title');
            }
          });
        });
      });
    };
  
    const hasUndefined = (el) => {
      if (!el) return false;
      const ariaLabel = el.getAttribute?.('aria-label') || '';
      const textContent = el.textContent || '';
      return ariaLabel.toLowerCase().includes('page undefined') ||
             textContent.toLowerCase().includes('page undefined');
    };
  
    const rowHasUndefinedPage = (row) => {
      const expandBtn = row.querySelector('.chevron-container button');
      if (hasUndefined(expandBtn)) return true;
      const labelBtn = row.querySelector('.panel-list-label-header button');
      if (hasUndefined(labelBtn)) return true;
      const spans = row.querySelectorAll('.panel-list-label-header button span');
      if (Array.from(spans).some((s) => hasUndefined(s))) return true;
      const textContent = row.textContent || '';
      if (textContent.toLowerCase().includes('page undefined')) return true;
      return false;
    };
  
    const applyRowVisibility = (row) => {
      if (!row.isConnected) return;
      if (rowHasUndefinedPage(row)) {
        row.style.visibility = 'hidden';
        row.style.pointerEvents = 'none';
        row.dataset.loadingPage = 'true';
      } else if (row.dataset.loadingPage === 'true') {
        row.style.visibility = '';
        row.style.pointerEvents = '';
        delete row.dataset.loadingPage;
      }
    };
  
    const fixUndefinedPageLabels = (root) => {
      const panel =
        root.querySelector('[data-element="bookmarksPanel"]') ||
        root.querySelector('[data-element="bookmarkPanel"]') ||
        root.querySelector('.BookmarksPanel');
      if (!panel || !panel.isConnected) return;
  
      panel.querySelectorAll('.panel-list-grid').forEach((grid) => {
        const row = grid.querySelector('.panel-list-row');
        if (row) applyRowVisibility(row);
        else applyRowVisibility(grid);
      });
  
      panel.querySelectorAll('.panel-list-row:not(.panel-list-grid .panel-list-row)').forEach(applyRowVisibility);
  
      const doc = panel.ownerDocument || document;
      const walker = doc.createTreeWalker(panel, NodeFilter.SHOW_TEXT, null);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue?.toLowerCase().includes('page undefined')) {
          const grid =
            node.parentElement?.closest('.panel-list-grid') ||
            node.parentElement?.closest('.panel-list-row');
          if (grid && grid.isConnected) applyRowVisibility(grid);
        }
      }
    };
  
    const setup = (root) => {
      // Also inject into iframe/shadowRoot document when we find it
      const rootDoc = root.ownerDocument || (root.nodeType === Node.DOCUMENT_NODE ? root : null);
      if (rootDoc && rootDoc !== document) injectGlobalHideStyles(rootDoc);
  
      const observeTarget = root.body || root;
      const fix = () => fixUndefinedPageLabels(root);
      const applyTitles = () => applyTitleToDescriptions(root);
  
      const observer = new MutationObserver((mutations) => {
        let needsFix = false;
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'aria-label') {
            const grid =
              m.target.closest?.('.panel-list-grid') ||
              m.target.closest?.('.panel-list-row');
            if (grid && grid.isConnected) applyRowVisibility(grid);
          } else if (m.type === 'childList' && m.addedNodes.length > 0) {
            needsFix = true;
          } else if (m.type === 'characterData') {
            needsFix = true;
          }
        }
        if (needsFix) fix();
        applyTitles();
      });
  
      observer.observe(observeTarget, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-label'],
      });
  
      applyTitles();
      fix();
      [300, 800, 1500, 2500].forEach((delay) => {
        setTimeout(applyTitles, delay);
        setTimeout(fix, delay);
      });
  
      return () => observer.disconnect();
    };
  
    const getRoot = (inst) => {
      const iframeDoc = inst.UI?.iframeWindow?.document;
      if (iframeDoc?.body) return iframeDoc;
      const webComponent = document.querySelector('apryse-webviewer');
      if (webComponent?.shadowRoot) return webComponent.shadowRoot;
      return null;
    };
  
    const attach = (inst, root) => {
      const observerCleanup = setup(root);
      const { documentViewer } = inst.Core;
  
      const onDocumentLoaded = () => {
        const freshRoot = inst.UI?.iframeWindow?.document || root;
        fixUndefinedPageLabels(freshRoot);
        applyTitleToDescriptions(freshRoot);
        [100, 300, 800, 1500, 2500].forEach((delay) => {
          setTimeout(() => fixUndefinedPageLabels(freshRoot), delay);
          setTimeout(() => applyTitleToDescriptions(freshRoot), delay);
        });
      };
  
      if (documentViewer?.getDocument()) {
        onDocumentLoaded();
      }
  
      documentViewer?.addEventListener('documentLoaded', onDocumentLoaded);
      return () => {
        if (typeof observerCleanup === 'function') observerCleanup();
        documentViewer?.removeEventListener('documentLoaded', onDocumentLoaded);
      };
    };

    // ─── retry loop ───────────────────────────────────────────────────────
    // When a new document tab is opened the WebViewer instance is initialised
    // asynchronously (by the loadDocument useEffect). The instance may be null
    // on the first run of this effect, so we keep retrying until it appears
    // (or until the iframe root is ready after the instance exists).
    let lateCleanup = null;
    let stopped = false;
    let attempts = 0;
    const maxAttempts = 30; // ~3 s at 100 ms, covers slow machines
    let t;

    const tryAttach = () => {
      if (stopped) return;
      attempts++;

      const inst = webViewerInstances.getInstance(activeTab);
      if (!inst) {
        // Instance not ready yet — keep waiting
        if (attempts < maxAttempts) t = setTimeout(tryAttach, 100);
        return;
      }

      const lateRoot = getRoot(inst);
      if (lateRoot) {
        lateCleanup = attach(inst, lateRoot);
        return;
      }

      // Instance exists but iframe not ready yet
      if (attempts < maxAttempts) t = setTimeout(tryAttach, 100);
    };

    // Try immediately first (handles the already-open-tab case), then fall
    // back to the retry loop for newly opened tabs.
    const immediateInst = webViewerInstances.getInstance(activeTab);
    if (immediateInst) {
      const immediateRoot = getRoot(immediateInst);
      if (immediateRoot) return attach(immediateInst, immediateRoot);
    }

    t = setTimeout(tryAttach, 100);

    return () => {
      stopped = true;
      clearTimeout(t);
      if (typeof lateCleanup === 'function') lateCleanup();
    };
  }, [activeTab, webViewerInstances]);
  
  // Reset pagination loading when loading completes
  useEffect(() => {
    if (matterDetailsLIstStatus === "succeeded") {
      setIsPaginationLoading(false);
    }
  }, [matterDetailsLIstStatus]);
  
  // Determine if we should show loader:
  // 1. Initial load: no data exists AND status is loading
  // 2. Pagination: pagination loading state is true
  const shouldShowLoader = activeTab === "1" && (
    // Initial load: no data exists and status is loading
    ((!matterDetailsList || matterDetailsList.length === 0) && (matterDetailsLIstStatus === "loading" || matterDetailsStatus === "loading1")) ||
    // Pagination: pagination loading is true
    isPaginationLoading
  );
  
  // Handle scroll and scrollbar when loader appears/disappears
  const isTableLoading = shouldShowLoader;
  
  useEffect(() => {
    if (tabContentAreaRef.current) {
      if (isTableLoading) {
        // Scroll to top and hide scrollbar when loading
        tabContentAreaRef.current.scrollTop = 0;
        tabContentAreaRef.current.style.overflow = 'hidden';
      } else {
        // Restore scrollbar when not loading
        tabContentAreaRef.current.style.overflow = 'auto';
      }
    }
  }, [isTableLoading]);
  
  // Save current document's page when switching tabs
  useEffect(() => {

    // Only save if we have a current document loaded and activeTab is changing to a different document
    if (!currentDocumentIdRef.current) {
      prevActiveTabRef.current = activeTab;
      return;
    }

    // Don't save if switching to tab "1" or "0" (non-document tabs), or if activeTab hasn't changed
    if (activeTab === "1" || activeTab === "0" || !activeTab || activeTab === prevActiveTabRef.current) {
      prevActiveTabRef.current = activeTab;
      return;
    }

    // Check if we're switching to a different document
    const prevTab = tabs.find(tab => tab.id === prevActiveTabRef.current);
    if (!prevTab || prevTab.id === "1" || prevTab.id === "0") {
      prevActiveTabRef.current = activeTab;
      return;
    }

    // Get previous document ID
    let prevDocumentRecord = null;
    if (prevTab.documentRecord) {
      prevDocumentRecord = prevTab.documentRecord;
    } else if (prevTab.content && typeof prevTab.content === 'object' && prevTab.content.props) {
      prevDocumentRecord = prevTab.content.props.documentRecord;
    }

    if (!prevDocumentRecord) {
      prevActiveTabRef.current = activeTab;
      return;
    }

    const prevDocumentId = prevDocumentRecord.unique_id?.substring(1);
    
    // Only save if we had a previous document loaded
    if (prevDocumentId && prevDocumentId === currentDocumentIdRef.current) {
      try {
        // Get page from documentViewer before it switches to new document
        let currentPage = null;
            const prevTabId = prevActiveTabRef.current;
            const instance = webViewerInstances.getInstance(prevTabId);
        
            if (instance?.Core?.documentViewer) {
          try {
                const { documentViewer } = instance.Core;
            const currentDoc = documentViewer.getDocument();
            if (currentDoc) {
              const viewerPage = documentViewer.getCurrentPage();
              if (viewerPage && viewerPage > 0) {
                currentPage = viewerPage;
              }
            }
          } catch (e) {
            // Document might be closed or switched, ignore
          }
        }
        
        // Save the page if we got it
        if (currentPage && currentPage > 0) {
          // Flush any pending debounced API call for this document
          if (pageChangeListenerRef.current && pageChangeListenerRef.current.documentId === prevDocumentId) {
            if (pageChangeListenerRef.current.timer) {
              clearTimeout(pageChangeListenerRef.current.timer);
              pageChangeListenerRef.current.timer = null;
            }
          }
          
          // Update localStorage immediately (used by various navigation flows)
          localStorage.setItem('lastPageViewed', String(currentPage));
          localStorage.setItem('lastPageViewedDoc', String(prevDocumentId));
          
          // NOTE: We intentionally do NOT call postLastPageViewed here anymore.
          // The backend is updated by:
          //  - debounced page change handler, and
          //  - explicit close-tab / navigation handlers.
          // Calling it again on every tab switch is unnecessary noise.
          
          // Still update sidebar Redux so UI-side retention works without extra API
          dispatch(updateDocumentLastPageViewed({ documentId: prevDocumentId, lastPageViewed: currentPage }));
          
          console.log(`💾 [SWITCH TAB] Saved page ${currentPage} for document ${prevDocumentId} when switching away (localStorage + sidebar Redux only, no extra API)`);
        }
      } catch (error) {
        console.warn('⚠️ Failed to save page when switching tabs:', error);
      }
    }
    
    prevActiveTabRef.current = activeTab;
  }, [activeTab, tabs, dispatch, webViewerInstances]);
  
  // Reset hasInitialDataRef when switching away from Tab 1 (for fresh load next time)
  useEffect(() => {
    if (activeTab !== "1") {
      // Keep hasInitialDataRef.current as is - we want to remember if data was loaded
      // Only reset if we're navigating to a completely different matter
    }
  }, [activeTab]);

  // Track loading state to prevent infinite loops
  const loadingDocumentRef = useRef(null); // Track which document is currently loading: { tabId, documentId }

  // Load document when activeTab changes to a document tab
  useEffect(() => {
    console.log(`📚 [LOAD DOC EFFECT] ========== useEffect triggered ==========`);
    console.log(`📚 [LOAD DOC EFFECT] activeTab: ${activeTab}`);
    console.log(`📚 [LOAD DOC EFFECT] Current URL: ${location.pathname}`);
    console.log(`📚 [LOAD DOC EFFECT] manualTabSwitchRef: ${manualTabSwitchRef.current}`);
    
    const loadDocument = async () => {
      // Small delay to ensure DOM is ready (containers are registered)
      // await new Promise(resolve => setTimeout(resolve, 50));
      // Only load if activeTab is a document (not "1" or "0")
      if (activeTab === "1" || activeTab === "0" || !activeTab) {
        console.log(`📚 [LOAD DOC EFFECT] Skipping - activeTab is "${activeTab}" (not a document tab)`);
        currentDocumentIdRef.current = null;
        loadingDocumentRef.current = null;
        return;
      }
      console.log(`📚 [LOAD DOC EFFECT] Starting document load for tab: ${activeTab}`);

      // Find the active tab
      const activeTabData = tabs.find(tab => tab.id === activeTab);
      if (!activeTabData) {
        return;
      }

      // Extract documentRecord from tab
      let documentRecord = null;
      if (activeTabData.documentRecord) {
        documentRecord = activeTabData.documentRecord;
      } else if (activeTabData.content && typeof activeTabData.content === 'object' && activeTabData.content.props) {
        documentRecord = activeTabData.content.props.documentRecord;
      }

      // If still no documentRecord, fetch it using the documentId from tab.id
      if (!documentRecord && activeTabData.id && activeTabData.id.startsWith('D')) {
        const documentId = activeTabData.id.substring(1);
        try {
          const result = await dispatch(getDocumentDetails(documentId));
          if (result.type === 'getDocumentDetails/fetch/fulfilled') {
            documentRecord = {
              unique_id: activeTabData.id,
              ...result.payload?.data
            };
            activeTabData.documentRecord = documentRecord;
            addBookmarksCache(result, documentId);
          }
        } catch (error) {
          console.error(`❌ Failed to fetch document ${documentId}:`, error);
          return;
        }
      }

      if (!documentRecord) {
        return;
      }

      // Extract documentId from unique_id (format: D123)
      const documentId = documentRecord.unique_id?.substring(1) || activeTab.substring(1);
      if (!documentId) {
        return;
      }

      // If this documentRecord doesn't have last_page_viewed (common for Tab 1 list API),
      // try to get it from the sidebar tree (matterDetailsTree), which we keep up to date.
      if (!documentRecord.last_page_viewed && matterDetailsTree) {
        try {
          const sidebarDoc =
            findDocumentById(matterDetailsTree, `D${documentId}`) ||
            findDocumentById(matterDetailsTree, String(documentId));

          if (sidebarDoc?.last_page_viewed) {
            documentRecord = {
              ...documentRecord,
              last_page_viewed: sidebarDoc.last_page_viewed,
            };
            console.log(
              `📄 [DOC LOAD] Using last_page_viewed from sidebar tree for document ${documentId}:`,
              sidebarDoc.last_page_viewed
            );
          }
        } catch (e) {
          console.warn(
            "⚠️ [DOC LOAD] Failed to read last_page_viewed from matterDetailsTree:",
            e
          );
        }
      }

      // Prevent duplicate loads - check if already loading or loaded
      const loadingKey = `${activeTab}-${documentId}`;
      if (loadingDocumentRef.current === loadingKey) {
        // Already loading this document for this tab
        return;
      }

      // Check if instance exists and document is already loaded
      const existingInstance = webViewerInstances.getInstance(activeTab);
      if (existingInstance) {
        // Check if document is actually loaded in the instance
        const { documentViewer } = existingInstance.Core;
        const currentDoc = documentViewer?.getDocument();
        
        // Get the document ID from the loaded document if available
        let loadedDocumentId = null;
        if (currentDoc) {
          // Try to get document ID from document data or instance
          const tabDocumentData = webViewerInstances.getTabDocumentData(activeTab);
          loadedDocumentId = tabDocumentData?.id || tabDocumentData?.unique_id?.substring(1);
        }
        
        // Only skip loading if: instance exists, document is loaded, AND it's the same document
        if (currentDoc && loadedDocumentId && String(loadedDocumentId) === String(documentId)) {
          // Document is loaded and matches, just switch to the tab
          console.log(`✅ Document ${documentId} already loaded in tab ${activeTab}, switching...`);
          currentDocumentIdRef.current = documentId;
          webViewerInstances.switchToTab(activeTab);
          // Update documentDetail in Redux
          const tabDocumentData = webViewerInstances.getTabDocumentData(activeTab);
          if (tabDocumentData && documentDetail?.id !== documentId) {
            dispatch(updateDocumentDetail(tabDocumentData));
          }
        return;
        } else if (currentDoc) {
          // Instance exists with different document - need to load new document
          console.log(`⚠️ Instance exists for tab ${activeTab} but with different document (loaded: ${loadedDocumentId}, requested: ${documentId}), will reload...`);
        } else {
          // Instance exists but document not loaded - need to load it
          console.log(`⚠️ Instance exists for tab ${activeTab} but document not loaded, will load...`);
        }
      }

      // Mark as loading
      loadingDocumentRef.current = loadingKey;

      // Use documentRecord - matterDetailsTree is updated when closing tabs, so it should have latest last_page_viewed
      let documentData = documentRecord;

      // If documentDetail in Redux has data for this document, merge it (but preserve last_page_viewed from documentRecord)
      if (documentDetail?.id && String(documentDetail.id) === String(documentId)) {
        documentData = {
          ...documentDetail, // Use fresh data from Redux (has latest bookmarks, etc.)
          ...documentRecord, // Override with documentRecord (has latest last_page_viewed from matterDetailsTree)
          unique_id: documentRecord.unique_id, // Preserve unique_id from documentRecord
          // Storage identity must come from the fresh API detail, never the
          // cached tree row, so the loader and the tab-header SharePoint
          // banner (which reads documentDetail) always agree.
          ...freshStorageIdentity(documentDetail, documentRecord),
        };
        console.log(`✅ [DOC LOAD] Using documentRecord.last_page_viewed: ${documentData.last_page_viewed} (merged with documentDetail)`);
      } else {
        // documentDetail not available yet - use documentRecord (which has last_page_viewed from matterDetailsTree)
        console.log(`✅ [DOC LOAD] Using documentRecord.last_page_viewed: ${documentData.last_page_viewed}`);
      }

      // Kick off the presigned-URL fetch NOW, before WebViewer WASM init,
      // so the network round trip overlaps instance boot instead of
      // running after it (site-speed 2026-07-11). documentLoader falls
      // back to a fresh resolve if this promise fails, so a dangling or
      // rejected prefetch can never make loading worse. The .catch(()
      // => null) guard prevents an unhandled-rejection console error on
      // the early-return paths below that never consume the promise.
      // Decide off the merged documentData (the merge above is synchronous)
      // so a stale tree row can neither skip a needed prefetch nor trigger
      // a pointless one.
      const resolvedUrlPromise = documentLoader
        .resolveDocumentUrl(documentData)
        .catch(() => null);
      // Get or create container for this tab - retry if not ready
      let container = webViewerInstances.getContainer(activeTab);
      if (!container) {
        // Container not ready yet, wait a bit and retry
        console.log(`⏳ Container not ready for tab ${activeTab}, waiting...`);
        container = webViewerInstances.getContainer(activeTab);
        if (!container) {
          // Still not ready, wait a bit more
          console.log(`⏳ Container still not ready for tab ${activeTab}, waiting more...`);
          container = webViewerInstances.getContainer(activeTab);
          if (!container) {
            console.warn(`⚠️ Container not ready for tab ${activeTab} after retries - will retry on next render`);
            // Clear loading state so it can retry
            if (loadingDocumentRef.current === loadingKey) {
              loadingDocumentRef.current = null;
            }
            return;
          }
        }
      }
      console.log(`✅ Container found for tab ${activeTab}`);

      // Make container visible before initializing/loading
      webViewerInstances.makeContainerVisible(activeTab);
      
      // Ensure container is actually in the DOM and visible
      if (!container.parentElement) {
        console.warn(`⚠️ Container for tab ${activeTab} is not in the DOM yet`);
        return;
      }

      // Initialize instance if needed
      let instance = webViewerInstances.getInstance(activeTab);
      if (!instance) {
        console.log(`🔧 Initializing WebViewer instance for tab ${activeTab}...`);
        // Loader should already be set to true in openTab, but ensure it's set here too
        // (in case tab was opened via other means)
        if (!isInstanceLoading) {
          setIsInstanceLoading(true);
        }
        
        // Ensure container is visible before initializing (WebViewer needs visible container)
        // Set display once during initialization, then never change it to prevent layout jumps
        container.style.display = 'block';
        container.style.visibility = 'visible';
        container.style.opacity = '1';
        container.style.zIndex = '10';
        container.style.pointerEvents = 'auto';
        
        try {
          instance = await webViewerInstances.initializeTabInstance(activeTab, container);
          if (!instance) {
            console.error(`❌ Failed to initialize instance for tab ${activeTab}`);
            setIsInstanceLoading(false);
            // Clear loading state on failure
            if (loadingDocumentRef.current === loadingKey) {
              loadingDocumentRef.current = null;
            }
            return;
          }
          console.log(`✅ WebViewer instance initialized for tab ${activeTab}`);
          
          // Set view-only mode initially to prevent showing edit mode before document loads
          try {
            const { UI, Core } = instance;
            UI.setToolbarGroup('toolbarGroup-View');
            Core.annotationManager.enableReadOnlyMode();
            UI.disableElements([
              'annotationTools',
              'toolbarGroup-Annotate',
              'toolbarGroup-Edit',
              'toolbarGroup-Shapes',
              'toolbarGroup-Insert',
              'toolbarGroup-Forms',
              'toolbarGroup-FillAndSign',
            ]);
            console.log('🔒 Set initial view-only mode for instance');
          } catch (permError) {
            console.warn('⚠️ Could not set initial view-only mode:', permError);
          }
        } catch (error) {
          console.error(`❌ Error initializing instance for tab ${activeTab}:`, error);
          setIsInstanceLoading(false);
          // Clear loading state on error
          if (loadingDocumentRef.current === loadingKey) {
            loadingDocumentRef.current = null;
          }
          return;
        } finally {
          // Hide loader once instance is ready
          setIsInstanceLoading(false);
          }
        } else {
        // Instance already exists - make sure loader is hidden
        if (isInstanceLoading) {
          setIsInstanceLoading(false);
        }
        console.log(`✅ Using existing WebViewer instance for tab ${activeTab}`);
        // Ensure container is visible even if instance exists
        // Only set display if not already set, to avoid layout recalculation
        if (!container.style.display || container.style.display === 'none') {
          container.style.display = 'block';
        }
        container.style.visibility = 'visible';
        container.style.opacity = '1';
        container.style.zIndex = '10';
        container.style.pointerEvents = 'auto';
      }

      // Update document data in instance
      webViewerInstances.updateTabDocumentData(activeTab, documentData);

      // Configure permissions based on file type before document loads
      // This prevents showing edit mode for MS files during loading
      // Define currentFileType here so it's available in onDocumentLoaded callback
      const currentFileType = getFileType(documentData.file_type || documentRecord.file_type);
      if (currentFileType === "pdf") {
        ensureViewerWordSearch(instance, documentId);
      }
      try {
        const currentUserId = Number(localStorage.getItem("user_id"));
        // Use documentDetail if available, otherwise assume not locked
        const lockedByUserId = documentDetail?.locked_by;
        const isLocked = documentDetail?.is_locked || false;
        
        // Configure permissions based on file type (MS files should be view-only)
        configurePermissions(instance, isLocked, currentFileType, currentUserId, lockedByUserId);
        console.log(`🔒 Configured permissions before document load: ${currentFileType} file`);
      } catch (permError) {
        console.warn('⚠️ Could not configure permissions before document load:', permError);
      }

      // Check if document is already loaded - if so, just switch tabs
      const { documentViewer } = instance.Core;
      const currentDoc = documentViewer?.getDocument();
      const isDocumentAlreadyLoaded = currentDoc !== null && currentDoc !== undefined;
      
      if (isDocumentAlreadyLoaded) {
        // Document already loaded - just switch to this tab (resume rendering)
        webViewerInstances.switchToTab(activeTab);
        return;
      }

      // Document not loaded yet - keep rendering paused, just make container visible
      // Use makeContainerVisible to hide other containers and show this one
      webViewerInstances.makeContainerVisible(activeTab);
      
      // Keep rendering paused for the active tab until document loads
      // This prevents rendering conflicts during document loading
      documentViewer.pauseRendering?.();

      const setupAnnotationAndFormListeners = (inst, docId, docData, docRecord) => {
        const { annotationManager, documentViewer } = inst.Core;
        const fileType = getFileType(docData.file_type || docRecord.file_type);
        if (fileType !== 'pdf') return;
        const ANNOTATION_CHANGE_DEBOUNCE_MS = 300;
        const sendAnnotationUpdate = async () => {
          try {
            const documentIdForWS = documentDetail?.id || docId;
            const userId = Number(localStorage.getItem("user_id"));
            const xfdfCommand = await annotationManager.exportAnnotationCommand();
            dispatch(sendWebSocketMessage({
              type: 'annotation_change',
              document_id: Number(documentIdForWS),
              xfdf_command: xfdfCommand,
              user_id: userId,
            }));
          } catch (error) {
            console.error("[WS] Failed to send annotation/form change:", error);
          }
        };
        const annotationChangeHandler = async (annotations, action, options) => {
          if (options?.imported || isApplyingRemoteUpdate.current) return;
          if (["add", "modify", "delete"].includes(action)) {
            handleAutoSave(documentViewer, annotationManager, true, docId, docData.name);
            const debounce = annotationChangeDebounceRef.current;
            if (debounce.timerId) clearTimeout(debounce.timerId);
            debounce.documentId = docId;
            debounce.timerId = setTimeout(() => {
              debounce.timerId = null;
              sendAnnotationUpdate();
            }, ANNOTATION_CHANGE_DEBOUNCE_MS);
          }
        };
        const fieldChangeHandler = () => {
          if (isApplyingRemoteUpdate.current) return;
          handleAutoSave(documentViewer, annotationManager, true, docId, docData.name);
          const debounce = annotationChangeDebounceRef.current;
          if (debounce.timerId) clearTimeout(debounce.timerId);
          debounce.documentId = docId;
          debounce.timerId = setTimeout(() => {
            debounce.timerId = null;
            sendAnnotationUpdate();
          }, ANNOTATION_CHANGE_DEBOUNCE_MS);
        };
        annotationManager.addEventListener('annotationChanged', annotationChangeHandler);
        annotationManager.addEventListener('fieldChanged', fieldChangeHandler);
        annotationListenerRef.current = {
          handler: annotationChangeHandler,
          fieldChangeHandler,
          documentId: docId,
          annotationManager,
          documentViewer
        };
      };

      // Capture bookmarks from documentData at load time to avoid stale-closure issues.
      // For large files, documentLoaded fires long after this point, by which time
      const capturedDocId = documentId;
      const capturedBookmarks = documentData?.bookmarks;
      const stableFetchBookmarksAPI = async (reqId) => {
        if (!reqId) return null;
        if (capturedBookmarks && reqId.toString() === capturedDocId.toString()) {
          const apiPayload = capturedBookmarks;
          return (
            apiPayload?.bookmarks?.[0] ??
            (apiPayload && typeof apiPayload === "object" && !Array.isArray(apiPayload)
              ? apiPayload
              : null)
          );
        }
        // Fallback: delegate to the live fetchBookmarksAPI (reads current documentDetail)
        return fetchBookmarksAPI(reqId);
      };

      // Load document using the hook (streaming: true, no caching)
      try {
        await documentLoader.loadDocument(instance, documentData, {
          tabId: activeTab,
          resolvedUrlPromise,
          onDocumentLoaded: async () => {
            // Get documentViewer from instance again (to avoid scope issues in async callback)
            const { documentViewer: loadedDocViewer } = instance.Core;
            if (!loadedDocViewer) {
              console.error('❌ documentViewer not available in onDocumentLoaded');
              return;
            }
            
            // Set zoom to 100% immediately to prevent zoom glitches for both PDF and MS files
            // This must be done BEFORE resumeRendering to prevent auto-fit zoom adjustments
            // currentFileType is available from outer scope.
            if (currentFileType === 'office' || currentFileType === 'pdf' || currentFileType === 'image') {
              try {
                if (instance.UI?.setZoomLevel) {
                  instance.UI.setZoomLevel(1.0);
                }
                if (instance.UI?.setFitMode) {
                  instance.UI.setFitMode(instance.UI.FitMode.Zoom);
                }
              } catch (zoomError) {
                console.warn('⚠️ Could not set zoom level for file:', zoomError);
              }
            }
            
            // Set currentDocumentIdRef BEFORE any page operations so
            // page change events can correctly validate the active document.
            currentDocumentIdRef.current = documentId;
            
            // Resume rendering after document is loaded
            loadedDocViewer.resumeRendering?.();
            
            // Now switch to tab (this will properly manage rendering and restore page/zoom)
            webViewerInstances.switchToTab(activeTab);

            // A citation-driven open owns the landing page. Resolve it
            // BEFORE the last-viewed-page restore below is even
            // scheduled, and when one exists skip that restore
            // entirely: the two used to race on 100 ms / 300 ms timers
            // and "last page viewed" (the note index, on a VAMC
            // record) kept winning. ``landOnCitation`` re-asserts the
            // cited page until the viewer confirms it, then highlights
            // the quote on that page.
            const citationLanding = resolveCitationLanding(documentId, {
              highlightMetadata: location.state?.highlightMetadata,
            });
            if (citationLanding) {
              console.log(
                `📌 [CITATION LANDING] document ${documentId} -> page ${citationLanding.page}`
              );
              landOnCitation(instance, citationLanding);
            }
            
            // Restore page from fresh documentData (just fetched from API) or documentDetail Redux state
            // Priority: documentData.last_page_viewed (freshly fetched) > documentDetail.last_page_viewed (Redux state)
            // documentData is guaranteed to be fresh since we just fetched it from API before loading
            if (!citationLanding) setTimeout(() => {
              let targetPage = null;
              
              // First, check documentData - this was just fetched fresh from API, so it has the latest last_page_viewed
              if (documentData?.last_page_viewed) {
                const parsedPage = parseInt(documentData.last_page_viewed, 10);
                if (parsedPage && parsedPage > 0) {
                  targetPage = parsedPage;
                  console.log(`📄 [RESTORE PAGE] Using documentData.last_page_viewed (fresh from API): ${targetPage} for document ${documentId}`);
                }
              }
              
              // Fallback to documentDetail from Redux state if documentData doesn't have last_page_viewed
              if (!targetPage && documentDetail?.id === documentId && documentDetail?.last_page_viewed) {
                const parsedPage = parseInt(documentDetail.last_page_viewed, 10);
                if (parsedPage && parsedPage > 0) {
                  targetPage = parsedPage;
                  console.log(`📄 [RESTORE PAGE] Using documentDetail.last_page_viewed from Redux: ${targetPage} for document ${documentId}`);
                }
              }
              
              if (targetPage && targetPage > 0) {
                // currentFileType already defined above
                documentLoader.restorePage(instance, targetPage, currentFileType);
              } else {
                console.log(`📄 [RESTORE PAGE] No valid page found for document ${documentId}, starting at page 1`);
              }
            }, 100);

            // Configure permissions
            const currentUserId = Number(localStorage.getItem("user_id"));
            const lockedByUserId = documentDetail?.locked_by;
            const isLocked = documentDetail?.is_locked;
            // currentFileType already defined above
            configurePermissions(instance, isLocked, currentFileType, currentUserId, lockedByUserId);

            // Chat-navigation highlight metadata is now consumed by
            // ``resolveCitationLanding`` above (page + quote, confirmed
            // landing); the old 300 ms ``performTextHighlighting`` pass
            // here was the second hand on the wheel and is gone.

            // Initialize firstLoad for AutoSave (only for PDFs)
            if (currentFileType === 'pdf') {
              // Mark ready right after document init so first user edit shows autosave.
              firstLoadRef.current.set(documentId, true);
              // Setup annotation + form field listeners INSIDE onDocumentLoaded so form fields are ready
              setupAnnotationAndFormListeners(instance, documentId, documentData, documentRecord);

              // Empty-field highlighting + format validators + field-audit
              // wiring for documents freshly created from a Formstack template.
              //
              // All three are scoped to the direct-merge path (Bugbot PR #66,
              // Medium): generic uploaded PDFs may legitimately have form-field
              // names like `date` or `tel` that the classifier would match —
              // installing the validator on every PDF would silently rewrite a
              // user's input and pop unexpected antd warning toasts on docs
              // that have nothing to do with our template flow.
              //
              // Trigger exclusively off the navigation-state flag set by the
              // direct-merge flow in UploadButtonUtils.openFile; do not infer
              // template-origin from document metadata because re-opens of an
              // older template-created doc should not re-light-up fields the
              // user intentionally left blank, and must not double-audit
              // values the user edited in a previous session.
              const shouldHighlightMergeFields =
                location.state?.fromTemplateMerge === true
                && !templateMergeDecoratedRef.current.has(documentId);
              if (shouldHighlightMergeFields) {
                templateMergeDecoratedRef.current.add(documentId);

                try {
                  const previousValidatorCleanup =
                    fieldValidatorCleanupsRef.current.get(documentId);
                  previousValidatorCleanup?.();
                  const validatorCleanup = installFieldFormatValidators(instance);
                  if (validatorCleanup) {
                    fieldValidatorCleanupsRef.current.set(documentId, validatorCleanup);
                  }
                } catch (validatorErr) {
                  console.warn('[field-format-validators] install failed:', validatorErr);
                }

                try {
                  const previousDecorationCleanup =
                    fieldDecorationCleanupsRef.current.get(documentId);
                  previousDecorationCleanup?.();
                  const decorationCleanup = highlightEmptyMergeFields(instance);
                  if (typeof decorationCleanup === 'function') {
                    fieldDecorationCleanupsRef.current.set(documentId, decorationCleanup);
                  }
                } catch (decorateErr) {
                  console.warn('[template-merge-decorations] apply failed:', decorateErr);
                }

                try {
                  const previousAuditCleanup = fieldAuditCleanupsRef.current.get(documentId);
                  previousAuditCleanup?.();
                  const auditCleanup = installFieldAuditListener(
                    instance,
                    documentId,
                    location.state?.mergedFieldValues || {},
                  );
                  if (auditCleanup) fieldAuditCleanupsRef.current.set(documentId, auditCleanup);
                } catch (auditErr) {
                  console.warn('[template-merge-audit] install failed:', auditErr);
                }
              }
            }

            // Setup page change listener INSIDE onDocumentLoaded to ensure documentViewer is ready.
            // This is especially important for MS Office files which need the document to be fully loaded
            // before the pageNumberUpdated event can fire reliably.
            pageChangeListenerRef.current = {
              handler: null,
              documentId: documentId,
              timer: null
            };
            
        const pageChangeHandler = (newPageNumber) => {
          // Clear existing timer if any
          if (pageChangeListenerRef.current?.timer) {
            clearTimeout(pageChangeListenerRef.current.timer);
            pageChangeListenerRef.current.timer = null;
          }
          
              const hasValidPageNumber = newPageNumber && newPageNumber > 0;
              const isCorrectDocument = currentDocumentIdRef.current === documentId;
              if (hasValidPageNumber && isCorrectDocument) {
            // Update localStorage immediately (for quick reopen scenarios)
            localStorage.setItem('lastPageViewed', String(newPageNumber));
            localStorage.setItem('lastPageViewedDoc', String(documentId));
            
            // Debounce API call (1 second delay)
            pageChangeListenerRef.current.timer = setTimeout(() => {
                  const isCorrectDocInDebounce = currentDocumentIdRef.current === documentId;
                  const isActiveTabInDebounce = activeTab === `D${documentId}`;
                  
                  if (isCorrectDocInDebounce && isActiveTabInDebounce) {
                    dispatch(postLastPageViewed({ docId: documentId, page_number: newPageNumber }));
                  }
                  
              // Clear timer reference after execution
              if (pageChangeListenerRef.current && pageChangeListenerRef.current.documentId === documentId) {
                pageChangeListenerRef.current.timer = null;
              }
            }, 1000);
          }
        };
        
        // Store handler reference and attach listener using the loaded documentViewer
        pageChangeListenerRef.current.handler = pageChangeHandler;
            try {
              loadedDocViewer.addEventListener('pageNumberUpdated', pageChangeHandler);
            } catch (error) {
              console.error('❌ Failed to attach pageNumberUpdated listener:', error);
            }
          },
          onLoadError: (error) => {
            console.error('❌ Document load error:', error);
            // Resume rendering even on error (so UI doesn't freeze)
            // Get documentViewer from instance to avoid scope issues
            const { documentViewer: errorDocViewer } = instance.Core;
            errorDocViewer?.resumeRendering?.();
            // When the backend has told us why a document cannot be shown,
            // pass that on. Logging it to the console left the reader
            // watching a spinner with no idea the record was incomplete.
            if (isDeliberateRefusal(error)) {
              dispatch(addNotification({
                id: Date.now().toString(),
                newMsg: error.message,
                success: false,
              }));
            }
          },
          fetchBookmarksAPI: stableFetchBookmarksAPI,
          addBookmarksAPI,
          dispatch,
          sendWebSocketMessage,
        });

        // Setup bookmark listener
        const bookmarkCleanup = documentLoader.setupBookmarkListener(
          instance,
          documentId,
          addBookmarksAPI,
          dispatch,
          sendWebSocketMessage,
          documentDetail,
          showAutoSaveIndicator
        );
        if (bookmarkCleanup) {
          bookmarkListenerRef.current = { cleanup: bookmarkCleanup, documentId };
        }

        // Setup pagesUpdated listener for INSERT, REORDER and REMOVE in thumbnail pane (PDF page manipulation)
        const currentFileTypeForPages = getFileType(documentData.file_type || documentRecord.file_type);
        if (currentFileTypeForPages === 'pdf') {
          const pagesUpdatedHandler = (changesOrEvent) => {
            const changes = changesOrEvent?.detail?.changes ?? changesOrEvent;
            if (!changes) return;
            if (currentDocumentIdRef.current !== documentId) return;

            const documentIdForWS = documentDetail?.id || documentId;
            const userId = Number(localStorage.getItem("user_id"));
            const getCurrentState = () => ({
              page_count: documentViewer.getPageCount(),
              current_page: documentViewer.getCurrentPage(),
            });

            const pageInsertBatch = () => {
              const batch = insertBatchRef.current;
              if (batch.timerId) clearTimeout(batch.timerId);
              batch.timerId = null;
              if (batch.pages.length && batch.documentId === documentId) {
                const pagesAdded = [...new Set(batch.pages)].sort((a, b) => a - b);
                const payload = changesOrEvent?.detail ?? changesOrEvent;
                const current = getCurrentState();
                console.log('📄 [PAGES UPDATED] INSERTED | Pages:', pagesAdded);
                dispatch(sendWebSocketMessage({
                  type: 'page_added',
                  document_id: Number(documentIdForWS),
                  pages_added: pagesAdded,
                  user_id: userId,
                  payload,
                  changes,
                  current,
                }));
                const documentName = documentDetail?.name || documentData?.name || "Document";
                showAutoSaveIndicator(documentName);
              }
              batch.pages = [];
              batch.documentId = null;
            };

            const pageReorderBatch = () => {
              const batch = reorderBatchRef.current;
              if (batch.timerId) clearTimeout(batch.timerId);
              batch.timerId = null;
              if (batch.moves.length && batch.documentId === documentId) {
                const payload = changesOrEvent?.detail ?? changesOrEvent;
                const current = getCurrentState();
                console.log('📄 [PAGES UPDATED] REORDERED | moves:', batch.moves);
                dispatch(sendWebSocketMessage({
                  type: 'page_reordered',
                  document_id: Number(documentIdForWS),
                  moves: batch.moves,
                  user_id: userId,
                  payload,
                  changes,
                  current,
                }));
                const documentName = documentDetail?.name || documentData?.name || "Document";
                showAutoSaveIndicator(documentName);
              }
              batch.moves = [];
              batch.documentId = null;
            };

            const extractMove = (rawMapping) => {
              const entries = Object.entries(rawMapping).map(([k, v]) => ({ from: Number(k), to: Number(v) }));
              if (!entries.length) return null;
              const moved = entries.find(e => Math.abs(e.to - e.from) > 1);
              if (moved) return moved;
              return entries.find(e => e.to - e.from === 1) || entries[0];
            };

            const pageRemoveBatch = () => {
              const batch = removeBatchRef.current;
              if (batch.timerId) clearTimeout(batch.timerId);
              batch.timerId = null;
              if (batch.pages.length && batch.documentId === documentId) {
                const pagesRemoved = [...new Set(batch.pages)].sort((a, b) => a - b);
                const payload = changesOrEvent?.detail ?? changesOrEvent;
                const current = getCurrentState();
                console.log('📄 [PAGES UPDATED] REMOVED | Pages:', pagesRemoved);
                dispatch(sendWebSocketMessage({
                  type: 'page_removed',
                  document_id: Number(documentIdForWS),
                  pages_removed: pagesRemoved,
                  user_id: userId,
                  payload,
                  changes,
                  current,
                }));
                const documentName = documentDetail?.name || documentData?.name || "Document";
                showAutoSaveIndicator(documentName);
              }
              batch.pages = [];
              batch.documentId = null;
            };

            if (Array.isArray(changes)) {
              // Skip reorder if the same event also contains an insert or remove —
              // those cascade-shift entries are a side effect, not a real user reorder.
              const hasInsertOrRemove = changes.some(
                (c) => c.type === 'inserted' || c.type === 'removed'
              );
              changes.forEach((change) => {
                if (change.type === 'inserted') {
                  const pagesAdded = change.pages || [];
                  if (pagesAdded.length) {
                    const batch = insertBatchRef.current;
                    if (batch.documentId !== documentId) {
                      if (batch.timerId) clearTimeout(batch.timerId);
                      batch.pages = [];
                      batch.documentId = documentId;
                    }
                    batch.pages.push(...pagesAdded);
                    if (batch.timerId) clearTimeout(batch.timerId);
                    batch.timerId = setTimeout(pageInsertBatch, 150);
                  }
                } else if (change.type === 'reordered' && !hasInsertOrRemove) {
                  const rawMapping = change.pages_reordered ?? change.moved ?? (change.pages ? { [change.pages[0]]: change.pages[1] } : {});
                  const move = extractMove(rawMapping);
                  if (move) {
                    const batch = reorderBatchRef.current;
                    if (batch.documentId !== documentId) {
                      if (batch.timerId) clearTimeout(batch.timerId);
                      batch.moves = [];
                      batch.documentId = documentId;
                    }
                    batch.moves.push(move);
                    if (batch.timerId) clearTimeout(batch.timerId);
                    batch.timerId = setTimeout(pageReorderBatch, 150);
                  }
                } else if (change.type === 'removed') {
                  const pagesRemoved = change.pages || [];
                  if (pagesRemoved.length) {
                    const batch = removeBatchRef.current;
                    if (batch.documentId !== documentId) {
                      if (batch.timerId) clearTimeout(batch.timerId);
                      batch.pages = [];
                      batch.documentId = documentId;
                    }
                    batch.pages.push(...pagesRemoved);
                    if (batch.timerId) clearTimeout(batch.timerId);
                    batch.timerId = setTimeout(pageRemoveBatch, 150);
                  }
                }
              });
            } else {
              const hasInsertOrRemove = changes.added?.length || changes.removed?.length;
              if (changes.added?.length) {
                const batch = insertBatchRef.current;
                if (batch.documentId !== documentId) {
                  if (batch.timerId) clearTimeout(batch.timerId);
                  batch.pages = [];
                  batch.documentId = documentId;
                }
                batch.pages.push(...changes.added);
                if (batch.timerId) clearTimeout(batch.timerId);
                batch.timerId = setTimeout(pageInsertBatch, 150);
              }
              if (changes.moved && Object.keys(changes.moved).length && !hasInsertOrRemove) {
                const move = extractMove(changes.moved);
                if (move) {
                  const batch = reorderBatchRef.current;
                  if (batch.documentId !== documentId) {
                    if (batch.timerId) clearTimeout(batch.timerId);
                    batch.moves = [];
                    batch.documentId = documentId;
                  }
                  batch.moves.push(move);
                  if (batch.timerId) clearTimeout(batch.timerId);
                  batch.timerId = setTimeout(pageReorderBatch, 150);
                }
              }
              if (changes.removed?.length) {
                const batch = removeBatchRef.current;
                if (batch.documentId !== documentId) {
                  if (batch.timerId) clearTimeout(batch.timerId);
                  batch.pages = [];
                  batch.documentId = documentId;
                }
                batch.pages.push(...changes.removed);
                if (batch.timerId) clearTimeout(batch.timerId);
                batch.timerId = setTimeout(pageRemoveBatch, 150);
              }
            }
          };
          documentViewer.addEventListener('pagesUpdated', pagesUpdatedHandler);
          pagesUpdatedListenerRef.current = { handler: pagesUpdatedHandler, documentId, documentViewer };
        }

        // Lock document if needed
        const currentUserId = Number(localStorage.getItem("user_id"));
        const isLockedByCurrentUser = documentData?.is_locked === true && documentData?.locked_by === currentUserId;
        const isNotLocked = documentData?.is_locked === null || documentData?.is_locked === false;
        const isLockedByOtherUser = documentData?.is_locked === true && documentData?.locked_by !== currentUserId;
        
        if ((isNotLocked || isLockedByOtherUser) && !isLockedByCurrentUser) {
          if (!lockedDocsRef.current.has(documentId)) {
            try {
              const lockResult = await dispatch(editPDFsLock(documentId));
              if (lockResult.payload?.status === 200) {
                lockedDocsRef.current.add(documentId);
                if (documentId == documentDetail?.id) {
                  dispatch(updateDocumentDetail({ 
                    locked_by: lockResult.payload?.data?.locked_by || currentUserId, 
                    is_locked: true 
                  }));
                }
              }
            } catch (error) {
              console.error(`❌ Failed to lock document ${documentId}:`, error);
            }
          }
        }

        // Update current document ID
        // NOTE: This is now set earlier in onDocumentLoaded callback to ensure it's available
        // when page change events fire during page restoration. This line is kept as a fallback
        // for cases where onDocumentLoaded might not fire, but it should already be set.
        if (currentDocumentIdRef.current !== documentId) {
          console.log(`⚠️ [DOC LOAD] currentDocumentIdRef was not set in onDocumentLoaded, setting now: ${documentId}`);
          currentDocumentIdRef.current = documentId;
        }
        
        // Update documentDetail in Redux if it doesn't match
        if (documentDetail?.id !== documentId) {
          dispatch(updateDocumentDetail(documentData));
            }
          } catch (error) {
        console.error(`❌ Failed to load document ${documentId}:`, error);
        // Resume rendering even on error (so UI doesn't freeze)
        if (instance?.Core?.documentViewer) {
          instance.Core.documentViewer.resumeRendering?.();
        }
        currentDocumentIdRef.current = null;
      } finally {
        // Clear loading state
        if (loadingDocumentRef.current === loadingKey) {
          loadingDocumentRef.current = null;
        }
      }
    };

    loadDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]); // Only depend on activeTab - other dependencies are stable or accessed via refs

  // Handle tab switching - ensure containers are properly shown/hidden
  // This works for both document tabs and matter list tabs ("1" or "0")
  useEffect(() => {
    if (!activeTab) {
            return;
          }

    // For matter list tabs ("1" or "0"), switchToTab will hide all WebViewer containers
    // For document tabs, switchToTab will show the active one and hide others
    webViewerInstances.switchToTab(activeTab);
    
    // Also show/hide the outer containers (which include breadcrumbs and share buttons)
    // Use opacity/visibility only to prevent layout jumps - keep display consistent
    tabs.filter(tab => tab.id !== "1" && tab.id !== "0").forEach(tab => {
      const outerContainer = document.getElementById(`webviewer-container-${tab.id}`);
      if (outerContainer) {
        // Ensure display is set to 'flex' initially, then never change it
        if (!outerContainer.style.display || outerContainer.style.display === 'none') {
          outerContainer.style.display = 'flex';
        }
        
        if (activeTab === tab.id) {
          outerContainer.style.visibility = 'visible';
          outerContainer.style.opacity = '1';
          outerContainer.style.pointerEvents = 'auto';
        } else if (activeTab === "1" || activeTab === "0") {
          // Hide all when on matter list tab - but keep display to prevent layout jumps
          outerContainer.style.visibility = 'hidden';
          outerContainer.style.opacity = '0';
          outerContainer.style.pointerEvents = 'none';
          } else {
          // Hide inactive document tabs - but keep display to prevent layout jumps
          outerContainer.style.visibility = 'hidden';
          outerContainer.style.opacity = '0';
          outerContainer.style.pointerEvents = 'none';
        }
      }
    });
  }, [activeTab, webViewerInstances, tabs]);

  // Reconfigure permissions when document lock status changes (via WebSocket updates)
  useEffect(() => {
    // Only reconfigure if we have a document open
    if (!currentDocumentIdRef.current || !documentDetail || !activeTab || activeTab === "1" || activeTab === "0") {
      return;
    }

    // Check if the current document matches the documentDetail
    const documentId = currentDocumentIdRef.current;
    const documentDetailId = documentDetail?.id || documentDetail?.unique_id?.substring(1);
    
    if (String(documentId) !== String(documentDetailId)) {
      return;
    }

    // Get instance for active tab
    const instance = webViewerInstances.getInstance(activeTab);
    if (!instance) return;

    // Get file type from documentDetail
    const currentFileType = getFileType(documentDetail?.file_type) || 'pdf';
    const currentUserId = Number(localStorage.getItem("user_id"));
    const lockedByUserId = documentDetail?.locked_by;
    const isLocked = documentDetail?.is_locked;
    
    configurePermissions(
      instance,
      isLocked,
      currentFileType,
      currentUserId,
      lockedByUserId
    );
  }, [documentDetail?.is_locked, documentDetail?.locked_by, activeTab, currentDocumentIdRef.current, webViewerInstances]);

  // Handle incoming annotation updates from WebSocket
  useEffect(() => {
    if (!annotationUpdate || !activeTab || activeTab === "1" || activeTab === "0") {
      return;
    }

    const instance = webViewerInstances.getInstance(activeTab);
    if (!instance) {
      return;
    }

    // Get current file type
    const activeTabData = tabs.find(tab => tab.id === activeTab);
    if (!activeTabData || activeTabData.id === "1" || activeTabData.id === "0") {
      return;
    }

    // Extract documentRecord from tab
    let documentRecord = null;
    if (activeTabData.documentRecord) {
      documentRecord = activeTabData.documentRecord;
    } else if (activeTabData.content && typeof activeTabData.content === 'object' && activeTabData.content.props) {
      documentRecord = activeTabData.content.props.documentRecord;
    }

    if (!documentRecord) {
      return;
    }

    const currentFileType = getFileType(documentRecord.file_type);
    
    // Only handle annotation updates for PDFs
    if (currentFileType !== 'pdf') {
      dispatch(clearAnnotationUpdate());
      return;
    }

    const currentDocumentId = documentDetail?.id || documentRecord.unique_id.substring(1);
    
    // Only apply updates for the current document
    if (String(annotationUpdate.document_id) !== String(currentDocumentId)) {
      return;
    }

    // Don't apply updates from the current user (they already made the change)
    const currentUserId = Number(localStorage.getItem("user_id"));
    if (annotationUpdate.user_id === currentUserId) {
      dispatch(clearAnnotationUpdate());
      return;
    }

    const { annotationManager } = instance.Core;
    
    try {
      console.log("[WS] Applying remote annotation update:", annotationUpdate);
      
      // Set flag to prevent sending this update back to server
      isApplyingRemoteUpdate.current = true;
      
      // Import and draw the annotation from XFDF command
      annotationManager.importAnnotationCommand(annotationUpdate.xfdf_command)
        .then((annotations) => {
          annotationManager.drawAnnotationsFromList(annotations);
          console.log("[WS] Remote annotations applied successfully");
          isApplyingRemoteUpdate.current = false;
        })
        .catch((error) => {
          console.error("[WS] Failed to apply remote annotations:", error);
          isApplyingRemoteUpdate.current = false;
        });
      
      // Clear the update after processing
      dispatch(clearAnnotationUpdate());
    } catch (error) {
      console.error("[WS] Error processing annotation update:", error);
      isApplyingRemoteUpdate.current = false;
      dispatch(clearAnnotationUpdate());
    }
  }, [annotationUpdate, documentDetail?.id, activeTab, tabs, dispatch, webViewerInstances]);

  // Handle incoming document content updates from WebSocket (e.g., letterhead added)
  // NOTE: This useEffect is implemented later in the file (around line 3023)
  // The duplicate block here was removed as it contained old singleton code

  // Reconfigure permissions when document lock status changes (via WebSocket updates)
  useEffect(() => {
    // Only reconfigure if we have a document open
    if (!currentDocumentIdRef.current || !documentDetail || !activeTab || activeTab === "1" || activeTab === "0") {
      return;
    }

    // Check if the current document matches the documentDetail
    const documentId = currentDocumentIdRef.current;
    const documentDetailId = documentDetail?.id || documentDetail?.unique_id?.substring(1);
    
    if (String(documentId) !== String(documentDetailId)) {
      return;
    }

    // Get instance for active tab
    const instance = webViewerInstances.getInstance(activeTab);
    if (!instance) return;

    // Get file type from documentDetail
    const currentFileType = getFileType(documentDetail?.file_type) || 'pdf';
    const currentUserId = Number(localStorage.getItem("user_id"));
    const lockedByUserId = documentDetail?.locked_by;
    const isLocked = documentDetail?.is_locked;
    
    configurePermissions(
      instance,
      isLocked,
      currentFileType,
      currentUserId,
      lockedByUserId
    );
  }, [documentDetail?.is_locked, documentDetail?.locked_by, activeTab, currentDocumentIdRef.current, webViewerInstances]);

  // Handle incoming annotation updates from WebSocket
  useEffect(() => {
    if (!annotationUpdate || !activeTab || activeTab === "1" || activeTab === "0") {
      return;
    }

    const instance = webViewerInstances.getInstance(activeTab);
    if (!instance) {
      return;
    }

    // Get current file type
    const activeTabData = tabs.find(tab => tab.id === activeTab);
    if (!activeTabData || activeTabData.id === "1" || activeTabData.id === "0") {
      return;
    }

    // Extract documentRecord from tab
    let documentRecord = null;
    if (activeTabData.documentRecord) {
      documentRecord = activeTabData.documentRecord;
    } else if (activeTabData.content && typeof activeTabData.content === 'object' && activeTabData.content.props) {
      documentRecord = activeTabData.content.props.documentRecord;
    }

    if (!documentRecord) {
      return;
    }

    const currentFileType = getFileType(documentRecord.file_type);
    
    // Only handle annotation updates for PDFs
    if (currentFileType !== 'pdf') {
      dispatch(clearAnnotationUpdate());
      return;
    }

    const currentDocumentId = documentDetail?.id || documentRecord.unique_id.substring(1);
    
    // Only apply updates for the current document
    if (String(annotationUpdate.document_id) !== String(currentDocumentId)) {
      return;
    }

    // Don't apply updates from the current user (they already made the change)
    const currentUserId = Number(localStorage.getItem("user_id"));
    if (annotationUpdate.user_id === currentUserId) {
      dispatch(clearAnnotationUpdate());
      return;
    }

    const { annotationManager } = instance.Core;
    
    try {
      console.log("[WS] Applying remote annotation update:", annotationUpdate);
      
      // Set flag to prevent sending this update back to server
      isApplyingRemoteUpdate.current = true;
      
      // Import and draw the annotation from XFDF command
      annotationManager.importAnnotationCommand(annotationUpdate.xfdf_command)
        .then((annotations) => {
          annotationManager.drawAnnotationsFromList(annotations);
          console.log("[WS] Remote annotations applied successfully");
          isApplyingRemoteUpdate.current = false;
        })
        .catch((error) => {
          console.error("[WS] Failed to apply remote annotations:", error);
          isApplyingRemoteUpdate.current = false;
        });
      
      // Clear the update after processing
      dispatch(clearAnnotationUpdate());
              } catch (error) {
      console.error("[WS] Error processing annotation update:", error);
      isApplyingRemoteUpdate.current = false;
      dispatch(clearAnnotationUpdate());
    }
  }, [annotationUpdate, documentDetail?.id, activeTab, tabs, dispatch, webViewerInstances]);

  // Handle incoming document content updates from WebSocket (e.g., letterhead added)
  useEffect(() => {
    if (!documentContentUpdate || !activeTab || activeTab === "1" || activeTab === "0") {
            return;
          }
          
    const instance = webViewerInstances.getInstance(activeTab);
    if (!instance) {
      return;
    }

    // Get current document info
    const activeTabData = tabs.find(tab => tab.id === activeTab);
    if (!activeTabData || activeTabData.id === "1" || activeTabData.id === "0") {
      dispatch(clearDocumentContentUpdate());
      return;
    }

    // Extract documentRecord from tab
    let documentRecord = null;
    if (activeTabData.documentRecord) {
      documentRecord = activeTabData.documentRecord;
    } else if (activeTabData.content && typeof activeTabData.content === 'object' && activeTabData.content.props) {
      documentRecord = activeTabData.content.props.documentRecord;
    }

    if (!documentRecord) {
      dispatch(clearDocumentContentUpdate());
      return;
    }

    const currentFileType = getFileType(documentRecord.file_type);
    
    // Only handle content updates for PDFs
    if (currentFileType !== 'pdf') {
      dispatch(clearDocumentContentUpdate());
      return;
    }

    const currentDocumentId = documentDetail?.id || documentRecord.unique_id.substring(1);
    
    // Only reload if this is for the current document
    if (String(documentContentUpdate.document_id) !== String(currentDocumentId)) {
      return;
    }

    // Don't reload if this update is from the current user (they already have the updated document)
    const currentUserId = Number(localStorage.getItem("user_id"));
    if (documentContentUpdate.user_id === currentUserId) {
      dispatch(clearDocumentContentUpdate());
      return;
    }

    // Reload the document from the server to get the updated content (e.g., letterhead)
    const reloadDocument = async () => {
      try {
        console.log("[WS] Reloading document due to content update:", documentContentUpdate);
        
        // Get instance for active tab
        const tabInstance = webViewerInstances.getInstance(activeTab);
        if (!tabInstance) {
          console.warn("[WS] No instance available for active tab, skipping reload");
          dispatch(clearDocumentContentUpdate());
          return;
        }
        
        // Fetch fresh document data to get updated streaming URL
        const result = await dispatch(getDocumentDetails(currentDocumentId));
        addBookmarksCache(result, currentDocumentId);
        if (result.type === 'getDocumentDetails/fetch/rejected') {
          throw new Error('Failed to fetch document details');
        }

        const documentData = result.payload?.data;
        if (!documentData) {
          throw new Error('No document data received');
        }

        // Get the updated streaming URL using new format
        const documentId = documentData.id || currentDocumentId;
        const documentPath = getDocumentStreamingUrl(documentId);

        // Add cache-busting parameter to ensure we get the latest version
        const url = new URL(documentPath);
        url.searchParams.set('_cb', `${currentDocumentId}_${Date.now()}`);
        const cacheBustedUrl = url.toString();

        console.log("[WS] Reloading document from:", cacheBustedUrl);

        // Reload the document using the document loader
        await documentLoader.loadDocument(
          activeTab,
          documentRecord,
          documentData
        );
        
        console.log("[WS] Document reloaded successfully after content update");
          } catch (error) {
        console.error("[WS] Failed to reload document after content update:", error);
      } finally {
        // Clear the update after processing
        dispatch(clearDocumentContentUpdate());
      }
    };

    reloadDocument();
  }, [documentContentUpdate, documentDetail?.id, activeTab, tabs, dispatch, webViewerInstances, documentLoader, fetchBookmarksAPI, getFileType]);
  // True when ``highlightMetadata`` may act on the active tab: either it
  // names no document (older chat payloads) or it names this one. A
  // citation click that opens ANOTHER document navigates while the
  // old tab is still active; without this check the listeners below
  // used to jump the old document to the new citation's page.
  const highlightMetadataTargetsActiveTab = useCallback((highlightMetadata) => {
    if (!Array.isArray(highlightMetadata) || !activeTab) return false;
    const named = highlightMetadata.find((m) => m && m.documentId != null);
    if (!named) return true;
    return `D${String(named.documentId)}` === activeTab || String(named.documentId) === activeTab;
  }, [activeTab]);

useEffect(()=>{  
  
  if(location.state?.highlightMetadata && highlightMetadataTargetsActiveTab(location.state.highlightMetadata)){
   const fileType = getFileType(documentDetail.file_type);
   const tabInstance = webViewerInstances.getInstance(activeTab);
    if(tabInstance?.Core){
   const { documentViewer } = tabInstance?.Core;
  
   performTextHighlighting(location.state?.highlightMetadata,documentViewer,tabInstance,fileType)}
    }
  console.log("highlightMetadata",location.state?.highlightMetadata) },[location])
  // Reusable function to perform text highlighting
  const performTextHighlighting = useCallback((highlightMetadata, documentViewer, instance, fileType) => {
    if (!highlightMetadata || !Array.isArray(highlightMetadata) || highlightMetadata.length === 0 || fileType !== 'pdf') {
      console.log('ℹ️ Skipping highlighting - invalid metadata or not PDF');
      return;
    }
    
    if (!instance || !documentViewer) {
      console.warn('⚠️ Cannot highlight - instance or documentViewer not available');
      return;
    }
    
    console.log('🎯 Starting text highlighting for metadata:', highlightMetadata);
    
  const splitIntoChunks = (text, size = 8) => {
  const words = text.split(" ");
  const chunks = [];

  for (let i = 0; i < words.length; i += size) {
    chunks.push(words.slice(i, i + size).join(" "));
  }

  return chunks;
};
const normalizeText = (text) => {
  return text
    .replace(/\n/g, " ")
    .replace(/[_\-]/g, "")
    .replace(/\s+/g, " ")
    .toLowerCase()
    .trim();
};

const advancedFuzzySearch = async(originalTarget, originalPattern,page)=> {

  // The previous panel-based path destructured ``UI`` to hide the
  // search panel and ``Annotations`` / ``annotationManager`` /
  // ``doc`` to draw highlights manually. The headless path delegates
  // all of that to ``applySearchHighlight`` (panel hygiene +
  // ``Core.documentViewer.textSearchInit`` + Apryse-rendered yellow
  // band), so this body now only needs the raw ``instance`` to pass
  // through.

    // 1. Create a Mapping
    // We store the original index for every character that survives normalization
    let cleanTarget = "";
    let indexMap = [];

    for (let i = 0; i < originalTarget.length; i++) {
        const char = originalTarget[i];
        // If it's not a weird whitespace/newline, keep it and record its index
        if (/\S/.test(char)) { 
            cleanTarget += char.toLowerCase();
            indexMap.push(i);
        }
    }

    const cleanPattern = originalPattern.toLowerCase().replace(/\s+/g, '');
    const patternLen = cleanPattern.length;
    
    let bestMatch = { score: 0, cleanStart: -1 };

    // 2. Sliding Window on the mapped string
    for (let i = 0; i <= cleanTarget.length - patternLen; i++) {
        const chunk = cleanTarget.substring(i, i + patternLen);
        const score = calculateSimilarity(chunk, cleanPattern);

        if (score > bestMatch.score) {
            bestMatch = { score: score, cleanStart: i };
        }
    }

    // 3. Map back to Original Indices
    if (bestMatch.score > 0.5) {
        const startInOriginal = indexMap[bestMatch.cleanStart];
        // End index is the original index of the last character in the window
        const endInOriginal = indexMap[bestMatch.cleanStart + patternLen - 1];

         const finalSnippet1 = originalTarget.substring(startInOriginal, endInOriginal + 1);
        const textSnippet = originalTarget.substring(startInOriginal, endInOriginal + 1);
       const finalSnippet = textSnippet.replace(/\s+/g, ' ').trim();
      // const finalSnippet = normalizeText(textSnippet)

        console.log("--- Result Found ---");
        console.log("Confidence Score:", (bestMatch.score * 100).toFixed(2) + "%");
        console.log("Start Index:", startInOriginal);
        console.log("End Index:", endInOriginal);
        console.log("\nMATCHED TEXT FROM PDF:");
        console.log("-----------------------");
        console.log(finalSnippet1);
        console.log("-----------------------");
// Headless search via Core.documentViewer.textSearchInit. The
// previous implementation called ``instance.UI.searchText(...)``
// which opens Apryse's user-visible search panel as a side effect —
// the exact bug this PR exists to fix. ``applySearchHighlight``
// handles panel hygiene + clearSearchResults + displaySearchResult
// internally; do not add any of those calls back inline.
        applySearchHighlight(instance, finalSnippet);

    } else {
        console.log("No confident match found.");
    }
}

/** Sørensen-Dice Similarity */
function calculateSimilarity(str1, str2) {
    const getBigrams = (s) => {
        const b = new Set();
        for (let i = 0; i < s.length - 1; i++) b.add(s.substring(i, i + 2));
        return b;
    };
    const b1 = getBigrams(str1);
    const b2 = getBigrams(str2);
    if (!b1.size || !b2.size) return 0;
    let intersect = 0;
    for (const item of b1) if (b2.has(item)) intersect++;
    return (2 * intersect) / (b1.size + b2.size);
}

    highlightMetadata.forEach(async (metadata) => {
  const { page, chunk_content } = metadata;

  if (!page) return;

  // Always apply the page jump first, even when ``chunk_content``
  // is missing or empty (legacy filename-resolved BE-link case in
  // the new-shape citation flow — Bugbot Medium #PR-106). Use the
  // shared ``applyPageJump`` helper rather than inlining
  // ``setCurrentPage`` so the ``getPageCount``-based bounds check is
  // not silently dropped (Bugbot Low ``446620be`` — the inline
  // version would queue out-of-bounds jumps that Apryse clamps
  // without surfacing the mistake).
  applyPageJump(instance, page);

  if (!chunk_content) return;

  const { Core } = instance;
  const { documentViewer, annotationManager } = Core;
  const doc = documentViewer.getDocument();

  console.log("🔍 Processing page:", page);

  // Load page text from PDF
  const pageText = await doc.loadPageText(page);
   console.log("pageText",pageText)
   console.log("pageText",chunk_content)

  const normalizedPdfText = normalizeText(pageText);
  const normalizedSearch = normalizeText(chunk_content);


  advancedFuzzySearch(pageText,chunk_content,page)

}); 
  
  }, [location]);

  // Watch for location.state changes to handle highlighting when document is already loaded
  //
  // NOTE: previously guarded on `webViewerInstances.isInstanceReady`, which
  // is not exported from `useWebViewerInstances` — the field was always
  // `undefined`, so `!undefined` was always truthy and this effect body
  // never ran (silently breaking "highlight the chunk when the user clicks
  // a chat citation for a document that is already open"). Switched to the
  // real `hasInstance(activeTab)` check.
  useEffect(() => {
    if (
      !activeTab ||
      activeTab === "1" ||
      activeTab === "0" ||
      !webViewerInstances.hasInstance(activeTab)
    ) {
      return;
    }
    
    // Get instance for active tab
    const tabInstance = webViewerInstances.getInstance(activeTab);
    if (!tabInstance) {
      return;
    }
    
    const highlightMetadata = location.state?.highlightMetadata;
    
    if (!highlightMetadata) {
      // Also check sessionStorage
      try {
        const stored = sessionStorage.getItem('chatHighlightMetadata');
        if (stored) {
          const parsed = JSON.parse(stored);
          console.log('📌 Highlight metadata from sessionStorage (already loaded doc):', parsed);
          sessionStorage.removeItem('chatHighlightMetadata');
          
          // Get current document info
          const { documentViewer } = tabInstance.Core;
          if (documentViewer && documentViewer.getDocument()) {
            // Get the active tab's document record to determine file type
            const activeTabData = tabs.find(tab => tab.id === activeTab);
            const documentRecord = activeTabData?.content?.props?.documentRecord || activeTabData?.documentRecord;
            const currentFileType = documentRecord ? getFileType(documentRecord.file_type) : 'pdf';
            
            console.log('🔄 Location state changed (sessionStorage), triggering highlighting for already loaded document');
            performTextHighlighting(parsed, documentViewer, tabInstance, currentFileType);
          }
        }
      } catch (e) {
        console.error('Failed to read from sessionStorage:', e);
      }
      return;
    }
    
    // Metadata addressed to another document (a cross-doc citation
    // click mid-navigation) must not move this tab.
    if (!highlightMetadataTargetsActiveTab(highlightMetadata)) {
      return;
    }

    // Get current document info
    const { documentViewer } = tabInstance.Core;
    if (documentViewer && documentViewer.getDocument()) {
      // Get the active tab's document record to determine file type
      const activeTabData = tabs.find(tab => tab.id === activeTab);
      const documentRecord = activeTabData?.content?.props?.documentRecord || activeTabData?.documentRecord;
      const currentFileType = documentRecord ? getFileType(documentRecord.file_type) : 'pdf';
      
      console.log('🔄 Location state changed, triggering highlighting for already loaded document');
      performTextHighlighting(highlightMetadata, documentViewer, tabInstance, currentFileType);
    }
  }, [location.state, activeTab, tabs, performTextHighlighting, webViewerInstances, highlightMetadataTargetsActiveTab]);

  // Track last fetched document to prevent duplicate API calls
  const lastFetchedDocRef = useRef(null);
  const lastBreadcrumbDocRef = useRef(null);

  // Set shareContext from documentDetail.sharing_context (replaces sharingContext API call)
  useEffect(() => {
    // Only proceed if we're on a document tab (not "0" or "1")
    if (!activeTab || activeTab === "0" || activeTab === "1") {
      // Clear when not on a document tab
      if (lastFetchedDocRef.current) {
        setShareContext({});
        setDocumentBreadcrumb([]);
        lastFetchedDocRef.current = null;
        lastBreadcrumbDocRef.current = null;
      }
      return;
    }

    // Extract documentId from activeTab (format: D4018049)
    const documentId = activeTab.substring(1); // Remove 'D' prefix
    
    // Only update sharing context if this is a different document than last time
    const currentUniqueId = urlIds.at(-1);
    const hasInstance = hasTabInstanceWithDocument(currentUniqueId);
    if (lastFetchedDocRef.current !== documentId && !hasInstance) {
      // Mark this document as being fetched
      lastFetchedDocRef.current = documentId;
    }

    // Use sharing_context from documentDetail instead of API call
    if (documentDetail?.sharing_context) {
      setShareContext(documentDetail.sharing_context);
      setShareID(documentDetail.sharing_context?.share_ids?.[0] || "");
    } else {
      setShareContext({});
      setShareID("");
    }

    // Create breadcrumb from treeData for the current document
    // This ensures breadcrumb updates when switching tabs without API calls
    if (lastBreadcrumbDocRef.current !== documentId) {
      lastBreadcrumbDocRef.current = documentId;
      
      // Clear breadcrumb first to show loading state
      setDocumentBreadcrumb([]);
      
      // Create breadcrumb from treeData using the document ID from activeTab
      // activeTab is already in format "D4018049", so use it directly
      const documentIdWithPrefix = activeTab; // e.g., "D4018049"
      
      try {
        const breadcrumb = createBreadcrumbFromTreeData(treeData, matterDetails, documentIdWithPrefix);
        setDocumentBreadcrumb(breadcrumb);
        // Store breadcrumb for this tab
        setTabBreadcrumbs(prev => new Map(prev).set(activeTab, breadcrumb));
      } catch (error) {
        console.error('Failed to create breadcrumb from treeData:', error);
        // Fallback to API if treeData doesn't have the document
        const currentUniqueId = urlIds.at(-1);
        const hasInstance = hasTabInstanceWithDocument(currentUniqueId);
        if (!hasInstance) {
      dispatch(fetchBreadCrumbs({ item_id: documentIdWithPrefix })).then((response) => {
            const breadcrumb = [
          { id: 0, name: "Matters" },
          ...(response?.payload?.data || []),
            ];
            setDocumentBreadcrumb(breadcrumb);
            setTabBreadcrumbs(prev => new Map(prev).set(activeTab, breadcrumb));
          }).catch((apiError) => {
            console.error('Failed to fetch breadcrumb from API:', apiError);
        lastBreadcrumbDocRef.current = null; // Reset on error so it can retry
      });
    }
      }
    }
  }, [activeTab, dispatch, treeData, matterDetails, documentDetail?.sharing_context]);

  // Update breadcrumb when matterDetails or treeData updates for the active document tab
  // This handles the case where user navigates directly to a document tab before matterDetails is loaded
  useEffect(() => {
    // Only proceed if we're on a document tab (not "0" or "1")
    if (!activeTab || activeTab === "0" || activeTab === "1") {
      return;
    }

    // Only update if we have matterDetails and treeData available
    if (!matterDetails?.id || !treeData || treeData.length === 0) {
      return;
    }

    // Extract documentId from activeTab (format: D4018049)
    const documentId = activeTab.substring(1); // Remove 'D' prefix
    const documentIdWithPrefix = activeTab; // e.g., "D4018049"

    // Try to create breadcrumb from treeData
    try {
      const breadcrumb = createBreadcrumbFromTreeData(treeData, matterDetails, documentIdWithPrefix);
      
      // Only update if breadcrumb is valid (has more than just "Matters")
      if (breadcrumb && breadcrumb.length > 1) {
        setDocumentBreadcrumb(breadcrumb);
        // Store breadcrumb for this tab
        setTabBreadcrumbs(prev => new Map(prev).set(activeTab, breadcrumb));
      }
    } catch (error) {
      console.error('Failed to create breadcrumb from treeData when matterDetails/treeData updated:', error);
      // Don't make API call here - let the existing useEffect handle fallback
    }
  }, [matterDetails, treeData, activeTab, setDocumentBreadcrumb, setTabBreadcrumbs]);

  // Update tab name and breadcrumb when documentDetail changes (e.g., from WebSocket sharepoint_document_update)
  const lastUpdatedDocumentIdRef = useRef(null);
  useEffect(() => {
    // Only proceed if we have documentDetail and we're on a document tab
    if (!documentDetail?.id || !activeTab || activeTab === "0" || activeTab === "1") {
      return;
    }

    // Extract documentId from activeTab (format: D4018049)
    const documentId = activeTab.substring(1); // Remove 'D' prefix
    
    // Only update if this documentDetail matches the active tab
    if (String(documentDetail.id) !== String(documentId)) {
      return;
    }

    // Check if this is a new update (prevent infinite loops)
    const updateKey = `${documentDetail.id}_${documentDetail.name}`;
    if (lastUpdatedDocumentIdRef.current === updateKey) {
      return; // Already processed this update
    }
    lastUpdatedDocumentIdRef.current = updateKey;

    // Update tab name if document name changed
    if (documentDetail.name) {
      const documentUniqueId = `D${documentDetail.id}`;
      
      // Update titleName state
      setTitleName((prev) => ({
        ...prev,
        [documentUniqueId]: documentDetail.name.trim(),
      }));

      // Update tab title in tabs array
      setTabs((prevTabs) =>
        prevTabs.map((tab) => {
          if (tab.id === activeTab) {
            return {
              ...tab,
              title: documentDetail.name.trim(),
            };
          }
          return tab;
        })
      );
    }

    // Refresh breadcrumb to get updated document name from treeData
    if (documentDetail.name) {
      const documentIdWithPrefix = activeTab; // e.g., "D4018049"
      
      try {
        const breadcrumb = createBreadcrumbFromTreeData(treeData, matterDetails, documentIdWithPrefix);
        // Update the last breadcrumb item (document) with the updated name
        if (breadcrumb.length > 0) {
          breadcrumb[breadcrumb.length - 1].name = documentDetail.name.trim();
        }
        setDocumentBreadcrumb(breadcrumb);
        setTabBreadcrumbs(prev => new Map(prev).set(activeTab, breadcrumb));
      } catch (error) {
        console.error('Failed to create breadcrumb from treeData after update:', error);
        // Fallback to API if treeData doesn't have the document
        const currentUniqueId = urlIds.at(-1);
        const hasInstance = hasTabInstanceWithDocument(currentUniqueId);
        if (!hasInstance) {
          dispatch(fetchBreadCrumbs({ item_id: documentIdWithPrefix })).then((response) => {
            const breadcrumb = [
              { id: 0, name: "Matters" },
              ...(response?.payload?.data || []),
            ];
            setDocumentBreadcrumb(breadcrumb);
            setTabBreadcrumbs(prev => new Map(prev).set(activeTab, breadcrumb));
          }).catch((apiError) => {
            console.error('Failed to fetch breadcrumb from API after update:', apiError);
          });
        }
      }
    }
  }, [documentDetail, activeTab, dispatch, treeData, matterDetails]);

    useEffect(() => {
      const preventDefault = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      globalThis.addEventListener("dragover", preventDefault);
      globalThis.addEventListener("drop", preventDefault);

      return () => {
        globalThis.removeEventListener("dragover", preventDefault);
        globalThis.removeEventListener("drop", preventDefault);
      };
    }, []);

const fetchUpdatedMatterDetails = async () => {
      if (matterDetails.sf_id) {
        setisLoading(true);
        // Commented out fetchMatterDetail API call - not needed when closing tab
        // dispatch(fetchMatterDetail(matterDetails.id)).finally(() => {
        //   setisLoading(false);
        // });
          setisLoading(false);
      }
    };


  const openedDocuments = useMemo(() => {
    if(urlIds.at(-1).startsWith("F")){
          setActiveTab("1")
        }
    const topLevelDocs = matterDetails?.documents || [];
    const nestedDocuments = collectNestedDocuments(matterDetails?.folders || []);
    const allDocs = [...topLevelDocs, ...nestedDocuments];
  
    // Create a Map for quick lookup
    const docMap = new Map(allDocs.map(doc => [doc.id, doc]));
  
    return (Array.isArray(openDocs) ? openDocs : [])
      .map(tab => {
        const doc = docMap.get(tab.document);
        return doc ? { ...doc, type: "document" } : null;
      })
      .filter(Boolean); // remove nulls if any
  }, [matterDetails?.documents, matterDetails?.folders, openDocs]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    const params = {
      id:urlIds[0], 
      page: currentPage,
      sort_direction: sort,
      sort_by: sortBy,
      ...(urlIds.length>1 && { folder: urlIds.at(-1) }),
    };
    setisLoading(true);
     if (treeData.length>0){
      checkHighlighted(treeData);
    if(!urlIds.at(-1).startsWith('D')){
      dispatch(fetchMatterDetailList(params)).finally(() => {
        setisLoading(false);
      });
    }
  }

  setisLoading(false)
  // eslint-disable-next-line
  }, [currentPage, sort, sortBy, pageSize,treeData]); // initial call

  const checkHighlighted = (nodes) => {
    if (!Array.isArray(nodes)) return;
    const urlendpoint = location.pathname.split("/matter/")[1].split("/")
    for (const node of nodes) {
      if (node.is_highlighted === true && urlendpoint.at(-1) != node.key) {
        if(localStorage.getItem("lastrecentclosed")!= node.key && localStorage.getItem("newPdf") !== "true"){
        console.log("==>navigated to check highlight",`/matter${node.relativePath}`);   
        }
        return; 
      }
      if (node.children && node.children.length > 0) {
        checkHighlighted(node.children);
      }
    }
  };

  // Function to open a new tab
  const openTab = useCallback((pdf, first, initialRender) => {
    localStorage.removeItem("lastrecentclosed")
    localStorage.removeItem("lastclosed")
    dispatch(setUpdateMeta(pdf))
    if (pdf?.type === "document" || PDF_FILE_TYPES.includes(pdf?.file_type) || MS_FILE_TYPES.includes(pdf?.file_type)) {
      
      const tabId = pdf.unique_id.toString();
      
      // Check if this is a new tab (no instance exists yet) - do this FIRST
      // Show loader immediately for new tabs, before any other operations
      const existingInstance = webViewerInstances.getInstance(tabId);
      if (!existingInstance && !initialRender) {
        // Set loader immediately - this will show as soon as React re-renders
        setIsInstanceLoading(true);
      }
      
      const existingTab = tabs?.find((tab) => tab.id === tabId);
      if (existingTab && !initialRender) {
        // Just set active tab without reordering
        // Check if user manually switched tabs before setting active tab
        console.log(`📂 [openTab] Existing tab found: ${tabId}`);
        console.log(`📂 [openTab] manualTabSwitchRef: ${manualTabSwitchRef.current}`);
        
        if (!manualTabSwitchRef.current) {
          console.log(`📂 [openTab] Setting active tab to existing tab ${tabId}`);
        setActiveTab(existingTab.id);
        } else {
          console.log(`📂 [openTab] Skipping setActiveTab for existing tab - user manually switched tabs`);
        }
        // If instance doesn't exist, loader is already set above
        return;
      }
      
      
      // Store documentRecord in tab for easy access (we'll use it instead of Document component)
      const documentId = pdf.unique_id.substring(1); // Remove 'D' prefix
      
      
      const newTab = {
        id: pdf.unique_id.toString(),
        key: pdf.unique_id,
        title: `${pdf.name}`,
        relativePath:pdf.relative_path,
        documentRecord: pdf, // Store documentRecord directly for easy access
        // Keep Document component for now (for backward compatibility), but we'll use persistent container instead
        content: (
          <Document
            documentRecord={pdf}
            isLocked={pdf.is_locked}
            matterDetails={matterDetailsTree}
            fetchUpdatedMatterDetails={fetchUpdatedMatterDetails}
            lockedUser={pdf.locked_by_user}
            setRenameEditFlag={setRenameEditFlag}
            titleName={titleName}
            first={first}
            setOpen={setOpen}
            setFileProp={setFileProp}
            loading={true}
            treeData={treeData}
            handleBreadcrumbClick={handleBreadcrumbClick}
            setActiveTab={setActiveTab}
            displayName={matterDetailsTree?.display_name}
            error={drawerError}
            setErrors={setdrawerError}
            setShowDeleteModal={setShowDeleteModal}
            setShowShareModal={setShowShareModal}
            setShowReviewActionModal={openReviewActionModal}
            setSelectedDoc={setSelectedDoc}
            setOpenReviewNotes={setOpenReviewNotes}
            setOpenESignModal={setOpenESignModal}
            setShareId={setShareID}
            openESignModal={openESignModal}
            setShowExternalShareModal={setShowExternalShareModal}
            setShowSendMessageModal={setShowSendMessageModal}
            setDocLoading={setDocLoading} 
            setSelectedFile={setSelectedFile}
            setIsModalOpen={setIsModalOpen}
          />
        ),
      };
      setRenameEditFlag((prev) => ({
        ...prev,
        [pdf.unique_id]: !!localStorage.getItem("newPdf"),
      }));
      setTitleName((prev) => ({
        ...prev,
        [pdf.unique_id]: pdf.name
      }))
      setTabs((prev) => {
        // If tab already exists, return previous state
        if (prev.some((tab) => tab.id === newTab.id)) return prev;
        // Just append new tab to the end (maintain natural order)
        return [...prev, newTab];
      });
     // Get current URL IDs from location (not from closure) to avoid stale values
     const currentUrlIds = location.pathname.split("/matter/")[1]?.split("/").filter(Boolean) || [];
     const currentUrlTabId = currentUrlIds.at(-1);
     
     // Set active tab immediately if user hasn't manually switched tabs
     // This provides instant feedback when clicking from sidebar (even before URL updates)
     // Only skip if user manually switched tabs (to prevent race condition)
     if (!manualTabSwitchRef.current) {
       // Normal click - set active tab immediately for instant feedback
       const urlMatches = tabId === currentUrlTabId;
       const isNewPdf = localStorage.getItem("newPdf") === "true";
       const urlNotUpdatedYet = !currentUrlTabId || currentUrlTabId.startsWith("F");
       
       if (urlMatches || isNewPdf || urlNotUpdatedYet) {
         console.log(`📂 [openTab] Setting active tab to ${tabId} immediately (normal click)`);
         setActiveTab(tabId);
       } else {
         // Even if URL doesn't match yet, set it for instant feedback (URL will update soon)
         console.log(`📂 [openTab] Setting active tab to ${tabId} (for instant feedback, URL will update)`);
        setActiveTab(tabId);
       }
     } else {
       console.log(`📂 [openTab] Skipping setActiveTab - user manually switched tabs (manualTabSwitchRef: true)`);
     }
    } else if (pdf?.type === "folder") {
      dispatch(setExpandedKeys([...expandedKeys, pdf.unique_id]));
    }
  }, [tabs, breadcrumb, currentPage, sort, sortBy, uniqueId, treeData]);

  // Expose openTab and setActiveTab functions via ref for sidebar clicks (after openTab is defined)
  useEffect(() => {
    if (openTabRef) {
      openTabRef.current = openTab;
    }
    if (setActiveTabRef) {
      setActiveTabRef.current = setActiveTab;
    }
  }, [openTab, setActiveTab, openTabRef, setActiveTabRef]);

useEffect(() => {
    if (hasOpenedTabs.current) return; // to ensure open tab is called only once
    if (openDocsStatus === "succeeded" && matterDetailsStatus === "succeeded") {
      hasOpenedTabs.current = true;
    }
    if (openedDocuments.length > 0) {
      const activeTabId = urlIds.at(-1).startsWith("D") ? urlIds.at(-1) : null;
      
      // LAZY LOADING: Just create tabs without fetching document details or caching
      // Documents will be loaded and cached only when user actually switches to that tab
      // This prevents initial load from making 10+ API calls and caching all documents
      const createTabsWithoutLoading = () => {
        const newTabs = [];
        
        for (const item of openedDocuments) {
          // Only create tabs for documents (not folders)
          if (item.type === "document" || PDF_FILE_TYPES.includes(item.file_type) || MS_FILE_TYPES.includes(item.file_type)) {
            const tabId = item.unique_id.toString();
            
            // Check if tab already exists
            const existingTab = tabs.find(tab => tab.id === tabId);
            if (existingTab) {
              newTabs.push(existingTab);
              continue;
            }
            
            // Create tab without fetching document details or caching
            // The Document component will be created but won't load until user switches to this tab
            const newTab = {
              id: tabId,
              key: item.unique_id,
              title: item.name || `Document ${item.unique_id}`,
              relativePath: item.relative_path,
              documentRecord: item, // Store basic documentRecord (will be enriched when tab is opened)
              // Keep Document component for backward compatibility (but it won't load until tab is active)
              content: (
                <Document
                  documentRecord={item}
                  isLocked={item.is_locked}
                  matterDetails={matterDetailsTree}
                  fetchUpdatedMatterDetails={fetchUpdatedMatterDetails}
                  lockedUser={item.locked_by_user}
                  setRenameEditFlag={setRenameEditFlag}
                  titleName={titleName}
                  first={false}
                  setOpen={setOpen}
                  setFileProp={setFileProp}
                  loading={true}
                  treeData={treeData}
                  handleBreadcrumbClick={handleBreadcrumbClick}
                  setActiveTab={setActiveTab}
                  displayName={matterDetailsTree?.display_name}
                  error={drawerError}
                  setErrors={setdrawerError}
                  setShowDeleteModal={setShowDeleteModal}
                  setShowShareModal={setShowShareModal}
                  setShowReviewActionModal={openReviewActionModal}
                  setSelectedDoc={setSelectedDoc}
                  setOpenReviewNotes={setOpenReviewNotes}
                  setOpenESignModal={setOpenESignModal}
                  setShareId={setShareID}
                  openESignModal={openESignModal}
                  setShowExternalShareModal={setShowExternalShareModal}
                  setShowSendMessageModal={setShowSendMessageModal}
                  setDocLoading={setDocLoading} 
                  setSelectedFile={setSelectedFile}
                  setIsModalOpen={setIsModalOpen}
                />
              ),
            };
            
            newTabs.push(newTab);
            
            // Update titleName for the tab
            setTitleName((prev) => ({
              ...prev,
              [item.unique_id]: item.name
            }));
            
            // Set renameEditFlag to false so tabs don't appear in rename state
            setRenameEditFlag((prev) => ({
              ...prev,
              [item.unique_id]: false,
            }));
          }
        }
        
        // Only add new tabs that don't already exist
        if (newTabs.length > 0) {
          setTabs((prev) => {
            const existingIds = new Set(prev.map(tab => tab.id));
            const tabsToAdd = newTabs.filter(tab => !existingIds.has(tab.id));
            return [...prev, ...tabsToAdd];
          });
        }
        
        // After all tabs are created, set active tab
        if (activeTabId) {
          setActiveTab(activeTabId);
        } else {
          setActiveTab("1");
        }
        
        console.log(`📑 Created ${newTabs.length} tabs without loading (lazy loading enabled)`);
      };
      
      createTabsWithoutLoading();
    }
  }, [openedDocuments, openDocsStatus, matterDetailsStatus]);

  // Track if cleanup has been called to prevent infinite loops
  const cleanupCalledRef = useRef(false);

  useEffect(() => {
    return () => {
      // Prevent multiple cleanup calls
      if (cleanupCalledRef.current) {
        return;
      }
      cleanupCalledRef.current = true;
      
      console.log('🧹 [TABVIEW CLEANUP] TabView unmounting - starting comprehensive cleanup...');
      
      // Synchronously clear Redux state first
      dispatch(resetStatuses());
      dispatch(resetMatterDetailList()); // Clears Document Listing on navigating out of matter
      
      // Clear local state immediately
      hasOpenedTabs.current = false;
      tab1SelectionRef.current = [];
      
      // Clean up scrollbars
      cleanupScrollState();
      
      // Dispose all WebViewer instances - this is async but we try to complete it
      // Note: In React, cleanup functions can't be async, but we can still call async functions
      // The browser will continue cleanup even after component unmounts
      cleanupAllInstances().then(() => {
        console.log('✅ [TABVIEW CLEANUP] All WebViewer instances disposed - WASM memory should be released');
        console.log('💡 Check Chrome Task Manager - memory should drop significantly');
        
        // Additional cleanup after async operations complete
        // Clear any remaining DOM references
        const allContainers = document.querySelectorAll('[id^="webviewer-container-"]');
        allContainers.forEach(container => {
          try {
            container.innerHTML = '';
            container.remove();
          } catch (e) {
            // Ignore errors during cleanup
          }
        });
      }).catch((error) => {
        console.error('❌ [TABVIEW CLEANUP] Failed to dispose WebViewer instances:', error);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Only run cleanup on unmount, not on dependency changes

  const handleCloseDeletedTab = (tabId) => {
    const newTabs = tabs.filter((tab) => tab.id !== tabId);
    setTabs(newTabs);
    if (tabId === activeTab) {
        navigateWithChatbox(navigate, location, `/matter${localStorage.getItem("relativePath")}`)
    }
  }
  const handleOpenFileProperties = () => {
    const docIdFromUrl = urlIds.at(-1)?.substring(1);
    const openDrawer = (docData) => {
      setFileProp(docData);
      setSelectedDoc(docData);
      dispatch(setUpdateMeta(docData));
      setOpen(true);
    };
    if (String(documentDetail?.id) !== String(docIdFromUrl)) {
      dispatch(getDocumentDetails(docIdFromUrl)).then((result) => {
        openDrawer(result.payload?.data || documentDetail);
      });
    } else {
      openDrawer(documentDetail);
    }
  };

  // Function to close a tab
const closeTab = (tabId, deleteTab) => {
  localStorage.setItem("lastrecentclosed", tabId);

  const selectedTab = tabs.find((tab) => tab.id === tabId);
  if (!selectedTab) return;

  const documentRecord = selectedTab.content?.props?.documentRecord;
  const docId = documentRecord ? documentRecord.unique_id.substring(1) : null;

  // Drop per-tab markdown + view-mode cache so a reopened tab starts fresh.
  setMarkdownContentByTab(prev => {
    if (!(tabId in prev)) return prev;
    const next = { ...prev };
    delete next[tabId];
    return next;
  });
  // Also clear the in-flight marker so reopening a closed tab refetches
  // markdown via the new endpoint (otherwise the marker would be stuck
  // for a doc that returned 404 once and the toggle would stay hidden
  // indefinitely on a re-open after, say, an undelete).
  markdownFetchInFlightRef.current.delete(tabId);
  setViewModeByTab(prev => {
    if (!(tabId in prev)) return prev;
    const next = { ...prev };
    delete next[tabId];
    return next;
  });

  onTabClosed(tabId, docId);

  // IMMEDIATE UI UPDATE: Remove tab and switch to another tab if needed
  // This happens synchronously for instant feedback
  handleTabClosure({tabId,deleteTab,selectedTab,tabs,activeTab,setTabs,setEditingKey,setEditingValue,dispatch,deleteHighlightMatter,setActiveTab,navigate,location,restoreTab1Selection,setSelectedKeys,uniqueId});
  
  // BACKGROUND CLEANUP: All async operations happen in the background
  // This doesn't block the UI update
  (async () => {
    try {
      const instance = webViewerInstances.getInstance(tabId);
      
      // Save current page to backend (fire and forget)
      // IMPORTANT: Flush any pending debounced API call first, then save current page
      if (pageChangeListenerRef.current && pageChangeListenerRef.current.documentId === docId) {
        try {
          // Flush pending debounced API call by clearing timer and calling immediately
          if (pageChangeListenerRef.current.timer) {
            clearTimeout(pageChangeListenerRef.current.timer);
            pageChangeListenerRef.current.timer = null;
          }
          
          // If there's a handler, get the current page and save it immediately
          if (instance && instance.Core?.documentViewer) {
            const { documentViewer } = instance.Core;
      const currentPage = documentViewer.getCurrentPage();
      if (currentPage && currentPage > 0) {
              // Update localStorage immediately (for quick reopen scenarios)
              localStorage.setItem('lastPageViewed', String(currentPage));
              localStorage.setItem('lastPageViewedDoc', String(docId));
              
              // Save to API immediately (don't wait for debounce)
              dispatch(postLastPageViewed({ docId: docId, page_number: currentPage }));
              
              // Update matterDetailsTree in Redux with latest last_page_viewed (so sidebar shows correct page)
              dispatch(updateDocumentLastPageViewed({ documentId: docId, lastPageViewed: currentPage }));
              
              console.log(`💾 [CLOSE TAB] Saved page ${currentPage} for document ${docId} immediately (localStorage + API + matterDetailsTree)`);
            }
          }
        } catch (e) {
          console.warn('⚠️ Error flushing page save on tab close:', e);
        }
      } else if (instance && instance.Core?.documentViewer) {
        // Fallback: if no listener ref, still try to save current page
        try {
          const { documentViewer } = instance.Core;
          const currentPage = documentViewer.getCurrentPage();
          if (currentPage && currentPage > 0) {
            // Update localStorage immediately (for quick reopen scenarios)
            localStorage.setItem('lastPageViewed', String(currentPage));
            localStorage.setItem('lastPageViewedDoc', String(docId));
            
            dispatch(postLastPageViewed({ docId: docId, page_number: currentPage }));
            
            // Update matterDetailsTree in Redux with latest last_page_viewed (so sidebar shows correct page)
            dispatch(updateDocumentLastPageViewed({ documentId: docId, lastPageViewed: currentPage }));
            
            console.log(`💾 [CLOSE TAB] Saved page ${currentPage} for document ${docId} (fallback - localStorage + API + matterDetailsTree)`);
      }
    } catch (error) {
      console.warn('⚠️ Failed to save page when closing tab:', error);
    }
  }
  
      // Flush a pending autosave while the document is still open — the
      // export reads from the live viewer, so anything left queued past
      // disposeTabInstance below is unrecoverable.
      flushAutoSave();

      // IMPORTANT: Remove our custom event listeners BEFORE disposing the instance
      // This prevents WebViewer's internal cleanup from trying to remove listeners that are already gone
      // Clean up listeners first
      if (pageChangeListenerRef.current && pageChangeListenerRef.current.documentId === docId) {
        try {
          if (instance && instance.Core?.documentViewer && pageChangeListenerRef.current.handler) {
            instance.Core.documentViewer.removeEventListener('pageNumberUpdated', pageChangeListenerRef.current.handler);
          }
          // Timer already cleared above
        } catch (e) {
          console.warn('Warning removing page change listener:', e);
        }
        pageChangeListenerRef.current = null;
      }
      
      if (bookmarkListenerRef.current && bookmarkListenerRef.current.documentId === docId) {
        try {
          // The ref stores { cleanup, documentId } — cleanup() FLUSHES any
          // pending debounced bookmark save before removing the listener.
          // The old code here read a nonexistent `.handler` and killed the
          // debounce timer directly, so closing a tab within the 400ms
          // debounce window silently discarded the user's last bookmark
          // change ("when the document closes, it isn't saved" —
          // Matthew/Paige, 2026-07-21).
          if (typeof bookmarkListenerRef.current.cleanup === 'function') {
            bookmarkListenerRef.current.cleanup();
          }
        } catch (e) {
          console.warn('Warning cleaning up bookmark listener:', e);
        }
        bookmarkListenerRef.current = null;
      }
      
      if (annotationListenerRef.current && annotationListenerRef.current.documentId === docId) {
        try {
          const { annotationManager } = instance?.Core || {};
          if (annotationManager) {
            if (annotationListenerRef.current.handler) {
              annotationManager.removeEventListener('annotationChanged', annotationListenerRef.current.handler);
            }
            if (annotationListenerRef.current.fieldChangeHandler) {
              annotationManager.removeEventListener('fieldChanged', annotationListenerRef.current.fieldChangeHandler);
            }
          }
        } catch (e) {
          console.warn('Warning removing annotation/field listeners:', e);
        }
        if (annotationChangeDebounceRef.current?.documentId === docId && annotationChangeDebounceRef.current?.timerId) {
          clearTimeout(annotationChangeDebounceRef.current.timerId);
          annotationChangeDebounceRef.current = { timerId: null, documentId: null };
        }
        annotationListenerRef.current = null;
      }

      if (pagesUpdatedListenerRef.current && pagesUpdatedListenerRef.current.documentId === docId) {
        try {
          if (instance && instance.Core?.documentViewer && pagesUpdatedListenerRef.current.handler) {
            instance.Core.documentViewer.removeEventListener('pagesUpdated', pagesUpdatedListenerRef.current.handler);
          }
          if (insertBatchRef.current?.timerId) clearTimeout(insertBatchRef.current.timerId);
          if (reorderBatchRef.current?.timerId) clearTimeout(reorderBatchRef.current.timerId);
          if (removeBatchRef.current?.timerId) clearTimeout(removeBatchRef.current.timerId);
        } catch (e) {
          console.warn('Warning removing pagesUpdated listener:', e);
        }
        pagesUpdatedListenerRef.current = null;
      }

      // Now dispose the WebViewer instance (this will handle WebViewer's internal cleanup)
      await webViewerInstances.disposeTabInstance(tabId);
  
  // Clean up firstLoad and autoSave state for this document
  firstLoadRef.current.delete(docId);
  replacingDocumentIdsRef.current.delete(String(docId));
  if (userInteractionCleanupRef.current.has(docId)) {
    const cleanup = userInteractionCleanupRef.current.get(docId);
    if (typeof cleanup === 'function') {
      cleanup();
      userInteractionCleanupRef.current.delete(docId);
    }
  }
  if (fieldValidatorCleanupsRef.current.has(docId)) {
    const cleanup = fieldValidatorCleanupsRef.current.get(docId);
    if (typeof cleanup === 'function') cleanup();
    fieldValidatorCleanupsRef.current.delete(docId);
  }
  if (fieldAuditCleanupsRef.current?.has?.(docId)) {
    const cleanup = fieldAuditCleanupsRef.current.get(docId);
    if (typeof cleanup === 'function') cleanup();
    fieldAuditCleanupsRef.current.delete(docId);
  }
  if (fieldDecorationCleanupsRef.current?.has?.(docId)) {
    const cleanup = fieldDecorationCleanupsRef.current.get(docId);
    if (typeof cleanup === 'function') cleanup();
    fieldDecorationCleanupsRef.current.delete(docId);
  }
  templateMergeDecoratedRef.current.delete(docId);
      
  // Clear autoSave message if it's for this document
  setAutoSave(null);
      
      // Clear current document ID if this was the active tab
      if (currentDocumentIdRef.current === docId) {
        currentDocumentIdRef.current = null;
      }
      
      // Clear documentDetail Redux state when closing tab
      // This ensures fresh state when reopening the document
      dispatch(clearDocumentDetail());
  
  let selectedID
    if (documentRecord.unique_id == documentDetail.unique_id) {
      selectedID = documentDetail;
    } else {
      selectedID = findDocumentById(
        [matterDetailsTree],
        documentRecord.unique_id
      );
    }

      // Call unlock API if document is locked by the same user
      const currentUserId = Number(localStorage.getItem("user_id"));
      if (selectedID && ((selectedID.is_locked === true && selectedID.locked_by === currentUserId ) || selectedID.locked_by=== null)) {
        localStorage.setItem("lastclosed", selectedID?.unique_id);
        await handleDocumentUnlock(dispatch, editPDFsunLock, fetchUpdatedMatterDetails, selectedID);
        // Remove from lockedDocsRef when unlocking
        lockedDocsRef.current.delete(docId);
    }

    await handleRemoveOpenedDoc(dispatch, id, docId, setdrawerError, setShowNotification);
    resetRenameFlag(setRenameEditFlag, documentRecord.unique_id);
  } catch (err) {
      console.error("Error during background cleanup when closing tab:", err);
      // Don't show error to user since tab is already closed
    }
  })();
};


  // Helper function to build highlight payload with tab_action for documents
  const buildHighlightPayload = (matterId, docId, docType) => {
    const payload = { matterId, docId, docType };
    
    // Add tab_action for documents only
    if (docType === 'document') {
      const userId = Number(localStorage.getItem("user_id"));
      payload.tabAction = {
        usr_id: userId,
        document_id: String(docId),
        matter_id: String(matterId),
        action: "open"
      };
    }
    
    return payload;
  };

  const handleTab1 = async () => {
    // Mark that user manually switched tabs to prevent race conditions
    manualTabSwitchRef.current = true;
    
    // With multi-instance architecture, instances are managed per-tab
    // When switching to tab "1", the previous tab's instance is automatically paused
    // No explicit cleanup needed here
    setActiveTab("1");
    restoreTab1Selection();

    const page_number = localStorage.getItem(`lastPageViewed`)
    localStorage.removeItem(`lastPageViewed`)
    const documentId = localStorage.getItem('lastPageViewedDoc')
    localStorage.removeItem(`lastPageViewedDoc`)
    if(documentId){
      dispatch(postLastPageViewed({docId:documentId, page_number}))
      // Note: With multi-instance architecture, we don't cache documents
    }
    // Matter tab = matter home. It used to restore localStorage's
    // "relativePath" (the last folder/document location), which stranded
    // users inside folder views with no way back to the matter root —
    // especially when the breadcrumb lost its folder crumb (Matthew,
    // 2026-07-22, Jamie Scurlock matter). The dashboard lives at the root.
    console.log(`🔍 [TAB1 SWITCH] Navigating to matter root: /matter/${id}`);
    navigateWithChatbox(navigate, location, `/matter/${id}`);
  };

  const onTabClick = async (tab) => {
    const { id, relativePath, key } = tab;
    // Mark manual tab switch to prevent race conditions
    if (id !== activeTab) {
      manualTabSwitchRef.current = true;
      console.log(`🖱️ [TAB CLICK] Tab changed, set manualTabSwitchRef = true`);
    } else {
      console.log(`🖱️ [TAB CLICK] Same tab clicked, not setting manualTabSwitchRef`);
    }
    console.log(`🖱️ [TAB CLICK] manualTabSwitchRef after: ${manualTabSwitchRef.current}`);
    
    // With multi-instance architecture, each tab has its own instance
    // No cleanup needed when switching tabs - instances are managed per-tab
    
    switch (id) {
      case "0": {
        setShowSideBar(true);
        setTabs((prev) => prev.slice(1));
        break;
      }
      case "1": handleTab1(relativePath);
      break; 
      
      default: {
        if (relativePath) {
          const matterId = relativePath.split("/")[1];
          const docId = relativePath.split("/")[relativePath.split("/").length-1]?.substring(1);
      const docType = relativePath.split("/")[relativePath.split("/").length-1]?.startsWith("F") ? "folder" : "document";
      localStorage.removeItem(`lastPageViewed`)
      localStorage.removeItem('lastPageViewedDoc')
      // if(documentId){
      //  dispatch(postLastPageViewed({docId:documentId, page_number}))
      //  // Note: With multi-instance architecture, we don't cache documents
      // }
      
          // Call highlight API with tab_action for documents
          dispatch(postHighlightedMatter(buildHighlightPayload(matterId, docId, docType)))
          
          // Call document details API for documents (not folders)
          if (docType === "document" && docId) {
            dispatch(getDocumentDetails(docId));
          }
          
              navigateWithChatbox(navigate, location, `/matter${relativePath}`);
        }
        setActiveTab(id);
        // decide which key to use
        const selectedKey = key || id;
        dispatch(setSelectedKeys([selectedKey]));
        dispatch(setTabClick(true));
        break;
      }
    }
  };

  // Handle breadcrumb item click
  const handleBreadcrumbClick = (folderId, index, oldBreadcrumb = breadcrumb) => {
    const len = oldBreadcrumb?.length > 0 ? oldBreadcrumb.length : breadcrumb.length
     const page_number = localStorage.getItem(`lastPageViewed`)
      localStorage.removeItem(`lastPageViewed`)
       const documentId = localStorage.getItem('lastPageViewedDoc')
      localStorage.removeItem(`lastPageViewedDoc`)
      if(documentId){
       dispatch(postLastPageViewed({docId:documentId, page_number}))
       // Note: With multi-instance architecture, we don't cache documents
      }
    // The matter crumb (index 1) is also honored when it's the LAST crumb
    // but the URL is deeper than the matter root: legacy folders can lose
    // their folder crumb (breadcrumb collapses to [Matters, matter]),
    // which used to leave the matter crumb unclickable and the user
    // stranded inside the folder (Matthew, 2026-07-22).
    const urlDepth =
      location.pathname.split("/matter/")[1]?.split("/").filter(Boolean)
        .length || 0;
    if (index + 1 !== len || (index === 1 && urlDepth > 1)) {
      // Set loading state for breadcrumb navigation
      setIsPaginationLoading(true);
      
      if (index === 0) {
        setUniqueId(null)
        navigateWithChatbox(navigate, location, "/matter");
      } else if (index === 1) {
        const matterId = oldBreadcrumb[index].id;
        // Only post a highlight when the trailing crumb is a real item
        // (when the matter crumb is last — collapsed legacy breadcrumb —
        // there is no folder/document to highlight).
        if (index + 1 !== len) {
          const docId = oldBreadcrumb.at(-1).id?.substring(1);
          const docType = oldBreadcrumb.at(-1).type;
          dispatch(postHighlightedMatter(buildHighlightPayload(matterId, docId, docType))).then(() => {
        });
        }
         // Commented out fetchMatterDetail API call - not needed when navigating via breadcrumb
         // dispatch(fetchMatterDetail(urlIds[0]))
          // Call folder-hierarchy API when clicking matter name in breadcrumb
          const listPage = Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;
          dispatch(fetchMatterDetailList({id: matterId, page: listPage}));
          navigateWithChatbox(navigate, location, `/matter/${oldBreadcrumb[index].id}`);
      } else {
        const matterId = oldBreadcrumb[1].id;
        const docId = oldBreadcrumb[index].id?.substring(1);
      const docType = oldBreadcrumb[index].type
        dispatch(postHighlightedMatter({
          matterId,
          docId,
          docType,
        }))
          navigateWithChatbox(navigate, location, `/matter${oldBreadcrumb[index].url}`)
      }
    }
  };

  const openNewPDF = (document, first) => {
    const pdfRecord = {
      type: "document",
      record: document,
      file_type: document.file_type,
      unique_id: document.unique_id,
      name: document.name,
      ...document,
    };
    setTitleName((prev) => ({...prev,[document.unique_id]: document?.name,}));
    const matterId = id;
    const docId = document.unique_id.substring(1);
    const docType = document.unique_id.substring(1)?.startsWith("F") ? "folder" : "document";
    if(localStorage.getItem("newPdf")==="true"){
      dispatch(postHighlightedMatter(buildHighlightPayload(matterId, docId, docType))).then((res)=>{
        console.log("response",res);
      })
       navigateWithChatbox(navigate, location, `/matter${document.relative_path}`);
    }else{
      // Open tab immediately for instant feedback
        openTab(pdfRecord, first);
      
      // Then do API call in background (don't wait for it)
      // Removed addOpenedDoc call - tab_action is now included in postHighlightedMatter for documents
      // dispatch(addOpenedDoc({ matterId: id, docId: document.unique_id.substring(1) })).catch((error) => {
      //   console.error('Failed to add opened doc:', error);
      //   // Tab is already open, so we continue even if API call fails
      // });
  }
  };

  // Main onClick handler for row
  // Phase 2 — "Run AI Analysis" entry from a row's More menu.
  //
  // Mirrors the document branch of `onRowClick` exactly (toast on
  // unsupported file types, openTab + setActiveTab, postHighlightedMatter
  // with `tabAction: "open"`, setUpdateMeta, setSelectedDetails,
  // setTabClick, setSelectedKeys, updateTitleName) so the table
  // selection, redux meta, tab title, and server-side tab_action /
  // last-viewed tracking all stay in sync — only the navigation step is
  // swapped to force `?ai=analysis` regardless of the current pane state.
  // We don't dispatch the trigger here on purpose: the canonical run UX
  // (the `claimed_only` checkbox + Run button) lives inside
  // `AnalysisTab`, so this affordance is wayfinding, not a
  // fire-and-forget run.
  const handleRunAIAnalysisFromRow = useCallback(
    (record, tab = "analysis") => {
      if (!record || record.type !== "document" || !record.unique_id) return;

      const isSupported =
        PDF_FILE_TYPES.includes(record.file_type) ||
        MS_FILE_TYPES.includes(record?.file_type) ||
        IMAGE_FILE_TYPES.includes(record?.file_type);
      if (!isSupported) {
        dispatch(
          addNotification({
            id: Date.now().toString(),
            newMsg: "This file format is not supported in DMS at the moment.",
            success: false,
          })
        );
        return;
      }

      const pdfRecord = {
        type: "document",
        record,
        file_type: record.file_type,
        unique_id: record.unique_id,
        name: record.name,
        ...record,
      };
      openTab(pdfRecord, false);
      setActiveTab(record.unique_id.toString());

      const userId = Number(localStorage.getItem("user_id"));
      const highlightPayload = {
        matterId: record.matter_id,
        docId: record.unique_id.substring(1),
        docType: record.type,
        tabAction: {
          usr_id: userId,
          document_id: String(record.unique_id.substring(1)),
          matter_id: String(record.matter_id),
          action: "open",
        },
      };
      dispatch(postHighlightedMatter(highlightPayload)).catch((error) => {
        console.error("Failed to post highlighted matter:", error);
      });

      dispatch(setUpdateMeta(record));
      dispatch(setSelectedDetails({ ...record, type: record?.type }));
      dispatch(setTabClick(false));
      dispatch(setSelectedKeys([record.unique_id]));
      updateTitleName(setTitleName, record);

      const target = buildPathWithAIPaneTab(
        `/matter${record.relative_path}`,
        tab
      );
      navigate(target);
    },
    [dispatch, navigate, openTab, setActiveTab, setTitleName]
  );

  // Phase 6 / "The Brief" rename (2026-04-29): AIStatusBadge click-through.
  // The badge in the matter document table fires `onAIBadgeActivate(record)`
  // so the row opens with the AI panel pre-selected to the `analysis`
  // tab (rendered as "The Brief"). All badge variants
  // (`running` / `completed` / `failed`) route to the same destination
  // because the standalone Briefing tab was removed from matter mode in
  // the same change — there's only one AI surface to land on now, and
  // it's where you want to be regardless of which deep-analysis state
  // the badge surfaced. Reuses the row-open pipeline already exercised
  // by `handleRunAIAnalysisFromRow` (open tab → set active → highlight
  // → meta → navigate) so document-state side effects stay consistent
  // across all "open from table" affordances.
  const handleAIBadgeActivate = useCallback(
    (record) => {
      handleRunAIAnalysisFromRow(record, "analysis");
    },
    [handleRunAIAnalysisFromRow]
  );

  const onRowClick = (record, e) => {
    e.stopPropagation();

    // Email files are rendered through the authenticated backend preview.
    if (record.type === 'document' && record.file_type) {
      const isSupported = PDF_FILE_TYPES.includes(record.file_type)
        || MS_FILE_TYPES.includes(record.file_type)
        || IMAGE_FILE_TYPES.includes(record?.file_type)
        || EMAIL_FILE_TYPES.includes(record?.file_type)
        || Boolean(getSharePointOfficeExtension(record));
      if (!isSupported) {
        // Show error toast for unsupported file formats
        dispatch(addNotification({
          id: Date.now().toString(),
          newMsg: 'This file format is not supported in DMS at the moment.',
          success: false,
        }));
        return; // Prevent opening unsupported files
      }
    }

   if(record.type === 'folder' || PDF_FILE_TYPES.includes(record.file_type) || MS_FILE_TYPES.includes(record?.file_type) || IMAGE_FILE_TYPES.includes(record?.file_type) || EMAIL_FILE_TYPES.includes(record?.file_type) || Boolean(getSharePointOfficeExtension(record))){
        // For documents, open tab immediately for instant feedback
        if (record.type === 'document' || PDF_FILE_TYPES.includes(record.file_type) || MS_FILE_TYPES.includes(record?.file_type) || IMAGE_FILE_TYPES.includes(record?.file_type)) {
          const pdfRecord = {
            type: "document",
            record: record,
            file_type: record.file_type,
            unique_id: record.unique_id,
            name: record.name,
            ...record,
          };
          // Open tab immediately (before API calls and navigation)
          openTab(pdfRecord, false);
          // Set as active tab immediately for instant feedback
          setActiveTab(record.unique_id.toString());
        }
        
        // Do API calls in background (don't wait for them)
        // Prepare payload with tab_action for documents
        const highlightPayload = { 
          matterId: record.matter_id, 
          docId: record.unique_id.substring(1), 
          docType: record.type 
        };
        
        // Add tab_action for documents only
        if (record.type === 'document') {
          const userId = Number(localStorage.getItem("user_id"));
          highlightPayload.tabAction = {
            usr_id: userId,
            document_id: String(record.unique_id.substring(1)),
            matter_id: String(record.matter_id),
            action: "open"
          };
        }
        
        dispatch(postHighlightedMatter(highlightPayload)).then((res)=>{
      // Commented out fetchMatterDetail API call - not needed when selecting folder/document from table
      // dispatch(fetchMatterDetail(urlIds[0]));
    }).catch((error) => {
      console.error('Failed to post highlighted matter:', error);
    });
    navigateWithChatbox(navigate, location, `/matter${record.relative_path}`)
    }
    if (record.type === 'folder') {
      setUniqueId(record.unique_id);
    }

    dispatch(setUpdateMeta(record));

    if (
      editingKey === record.unique_id &&
      (record.type === 'folder' || (record.type === 'document' && !record.is_locked))
    ) {
      return;
    }

    if (record.type === 'folder') {
      updateBreadcrumb(breadcrumb, setBreadcrumb, record);
      setCurrentPage(1); // reset UI pagination to page 1

      fetchFolderDetails({setisLoading, dispatch, setExpandedKeys, setSelectedKeys, fetchMatterDetailList, id, currentPage: 1, folderId: record.unique_id}).then((respDetailsList) => {
        if (respDetailsList.payload?.status === 200) {
        } else if (respDetailsList?.payload?.code === "ERR_NETWORK") {
          handleSnackbar("Failed to Open the Folder.")
        }
      })
    }

    dispatch(setSelectedDetails({ ...record, type: record?.type }));
    dispatch(setTabClick(false));
    dispatch(setSelectedKeys([record.unique_id]));
    updateTitleName(setTitleName, record);
    if(PDF_FILE_TYPES.includes(record.file_type) || MS_FILE_TYPES.includes(record?.file_type)){
      openTab(record);
    }
  };

  const getRowProps = () => (record) => {
    const status = record?.sharing_context?.review_assignment_context?.current_status;
    const statusClass = status?.toLowerCase();
    const isHovered = isDraggingOverRow && hoveredRowName === record.name;
    let targetId = null;
    if (record?.type === "folder") {
      targetId = record?.unique_id;
    } else if (record?.type === "document") {
      targetId = record.folder_id;
    }
    const rowClass = statusClass ? "row-" + statusClass : "";
    const hoverClass = isHovered ? "row-drag-hover" : "";
    const combinedClassName = `${rowClass} ${hoverClass}`.trim();
    return {
      className: combinedClassName,
      onClick: (e) => {
        if (e.target?.closest?.(".ant-checkbox-wrapper, .ant-checkbox, input[type='checkbox']")) {
          return;
        }
        onRowClick(record, e);
      },
      onDragOver: (e) => e.preventDefault(),
      onDragEnter: (e) => {
        e.stopPropagation();
        if (record?.type === "folder") {
          setHoveredRowName(record.name); // highlight
          handleDragEnter(setDropTargetName, setIsDraggingOverRow, record.name);// drop target
        } else {
          setHoveredRowName(record.name); // still highlight the doc
          handleDragEnter(setDropTargetName, setIsDraggingOverRow, currentFolder || matterDetails?.matter_displayName || ""); // drop target is folder
        }
      },
      onDrop: (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDraggingOverRow(false);
        setHoveredRowName(null);
        handleDragAndDrop(e, targetId);
      },
    };
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows = []) => {
      setSelectedRowKeys((previousKeys) =>
        preserveOffPageDocumentSelection(
          previousKeys,
          newSelectedRowKeys,
          matterDetailsList
        )
      );
      // The selection state is automatically saved via the useEffect when on tab 1
    },
    // Folders can't participate in bulk document actions (merge etc.), so
    // don't offer them a checkbox at all.
    getCheckboxProps: (record) => ({
      disabled: record?.type === "folder",
    }),
  };

  // "Merge selected" from the table's selection bar: seed the merge flow
  // with the eligible records and jump straight to the reorder/confirm
  // step (the tree picker stays available via its "+ Add Files").
  const handleMergeSelected = (eligibleRecords) => {
    setMergeSeedFiles(eligibleRecords);
    setSelectedRowKeys([]);
    setIsModalOpen(true);
  };

  // "Prepare N for AI": the escape hatch for "just get these ready".
  // One unpreparable scan does not block the rest, so the summary
  // reports per-document outcomes rather than a single pass/fail.
  const handlePrepareSelectedForAi = async (records) => {
    const documentIds = (records || []).map(generatedDocumentId).filter(Boolean);
    if (!documentIds.length) return;
    setPreparingSelectionForAi(true);
    try {
      const result = await bulkPrepareDocuments(documentIds);
      const accepted = result?.accepted || 0;
      const skipped = result?.skipped || 0;
      const failed = result?.failed || 0;
      const parts = [`Preparing ${accepted} document(s) for AI`];
      // "Skipped" is the normal answer when re-preparing a group after
      // adding a couple of new scans, so it is not phrased as a problem.
      if (skipped) parts.push(`${skipped} already ready or in progress`);
      if (failed) parts.push(`${failed} could not be started`);
      handleSnackbar(`${parts.join(" · ")}.`, failed === 0);
      setSelectedRowKeys([]);
    } catch (err) {
      console.error("Failed to bulk prepare documents for AI", err);
      handleSnackbar(
        err?.response?.data?.error || "Failed to start AI preparation."
      );
    } finally {
      setPreparingSelectionForAi(false);
    }
  };

  const handleOpenSaveAsCollection = async (records) => {
    setCollectionCandidates(records || []);
    setCollectionModalOpen(true);
    setLoadingCollections(true);
    try {
      const data = await fetchMatterCollections(id);
      setCollections(data?.collections || []);
    } catch (err) {
      // A failed list still leaves "New collection…" usable, which is
      // the common path; don't block the modal on it.
      console.error("Failed to load document collections", err);
      setCollections([]);
    } finally {
      setLoadingCollections(false);
    }
  };

  const handleSaveAsCollection = async ({ collectionId, name, prepare }) => {
    const documentIds = collectionCandidates
      .map(generatedDocumentId)
      .filter(Boolean);
    if (!documentIds.length) return;
    setSavingCollection(true);
    try {
      let saved;
      if (collectionId) {
        saved = await addCollectionDocuments(collectionId, documentIds);
        if (prepare) await prepareCollection(collectionId);
      } else {
        // `prepare` rides along with create so a dropped response cannot
        // leave a collection saved but never prepared.
        saved = await createCollection({
          matterId: id,
          name,
          documentIds,
          prepare,
        });
      }
      const missing = saved?.missing_document_ids?.length || 0;
      handleSnackbar(
        missing
          ? `Saved to "${name || "collection"}" — ${missing} document(s) could not be found.`
          : `Saved ${documentIds.length} document(s) to "${name || "collection"}".`,
        missing === 0
      );
      setCollectionModalOpen(false);
      setCollectionCandidates([]);
      setSelectedRowKeys([]);
    } finally {
      setSavingCollection(false);
    }
  };

  const handleDeleteSelectedDocuments = async (selectedDocuments) => {
    if (!selectedDocuments?.length) return;
    if (!window.confirm(`Delete ${selectedDocuments.length} selected document(s)?`)) {
      return;
    }
    const documentIds = selectedDocuments.map(generatedDocumentId).filter(Boolean);
    if (!documentIds.length) {
      handleSnackbar("No valid document ids found in the selected rows.");
      return;
    }
    try {
      const res = await bulkDeleteMatterDocuments(id, documentIds);
      const data = res?.data || {};
      const deleted = data.deleted || [];
      const errors = data.errors || [];
      const closedTabIds = deleted.map((doc) => doc.unique_id).filter(Boolean);
      if (closedTabIds.length) {
        closeTabsByIds(tabs, setTabs, closedTabIds);
      }
      setSelectedRowKeys([]);
      refreshMatterDocuments();
      handleSnackbar(
        errors.length
          ? `Deleted ${deleted.length} document(s), ${errors.length} failed.`
          : `Deleted ${deleted.length} document(s).`,
        errors.length === 0
      );
    } catch (err) {
      console.error("Failed to bulk delete selected documents", err);
      handleSnackbar(err?.response?.data?.error || "Failed to delete selected documents.");
    }
  };

  // Refactor handleSave into smaller parts for folder and document rename

  const saveDocumentRename = (ex) => {
    localStorage.setItem("newPdf","")
    resetEditingState(setEditingKey, setEditingValue, setisLoading);
    dispatch(
      pdfRenameDocuments({
        id: ex.unique_id.substring(1),
        newPDFName: `${getNameWithoutExtension(titleName[ex.unique_id]).trim()+getExtension(titleName[ex.unique_id])}`,
      })
    )
      .unwrap()
      .then((res) => {
        if (res.status !== 409) {
          dispatch(fetchMatterDetail(id));
          if (res?.data?.name) {
            updateTabState(tabs, setTabs, ex.unique_id, res.data.name, res.data);
          }

          const fetchListParams = ex.folder_id
            ? { id, page: currentPage, folder: "F" + ex.folder_id }
            : { id, page: currentPage };
          const fetchList = ex.folder_id
            ? dispatch(fetchMatterDetailList(fetchListParams))
            : dispatch(fetchMatterDetailList(fetchListParams));

          fetchList
            .unwrap()
            .then((resp) => {
              if (resp.status === 200) {
                // Update breadcrumb directly after successful rename to show updated name
                // Check if the renamed document is currently active (in document view)
                if (activeTab && activeTab.startsWith("D") && activeTab === ex.unique_id && res?.data?.name) {
                  // Update documentBreadcrumb by finding and updating the document's name
                  setDocumentBreadcrumb((prevBreadcrumb) => {
                    return prevBreadcrumb.map((item) => {
                      // Find the document item by unique_id (with or without 'D' prefix)
                      if (item.id === ex.unique_id || item.id === activeTab) {
                        return { ...item, name: res.data.name };
                      }
                      return item;
                    });
                  });
                }
              }
              resetEditingState(setEditingKey, setEditingValue, setisLoading);
            })
            .catch((err) => {
              resetEditingState(setEditingKey, setEditingValue, setisLoading);
              handleSnackbar(err || "Failed to Fetch Matter Details");
            });
        }
      })
      .catch(() => {
        resetEditingState(setEditingKey, setEditingValue, setisLoading);
        handleSnackbar("Failed to Rename the file");
      });
      
  };

  const handleSave = (ex) => {
    if (
      ex.type === "folder" &&
      editingValue.trim() !== "" &&
      editingValue !== undefined &&
      editingValue !== null
    ) {
      saveFolderRename({ ex,id,currentPage,editingKey,editingValue,setisLoading,setEditingKey,setEditingValue,handleSnackbar,resetEditingState,dispatch,renameFolders,fetchMatterDetail,fetchMatterDetailList,});
    } else if (
      ex.type === "document" &&
      titleName[ex.unique_id]?.trim() !== "" &&
      titleName[ex.unique_id] !== undefined &&
      titleName[ex.unique_id] !== null &&
      titleName[ex.unique_id] !== `.${ex.file_type}`
    ) {
      saveDocumentRename(ex);
    } else {
      resetEditingState(setEditingKey, setEditingValue, setisLoading);
    }
  };

  const renameDocument = (event, docID, type, oldName) => {
      if(docLoading) {
        console.warn("Renaming files on hold:");
        return;
      }
    if(titleName[docID] === oldName && event.key === "Enter") {
      setRenameEditFlag((prev) => ({ ...prev, [docID]: false }));
      localStorage.removeItem("newPdf")
      resetEditingState(setEditingKey, setEditingValue, setisLoading);
      return;
    }
    if (
      event.key === "Enter" &&
      titleName[docID] &&
      titleName[docID] !== `.${type}`
    ) {
      localStorage.removeItem("newPdf")
      resetEditingState(setEditingKey, setEditingValue, setisLoading);
      dispatch(
        pdfRenameDocuments({
          id: docID.substring(1),
          newPDFName: titleName[docID].split(".")[0].trim() + "." + mimeToExtension[type],
        })
      ).then((response) => handleRenameResponse({setRenameEditFlag, setTitleName, fetchMatterDetailList, uniqueId, id, currentPage, sort, sortBy, dispatch, setisLoading, setdrawerError, setShowNotification, response, docID, oldName, activeTab, createUpdatedTab, matterDetailsTree, fetchUpdatedMatterDetails, titleName, breadcrumb, tabs, setTabs, fetchMatterDetail, updateDocumentDetail, setDocumentBreadcrumb, fetchBreadCrumbs})).catch((err) => console.error("Error renaming", err));
    }
  };

const handleBlur = (record, file) =>
  handleBlurUtil(
    {
      titleName,
      setTitleName,
      setRenameEditFlag,
      setPendingRename,
      renameDocument,
      handleSave,
      docLoading,
    },
    record,
    file
  );

const handleReviewAction = (reviewDoc, shareId, reviewType, comment) => {
  const sId = shareId || reviewDoc?.sharing_context?.share_ids[0];
  const docUniqueId = reviewDoc?.unique_id;
  const docId = docUniqueId?.substring(1);
  const tabIsOpen = tabs.some((tab) => tab.id === docUniqueId);
  const reviewStatus = REVIEW_STATUS[reviewType];

  const onSuccess = (message) => {
    handleSnackbar(message , true, false);
    if (tabIsOpen && docUniqueId) {
      closeTab(docUniqueId, true);
    } else {
      const currentUniqueId = selectedKeys[0]
      const fetchListParams = {
        id,
        page: currentPage,
        sort_direction: sort,
        sort_by: sortBy,
        ...(currentUniqueId?.startsWith("F") && { folder: currentUniqueId }),
      }; 
      dispatch(fetchMatterDetailList(fetchListParams));
    }
  };

  const onError = (err) => {
    console.error("Review action failed", err);
    handleSnackbar("Failed to submit action");
  };

  const onComplete = () => {
    setSelectedDoc(null);
  };

  const actionPromise =
    reviewType === "submit"
      ? dispatch(submitAction({ docId, comment }))
      : dispatch(reviewAction({
          shareId: sId,
          reviewStatus,
          comment,
          nextReviewerId:
            reviewType === "approve_forward"
              ? selectedForwardRecipients[0]?.id
              : null,
        }));

  actionPromise
    .unwrap()
    .then((res) => {
      if (res?.status === 200) {
        onSuccess("Action successful");
      }
    })
    .catch(onError)
    .finally(() => {
      setSelectedForwardRecipients([]);
      onComplete();
    });
};

const openModal = (type, message) => {
  const closeHandler = () => setMessageModal(prev => ({ ...prev, isOpen: false }));
  setMessageModal(getModalConfig({ type, closeHandler, message }));
};

  const createUpdatedTab = (
    { item,
      pdfRenameResponse,
      pdf,
      matterDetailsTree,
      fetchUpdatedMatterDetails,
      setRenameEditFlag,
      titleName,
      breadcrumb }
  ) => {
    return {
      id: item.id,
      title: pdfRenameResponse.payload.data.name,
      key:item.id,
      relativePath:pdf.relative_path,
      content: (
        <Document
          documentRecord={pdf}
          isLocked={pdf.is_locked}
          matterDetails={matterDetailsTree}
          fetchUpdatedMatterDetails={fetchUpdatedMatterDetails}
          lockedUser={pdf.locked_by_user}
          setRenameEditFlag={setRenameEditFlag}
          titleName={titleName}
          setOpen={setOpen}
          setFileProp={setFileProp}
          treeData={treeData}
          handleBreadcrumbClick={handleBreadcrumbClick}
          setActiveTab={setActiveTab}
          displayName={matterDetailsTree?.display_name}
          error={drawerError}
          setErrors={setdrawerError}
          rename={true}
          setShowDeleteModal={setShowDeleteModal}
          setShowShareModal={setShowShareModal}
          setShowReviewActionModal={openReviewActionModal}
          setSelectedDoc={setSelectedDoc}
          setOpenReviewNotes={setOpenReviewNotes}
          setOpenESignModal={setOpenESignModal}
          setShareId={setShareID}
          setShowExternalShareModal={setShowExternalShareModal}
          setShowSendMessageModal={setShowSendMessageModal}
          setDocLoading={setDocLoading}
          setSelectedFile={setSelectedFile}
          setIsModalOpen={setIsModalOpen}
        />
      ),
    };
  };

  // Use extracted tab drag handlers (urlIds is already defined at line 354)
  const { handleTabDrop, handleTabDragEnd } = useTabDragHandlers({
    draggedTabId,
    setDraggedTabId,
    dragOverTabId,
    setDragOverTabId,
    tabs,
    setTabs,
    dispatch,
    updateTabOrder,
    urlIds, // urlIds is defined at line 354
    onTabClick,
  });

  // Check scroll position and update button states
  const checkScrollButtons = useCallback(() => {
    const container = tabSectionWrapperRef.current;
    if (!container) {
      setCanScrollLeft(false);
      setCanScrollRight(false);
      setHasScrollableContent(false);
      return;
    }

    const { scrollLeft, scrollWidth, clientWidth } = container;
    // Use a small threshold (2px) to account for rounding errors and ensure buttons show when needed
    const threshold = 2;
    const hasScroll = scrollWidth > clientWidth + threshold;
    setHasScrollableContent(hasScroll);
    
    // Only enable buttons if there's scrollable content
    if (hasScroll) {
      setCanScrollLeft(scrollLeft > threshold);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - threshold);
    } else {
      setCanScrollLeft(false);
      setCanScrollRight(false);
    }
  }, []);

  // Scroll handlers
  const scrollLeft = useCallback(() => {
    const container = tabSectionWrapperRef.current;
    if (container) {
      container.scrollBy({ left: -200, behavior: 'smooth' });
    }
  }, []);

  const scrollRight = useCallback(() => {
    const container = tabSectionWrapperRef.current;
    if (container) {
      container.scrollBy({ left: 200, behavior: 'smooth' });
    }
  }, []);

  // Scroll a specific tab into view
  const scrollTabIntoView = useCallback((tabId, force = false) => {
    const container = tabSectionWrapperRef.current;
    if (!container || !tabId) return;

    // Only auto-scroll if user hasn't manually scrolled, or if forced
    if (!force) {
      // Check if user has manually scrolled
      if (hasUserScrolledRef.current) {
        return; // Don't interrupt user's manual scrolling
      }
      
      // Check if auto-scroll is allowed for this tab/event
      const autoScrollKey = `tab-${tabId}`;
      if (!shouldAutoScrollRef.current.get(autoScrollKey)) {
        return; // Auto-scroll not allowed for this tab
      }
    }

    // Find the tab element by its data-tab-id attribute
    const tabElement = container.querySelector(`[data-tab-id="${tabId}"]`);
    
    if (!tabElement) {
      // If not found, try again after a short delay (for newly rendered tabs)
      setTimeout(() => {
        const retryElement = container.querySelector(`[data-tab-id="${tabId}"]`);
        if (retryElement) {
          scrollTabIntoView(tabId, force);
        }
      }, 100);
      return;
    }

    // Check if tab is outside visible area
    const containerRect = container.getBoundingClientRect();
    const tabRect = tabElement.getBoundingClientRect();
    
    const isOutOfView = tabRect.right > containerRect.right || tabRect.left < containerRect.left;
    
    if (isOutOfView) {
      // Calculate scroll position to bring the tab into view
      const tabOffsetLeft = tabElement.offsetLeft;
      const tabWidth = tabElement.offsetWidth;
      const containerWidth = container.clientWidth;
      
      // Calculate desired scroll position
      let targetScrollLeft;
      
      if (tabRect.right > containerRect.right) {
        // Tab is to the right, scroll it into view from the right
        targetScrollLeft = tabOffsetLeft + tabWidth - containerWidth + 20; // Add small padding
      } else if (tabRect.left < containerRect.left) {
        // Tab is to the left, scroll it into view from the left
        targetScrollLeft = tabOffsetLeft - 20; // Add small padding
      } else {
        // Tab is already visible
        return;
      }
      
      // Ensure target scroll is within bounds
      targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, container.scrollWidth - containerWidth));
      
      // Scroll to the target position
      container.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
      
      // Mark that we've done auto-scroll for this tab, so it won't auto-scroll again
      const autoScrollKey = `tab-${tabId}`;
      shouldAutoScrollRef.current.set(autoScrollKey, false);
    }
  }, []);

  // Calculate dynamic max-width based on available space
  const calculateMaxWidth = useCallback(() => {
    const headerWrapper = tabHeaderWrapperRef.current;
    if (!headerWrapper) {
      setMaxWidth(null);
      return;
    }

    // Get the actual parent container width
    // Start with the TabHeaderWrapper's actual width as baseline
    let parentWidth = headerWrapper.clientWidth;
    
    // Traverse up to find the actual constraining parent (MainContentWrapper)
    // This is the flex container that changes when sidebar/chat panel opens
    let parentElement = headerWrapper.parentElement;
    const measuredWidths = [];
    
    while (parentElement && parentElement !== document.body && parentElement !== document.documentElement) {
      const computedStyle = window.getComputedStyle(parentElement);
      const elementWidth = parentElement.clientWidth;
      
      if (elementWidth > 0) {
        measuredWidths.push({ element: parentElement, width: elementWidth, style: computedStyle });
        
        // Use the MainContentWrapper width (flex: 1 container)
        // This is the actual available space for tabs - it shrinks when sidebar widens
        const flexValue = computedStyle.flex;
        if (computedStyle.display === 'flex' && 
            (flexValue === '1 1 0%' || flexValue === '1' || flexValue?.includes('1'))) {
          parentWidth = elementWidth;
          // Verify this width is correct by checking against viewport and sidebar
          // This ensures we account for sidebar width changes during drag
          const viewportWidth = window.innerWidth;
          let actualSidebarWidth = 0;
          if (showSideBar) {
            const sidebarWrapper = document.querySelector('[class*="SideBarWrapper"]');
            if (sidebarWrapper) {
              const sidebarStyle = window.getComputedStyle(sidebarWrapper);
              actualSidebarWidth = parseFloat(sidebarStyle.width) || 240;
            }
          }
          const chatPanelWidth = isAIPaneOpen(location.search) ? 508 : 0;
          const estimatedFixedWidth = 72 + actualSidebarWidth + 16 + chatPanelWidth;
          const calculatedMaxWidth = viewportWidth - estimatedFixedWidth;
          
          // Use the smaller of measured or calculated to ensure we don't exceed available space
          if (elementWidth > calculatedMaxWidth) {
            parentWidth = Math.max(calculatedMaxWidth, 300);
          }
          break;
        }
        
        // Also check for MatterDetailsWrapper (the root flex container)
        if (computedStyle.width === '100%' && computedStyle.display === 'flex') {
          // This might be MatterDetailsWrapper, but we want MainContentWrapper
          // Continue searching
        }
      }
      
      parentElement = parentElement.parentElement;
    }
    
    // If we didn't find MainContentWrapper, use the largest measured width
    let mainContentWrapperFound = false;
    if (measuredWidths.length > 0) {
      // Check if we found MainContentWrapper
      const mainContent = measuredWidths.find(m => {
        const flexValue = m.style.flex;
        return m.style.display === 'flex' && 
               (flexValue === '1 1 0%' || flexValue === '1' || flexValue?.includes('1'));
      });
      
      if (mainContent) {
        parentWidth = mainContent.width;
        mainContentWrapperFound = true;
      } else if (!parentWidth || parentWidth <= 0) {
        const largestWidth = Math.max(...measuredWidths.map(m => m.width));
        if (largestWidth > 0) {
          parentWidth = largestWidth;
        }
      }
    }
    
    // Always verify parentWidth is correct by checking actual sidebar width
    // This ensures we account for sidebar width changes during drag
    const viewportWidth = window.innerWidth;
    let actualSidebarWidth = 0;
    if (showSideBar) {
      const sidebarWrapper = document.querySelector('[class*="SideBarWrapper"]');
      if (sidebarWrapper) {
        const sidebarStyle = window.getComputedStyle(sidebarWrapper);
        actualSidebarWidth = parseFloat(sidebarStyle.width) || 240;
      } else {
        actualSidebarWidth = 240;
      }
    }
    
    const chatPanelWidth = isAIPaneOpen(location.search) ? 508 : 0;
    const estimatedFixedWidth = 72 + actualSidebarWidth + 16 + chatPanelWidth;
    const calculatedParentWidth = viewportWidth - estimatedFixedWidth;
    
    // Use the smaller of measured width or calculated width to ensure we don't exceed available space
    // This is especially important when sidebar is being dragged
    if (!mainContentWrapperFound || parentWidth > calculatedParentWidth) {
      parentWidth = Math.max(calculatedParentWidth, 300); // Minimum 300px for content
    }
    
    // Final fallback
    if (!parentWidth || parentWidth <= 0) {
      parentWidth = Math.max(calculatedParentWidth, 300);
    }

    // Always reserve space for scroll buttons and action button to prevent cut-off
    // This prevents layout shifts and ensures buttons are never cut off
    const scrollButtonWidth = 32; // Width of scroll button
    const scrollButtonMargin = 4; // Margin on each side of scroll button
    const scrollButtonTotalWidth = scrollButtonWidth + (scrollButtonMargin * 2); // ~40px per button
    
    // Check current scroll state (read from state, but also check DOM to be safe)
    const container = tabSectionWrapperRef.current;
    let needsLeftScroll = false;
    let needsRightScroll = false;
    
    if (container) {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      const threshold = 2;
      needsLeftScroll = scrollLeft > threshold;
      needsRightScroll = scrollLeft < scrollWidth - clientWidth - threshold;
    }
    
    // Always reserve space for right scroll button if there are tabs (it might be needed)
    // Also check if tabs container might overflow
    const tabsContainer = container?.querySelector('[class*="VisibleTabsContainer"]');
    const mightNeedRightScroll = tabsContainer && tabsContainer.scrollWidth > tabsContainer.clientWidth;
    
    // Reserve space for scroll buttons (use current state or DOM check)
    const leftScrollButtonSpace = (canScrollLeft || needsLeftScroll) ? scrollButtonTotalWidth : 0;
    const rightScrollButtonSpace = (canScrollRight || needsRightScroll || mightNeedRightScroll) ? scrollButtonTotalWidth : 0;
    
    // Reserve space for action button (always reserve if not on tab "1")
    const currentActiveTab = activeTab; // Read from closure
    
    // Use generous estimate for action button width
    // "Hide actions" is longer, so we need more space
    const actionButtonWidth = currentActiveTab !== "1" ? 180 : 0; // Increased to 180 for "Hide actions"
    const actionButtonPadding = 12; // padding-left from FixedActionsContainer
    const actionButtonMargin = 12; // Increased margin for safety
    let actionButtonTotalWidth = actionButtonWidth + actionButtonPadding + actionButtonMargin;
    
    // Get all child elements in TabHeaderWrapper
    const children = Array.from(headerWrapper.children);
    let totalFixedWidth = 0;
    let measuredActionButtonWidth = 0;
    
    // Calculate widths of actually rendered fixed elements
    // Only count elements that are actually visible and have valid dimensions
    children.forEach((child) => {
      // Skip the TabSectionWrapper itself
      if (child === tabSectionWrapperRef.current) return;
      
      // Only count elements that are actually rendered and visible
      const computedStyle = window.getComputedStyle(child);
      if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
        return;
      }
      
      const elementWidth = child.offsetWidth;
      // Only count if element has valid width (not 0 or invalid)
      if (elementWidth > 0) {
        const marginLeft = parseFloat(computedStyle.marginLeft) || 0;
        const marginRight = parseFloat(computedStyle.marginRight) || 0;
        const totalElementWidth = elementWidth + marginLeft + marginRight;
        totalFixedWidth += totalElementWidth;
        
        // Check if this is the FixedActionsContainer and measure its actual width
        if (child.querySelector && child.querySelector('[class*="StyledActionButton"]')) {
          measuredActionButtonWidth = totalElementWidth;
          // If we measured the actual width and it's larger, use it with extra buffer
          if (currentActiveTab !== "1" && measuredActionButtonWidth > actionButtonWidth) {
            actionButtonTotalWidth = measuredActionButtonWidth + actionButtonPadding + actionButtonMargin + 12; // Extra buffer
          }
        }
      }
    });
    
    // Get padding and gap from TabHeaderWrapper
    const headerStyle = window.getComputedStyle(headerWrapper);
    const paddingRight = parseFloat(headerStyle.paddingRight) || 0;
    const paddingLeft = parseFloat(headerStyle.paddingLeft) || 0;
    const gap = parseFloat(headerStyle.gap) || 0;
    
    // Calculate reserved space for buttons
    const reservedSpace = leftScrollButtonSpace + rightScrollButtonSpace + actionButtonTotalWidth;
    
    // Account for gap between elements (gap applies between all flex children)
    // Estimate: TabSectionWrapper, scroll buttons (if needed), action button
    const estimatedChildren = 1 + (leftScrollButtonSpace > 0 ? 1 : 0) + (rightScrollButtonSpace > 0 ? 1 : 0) + (actionButtonTotalWidth > 0 ? 1 : 0);
    const gapCount = Math.max(0, estimatedChildren - 1);
    const totalGapWidth = gapCount * gap;
    
    // Use the maximum of actually measured width or reserved space to ensure nothing gets cut off
    const totalFixedSpace = Math.max(totalFixedWidth, reservedSpace);
    
    // Simplified and more aggressive calculation
    // Use the actual measured fixed width, but ensure we reserve enough for action button
    const actualFixedWidth = totalFixedWidth > 0 ? totalFixedWidth : reservedSpace;
    
    // Ensure we always reserve enough space for the action button (especially "Hide actions")
    // Use the maximum of measured width or reserved space to prevent cutoff
    const safeFixedWidth = Math.max(actualFixedWidth, reservedSpace);
    
    // Increased buffer to ensure action button is never cut off
    // Use larger buffer when action button is present
    const safeBuffer = currentActiveTab !== "1" ? 24 : 16; // Larger buffer when action button exists
    
    // Calculate space available for tabs: parent width minus fixed elements
    // Note: chat panel is already accounted for in parentWidth calculation (line 4002-4004)
    const spaceForTabs = parentWidth - safeFixedWidth - paddingRight - paddingLeft - totalGapWidth - safeBuffer;
    
    // Use less aggressive percentage when action button is present to ensure it's never cut off
    // Use 97% when action button exists, 99% otherwise
    const spacePercentage = currentActiveTab !== "1" ? 0.97 : 0.99;
    let finalMaxWidth = spaceForTabs * spacePercentage;
    
    // Ensure minimum width - use a better minimum based on parent width
    const minWidth = Math.max(400, parentWidth * 0.3); // Increased from 300px and 20% to 400px and 30%
    
    // When action button is present (document tab) and the AI panel is closed, reduce width by 100px
    // This ensures action button and share button are never cut off when there are many tabs
    const isAIPaneClosed = !isAIPaneOpen(location.search);
    if (currentActiveTab !== "1" && isAIPaneClosed) {
      // Reduce by 100px to ensure both "Hide actions" and "Share" buttons are fully visible
      finalMaxWidth = Math.max(finalMaxWidth - 100, minWidth);
    }
    
    finalMaxWidth = Math.max(finalMaxWidth, minWidth);
    
    // For any reasonable screen size, ensure we use at least 70% of parent
    // This prevents TabSectionWrapper from getting too small when sidebar widens
    if (parentWidth > 500) {
      const minUsage = parentWidth * 0.75; // Minimum 70% of parent
      finalMaxWidth = Math.max(finalMaxWidth, minUsage);
    }
    
    // For large screens, ensure we use at least 75% of parent
    if (parentWidth > 1000) {
      const minUsageLarge = parentWidth * 0.815; // Minimum 75% of parent
      finalMaxWidth = Math.max(finalMaxWidth, minUsageLarge);
    }
    if (parentWidth > 1800) {
      const minUsageLarge = parentWidth * 0.88; // Minimum 75% of parent
      finalMaxWidth = Math.max(finalMaxWidth, minUsageLarge);
    }
    
    // Cap at parent width minus safe buffer to ensure action button is never cut off
    finalMaxWidth = Math.min(finalMaxWidth, parentWidth - safeBuffer);
    
    setMaxWidth(finalMaxWidth);
  }, [showSideBar, location.search, canScrollLeft, canScrollRight, activeTab, visibleTabs.length]);

  // Check scroll buttons and calculate max-width on mount, resize, and scroll
  useEffect(() => {
    // Use a longer delay to ensure all elements are rendered and measured
    const initialDelay = setTimeout(() => {
      checkScrollButtons();
      calculateMaxWidth();
    }, 100);
    
    const container = tabSectionWrapperRef.current;
    const headerWrapper = tabHeaderWrapperRef.current;
    
    if (container && headerWrapper) {
      const handleUpdate = () => {
        checkScrollButtons();
        // Use requestAnimationFrame with a small delay to ensure layout is complete
        requestAnimationFrame(() => {
          setTimeout(() => {
            calculateMaxWidth();
          }, 50);
        });
      };
      
      // Track manual scrolling by user
      let scrollTimeout;
      const handleScroll = () => {
        checkScrollButtons();
        
        // Detect if this is a user-initiated scroll (not programmatic)
        // Clear any pending auto-scroll
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          // After scroll stops, mark that user has scrolled
          hasUserScrolledRef.current = true;
        }, 100);
      };
      
      container.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleUpdate);
      
      // Use ResizeObserver to detect content changes (including chat panel open/close, sidebar resize)
      const containerObserver = new ResizeObserver((entries) => {
        // Check if sidebar width changed
        const sidebarChanged = entries.some(entry => {
          const target = entry.target;
          const classList = target.classList ? target.classList.toString() : '';
          return classList.includes('SideBarContainer') ||
                 classList.includes('SideBarWrapper') ||
                 classList.includes('MatterDetailsWrapper') ||
                 classList.includes('MainContentWrapper');
        });
        
        // If sidebar or main content changed, recalculate immediately
        if (sidebarChanged) {
          // Immediate recalculation when sidebar changes (during drag)
          // Use requestAnimationFrame for smooth updates
          requestAnimationFrame(() => {
            calculateMaxWidth();
            checkScrollButtons();
            // Scroll active tab into view when layout changes (only if allowed)
            if (activeTab && activeTab !== "1") {
              const autoScrollKey = `tab-${activeTab}`;
              if (shouldAutoScrollRef.current.get(autoScrollKey)) {
                setTimeout(() => {
                  scrollTabIntoView(activeTab);
                }, 100);
              }
            }
          });
        } else {
          // Debounce other resize observer updates
          setTimeout(() => {
            handleUpdate();
            // Scroll active tab into view when layout changes (only if allowed)
            if (activeTab && activeTab !== "1") {
              const autoScrollKey = `tab-${activeTab}`;
              if (shouldAutoScrollRef.current.get(autoScrollKey)) {
                setTimeout(() => {
                  scrollTabIntoView(activeTab);
                }, 100);
              }
            }
          }, 50);
        }
      });
      containerObserver.observe(container);
      containerObserver.observe(headerWrapper);
      
      // Observe the TabViewWrapper to catch layout changes
      const tabViewWrapper = container.closest('[class*="TabViewWrapper"]');
      if (tabViewWrapper) {
        containerObserver.observe(tabViewWrapper);
      }
      
      // Observe the MainContentWrapper parent to catch sidebar/chat panel changes
      // This is the key element that changes when sidebar width or chat panel state changes
      let mainContentWrapper = headerWrapper.parentElement;
      while (mainContentWrapper && mainContentWrapper !== document.body) {
        const computedStyle = window.getComputedStyle(mainContentWrapper);
        // Check if this is MainContentWrapper (has flex: 1)
        if (computedStyle.display === 'flex' && (computedStyle.flex === '1 1 0%' || computedStyle.flex === '1')) {
          containerObserver.observe(mainContentWrapper);
          break;
        }
        mainContentWrapper = mainContentWrapper.parentElement;
      }
      
      // Also observe MatterDetailsWrapper to catch all layout changes (including sidebar width changes)
      let matterDetailsWrapper = headerWrapper.closest('[class*="MatterDetailsWrapper"]');
      if (!matterDetailsWrapper) {
        matterDetailsWrapper = headerWrapper.parentElement;
        while (matterDetailsWrapper && matterDetailsWrapper !== document.body) {
          const computedStyle = window.getComputedStyle(matterDetailsWrapper);
          if (computedStyle.display === 'flex' && computedStyle.width === '100%') {
            containerObserver.observe(matterDetailsWrapper);
            break;
          }
          matterDetailsWrapper = matterDetailsWrapper.parentElement;
        }
      } else {
        containerObserver.observe(matterDetailsWrapper);
      }
      
      // Also observe SideBarContainer and SideBarWrapper to catch sidebar width changes
      const sidebarContainer = document.querySelector('[class*="SideBarContainer"]');
      if (sidebarContainer) {
        containerObserver.observe(sidebarContainer);
      }
      
      // Also observe SideBarWrapper directly to catch width changes
      const sidebarWrapper = document.querySelector('[class*="SideBarWrapper"]');
      if (sidebarWrapper) {
        containerObserver.observe(sidebarWrapper);
      }
      
      return () => {
        clearTimeout(initialDelay);
        clearTimeout(scrollTimeout);
        container.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleUpdate);
        containerObserver.disconnect();
      };
    }
    
    return () => clearTimeout(initialDelay);
  }, [checkScrollButtons, calculateMaxWidth, visibleTabs.length, activeTab, showActions, scrollTabIntoView]);

  // Recalculate when location changes (chat panel open/close)
  useEffect(() => {
    // Delay to allow layout to update after chat panel opens/closes
    const timer = setTimeout(() => {
      calculateMaxWidth();
      checkScrollButtons();
    }, 100);
    
    return () => clearTimeout(timer);
  }, [location.search, calculateMaxWidth, checkScrollButtons]);

  // Scroll active tab into view when it changes (especially for newly opened tabs)
  useEffect(() => {
    if (activeTab && activeTab !== "1") {
      // Reset manual scroll flag for new tab (so it can auto-scroll)
      // Only reset if this is a different tab than before
      const prevTab = prevActiveTabRef.current;
      if (prevTab !== activeTab) {
        hasUserScrolledRef.current = false;
        prevActiveTabRef.current = activeTab;
      }
      
      // Allow auto-scroll for this tab (first time only)
      const autoScrollKey = `tab-${activeTab}`;
      shouldAutoScrollRef.current.set(autoScrollKey, true);
      
      // Delay to ensure the tab is rendered in the DOM
      const timer = setTimeout(() => {
        scrollTabIntoView(activeTab);
      }, 150);
      
      return () => clearTimeout(timer);
    }
  }, [activeTab, scrollTabIntoView, visibleTabs.length]);

  // Scroll active tab into view when layout changes (sidebar/chat panel open/close/resize)
  // This ensures the active tab remains visible when the container shrinks
  // Always scroll into view when sidebar/chat panel opens (not just first time)
  useEffect(() => {
    if (activeTab && activeTab !== "1") {
      // Reset manual scroll flag when layout changes
      // This allows auto-scroll even if user scrolled before, since layout change might hide the tab
      hasUserScrolledRef.current = false;
      
      // Allow auto-scroll for this tab when layout changes
      const autoScrollKey = `tab-${activeTab}`;
      shouldAutoScrollRef.current.set(autoScrollKey, true);
      
      // Delay to allow layout to update after sidebar/chat panel changes
      const timer = setTimeout(() => {
        // Force scroll on layout change to ensure tab comes into view
        scrollTabIntoView(activeTab, true);
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [showSideBar, location.search, scrollTabIntoView, activeTab]);

  return (
    <>
      <TabViewWrapper>
          <TabHeaderWrapper ref={tabHeaderWrapperRef}>
            {/* Fixed collapse button - rendered outside scrollable area */}
            {collapseButtonTab && !showSideBar && (
              <FixedCollapseButtonContainer>
                <TabItem 
                  key={collapseButtonTab.id} 
                  {...getTabItemProps(collapseButtonTab, -1)} 
                  tabCount={visibleTabs.length}
                >
                  {renderTabContent(collapseButtonTab, {
                    setShowSideBar,
                    activeTab,
                    matterDetails,
                    matterDetailsTree,
                    renderDocumentTabProps: {
                      activeTab,
                      renameEditFlag,
                      titleName,
                      setTitleName,
                      updateTitleName,
                      renameDocument,
                      handleBlur,
                    },
                  })}
                </TabItem>
              </FixedCollapseButtonContainer>
            )}
            {hasScrollableContent && (
              <TabScrollButtonLeft 
                onClick={scrollLeft} 
                disabled={!canScrollLeft}
                aria-label="Scroll tabs left"
              >
                <ScrollButtonIconWrapper>
                <CaretLeft />
                </ScrollButtonIconWrapper>
              </TabScrollButtonLeft>
            )}
            <TabSectionWrapper 
              ref={tabSectionWrapperRef} 
              style={{ maxWidth: maxWidth ? `${maxWidth}px` : 'none' }}
            >
              <VisibleTabsContainer tabCount={visibleTabs.length}>
                {visibleTabs.map((tab, index) => (
                  <TabItem key={tab.id} {...getTabItemProps(tab, index)} tabCount={visibleTabs.length} data-tab-id={tab.id}>
                    {renderTabContent(tab, {
                      setShowSideBar,
                      activeTab,
                      matterDetails,
                      matterDetailsTree,
                      renderDocumentTabProps: {
                        activeTab,
                        renameEditFlag,
                        titleName,
                        setTitleName,
                        updateTitleName,
                        renameDocument,
                        handleBlur,
                      },
                    })}
                    <TabCloseButton tab={tab} activeTab={activeTab} hoveredTab={hoveredTab} closeTab={closeTab} />
                  </TabItem>
                ))}
              </VisibleTabsContainer>
            </TabSectionWrapper>
            {hasScrollableContent && (
              <TabScrollButtonRight 
                onClick={scrollRight} 
                disabled={!canScrollRight}
                aria-label="Scroll tabs right"
              >
                <ScrollButtonIconWrapper>
                   <CaretRight />
                </ScrollButtonIconWrapper>
               
              </TabScrollButtonRight>
            )}
            <FixedActionsContainer>
              {activeTab !== "1" && (
                <StyledActionButton onClick={() => handleShowActions(dispatch, showActions, updateShowActions)}>
                  {showActions ? <Popover placement="left" content={"Hide action panel"}><CaretDoubleUp size={20} color="#5A6C87" /></Popover> : <Popover placement="left" content={"Expand action panel"}><CaretDoubleDown size={20} color="#5A6C87"/></Popover>}
                </StyledActionButton>
              )}
            </FixedActionsContainer>
          </TabHeaderWrapper>
          {/* Table of PDFs in Tab 1 - Always render, hide via CSS when not active */}
            <TabContentArea
            ref={tabContentAreaRef}
              showSideBar={showSideBar}
              isDraggingOverRow={isDraggingOverRow}
            style={{
              display: activeTab === "1" ? 'block' : 'none',
              visibility: activeTab === "1" ? 'visible' : 'hidden',
              opacity: activeTab === "1" ? 1 : 0,
              pointerEvents: activeTab === "1" ? 'auto' : 'none',
              position: 'relative', // For absolute positioning of loader
            }}
              {...(!emptyTable && !showMatterDashboard && {
              onDrop: (e) => handleDragAndDrop(e, folderId),
              onDragOver: (e) => e.preventDefault(),
              onDragEnter: () => {
                handleDragEnter(setDropTargetName, setIsDraggingOverRow,
                  currentFolder || matterDetails?.matter_displayName || ""
                );
              },
              onDragLeave: (e) => {
                if (e.currentTarget.contains(e.relatedTarget)) return;
                setIsDraggingOverRow(false);
                setHoveredRowName(null);
              },
              })}
            >
            {clipboardItems.length > 0 && (
              <ClipboardPasteBar
                count={clipboardItems.length}
                destinationName={pasteDestinationName}
                onPaste={handlePasteHere}
                pasting={pastingClipboard}
              />
            )}
            {showMatterDashboard ? (
              <MatterDashboard
                matterId={id}
                matterDetails={matterDetails}
                matterTree={matterDetailsTree}
                onOpenDocument={openDocumentFromDashboard}
                onBrowseFiles={() => setRootView("files")}
                isDropActive={dashDropActive}
                onDragStateChange={setDashDropActive}
                onDropFiles={(e) => {
                  e.preventDefault();
                  setDashDropActive(false);
                  handleDragAndDrop(e, folderId);
                }}
                uploadSlot={
                  <Box
                    className="doc-actions"
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      width: "100%",
                      maxWidth: "100%",
                      minWidth: 0,
                    }}
                  >
                    <SharedOutsideBadge
                      count={expertShare.count}
                      recipients={expertShare.recipients}
                    />
                    <Button onClick={() => setShowExpertShareModal(true)}>
                      Share with an outside expert
                    </Button>
                    <Button onClick={openGeneratePackageModal}>
                      Generate Package
                    </Button>
                    <Button
                      onClick={() =>
                        templateUploadButtonRef.current?.openTemplatePicker()
                      }
                    >
                      Create Doc from Template
                    </Button>
                    <Button onClick={() => setShowSignatureLauncher(true)}>
                      Send Doc for E-Signature
                    </Button>
                    <UploadButton
                      ref={templateUploadButtonRef}
                      openNewPDF={openNewPDF}
                      handleUpload={handleUpload}
                      setCurrentPage={setCurrentPage}
                      setEditingKey={setEditingKey}
                      setEditingValue={setEditingValue}
                      treeData={treeData}
                      matterId={id}
                      showENotification={showNotification}
                      setShowENotification={setShowNotification}
                      on={(e) => {
                        e.stopPropagation();
                      }}
                      setisLoading={setisLoading}
                    />
                  </Box>
                }
              />
            ) : (
            <>
            {/* Loader for Tab 1 - shows when tab opens, list is loading, or pagination is loading */}
            {isTableLoading && (
              <InstanceLoader message="Loading documents..." />
            )}
            
              <TabContentHeaderWrapper>
                <Breadcrumb
                  breadcrumb={breadcrumb}
                  onBreadcrumbClick={handleBreadcrumbClick}
                />
                 
                 <Box
                   className="doc-actions"
                   sx={{
                     display: "flex",
                     flexWrap: "wrap",
                     alignItems: "center",
                     justifyContent: "flex-end",
                     gap: "8px",
                     flex: "1 1 240px",
                     maxWidth: "100%",
                     minWidth: 0,
                   }}
                 >
                   {matterDetailsLIstStatus === "loading" && (
                     <InlineLoader text="Updating document list" />
                   )}
                   <SharedOutsideBadge
                     count={expertShare.count}
                     recipients={expertShare.recipients}
                   />
                   <Button onClick={() => setShowExpertShareModal(true)}>
                     Share with an outside expert
                   </Button>
                   <Button onClick={openGeneratePackageModal}>
                     Generate Package
                   </Button>
                   <Button
                     onClick={() =>
                       templateUploadButtonRef.current?.openTemplatePicker()
                     }
                   >
                     Create Doc from Template
                   </Button>
                   <Button onClick={() => setShowSignatureLauncher(true)}>
                     Send Doc for E-Signature
                   </Button>
                   <UploadButton
                    ref={templateUploadButtonRef}
                    openNewPDF={openNewPDF}
                    handleUpload={handleUpload}
                    setCurrentPage={setCurrentPage}
                    setEditingKey={setEditingKey}
                    setEditingValue={setEditingValue}
                    treeData={treeData}
                    matterId={id}
                    showENotification={showNotification}
                    setShowENotification={setShowNotification}
                    on={(e) => {
                      e.stopPropagation();
                    }}
                    setisLoading={setisLoading}
                  />
                </Box>
              </TabContentHeaderWrapper>
            {/*
              Per-matter AI pipeline status surface (BE PRs #655 / #656).
              Lives directly above the documents table on the matter root tab.
              Reads activity rollups + `errored_documents` already on the
              `matterDetails` payload and posts to
              `POST /api/matters/<id>/documents/retry-errors/` for retries.
              Self-hides on matters with no documents or when everything is
              already processed (renders a single "Ready for analysis" badge
              instead), so the chrome stays quiet on the happy path.
            */}
            <MatterProcessingStatus matter={matterDetails} />
            <MergeSelectedBar
              selectedRowKeys={selectedRowKeys}
              rows={matterDetailsList || []}
              onMerge={handleMergeSelected}
              onDelete={handleDeleteSelectedDocuments}
              onClear={() => setSelectedRowKeys([])}
              onPageBuilder={pdfTools.openPageBuilder}
              onPrepareForAi={handlePrepareSelectedForAi}
              onSaveAsCollection={handleOpenSaveAsCollection}
              onCopy={handleCopyRecords}
              preparingForAi={preparingSelectionForAi}
            />
            <div style={{ position: 'relative' }}>
              <Table
                columns={MatterDetailsTableColumn({
                  editingKey,
                  editingValue,
                  setEditingKey,
                  setEditingValue,
                  handleSave,
                  setTitleName,
                  renameEditFlag,
                  setCurrentPage,
                  sortBy,
                  setSortBy,
                  sort,
                  setSort,
                  titleName,
                  setOpen,
                  setFileProp,
                  setShowDeleteModal,
                  setShowShareModal,
                  setShowAssignModal,
                  setShowExternalShareModal,
                  handleBlur,
                  setSelectedDoc,
                  setOpenReviewNotes,
                  setOpenESignModal,
                  openReviewActionModal,
                  setShowSendToVAModal,
                  isVaAgencyMatter,
                  setIsModalOpen,
                  setSelectedFile,
                  onRunAIAnalysis: handleRunAIAnalysisFromRow,
                  runningAnalysisDocIds,
                  onAIBadgeActivate: handleAIBadgeActivate,
                  categorizationFlags,
                  onCategorize: handleCategorize,
                  onExportPdf: pdfTools.exportAsPdf,
                  onOpenPageBuilder: pdfTools.openPageBuilder,
                  onCopy: handleCopyRecords,
                  onPasteIntoFolder: handlePasteIntoFolder,
                  clipboardCount: clipboardItems.length,
                  onDownload: handleDownloadDocument,
                })}
                data={matterDetailsList || []}
                onRow={getRowProps()}
                emptyMessage={<EmptyTableComponent setShowDragNotification={setShowNotification} /> }
                rowSelection={rowSelection}
                loading={matterDetailsStatus === "loading1"}
                loadingComponent={<MatterDetailsSkeleton rows={8} />}
                onDragLeave={(e) => {
                  if (e.currentTarget.contains(e.relatedTarget)) {
                    return;
                  }
                  setIsDraggingOverRow(false);
                  setHoveredRowName(null);
                }}
              />
              {matterDetailsList?.length > 0 && (
                <PaginationContainer>
                  <Pagination
                    total={totalRecords}
                    current={currentPage}
                    pageSize={pageSize}
                    onChange={(page) => {
                      // Selection maps to rows on the visible page; keys
                      // from other pages can't be bulk-actioned, so drop
                      // them instead of letting counts overpromise.
                      setSelectedRowKeys([]);
                      handlePageChange(setCurrentPage, dispatch, null, page, setIsPaginationLoading);
                    }}
                    adjustable={false}
                    onPageSizeChange={(pageSize) => {
                      setSelectedRowKeys([]);
                      handlePageSizeChange(setCurrentPage, dispatch, setDocListingPageSize, pageSize);
                    }}
                  />
                </PaginationContainer>
              )}
            </div>
            </>
            )}
            </TabContentArea>
          
          {/* Document Content Area - Always render, hide via CSS when on tab "1" or "0" */}
          <DocumentContentArea 
            showActions={showActions}
            style={{
              display: (activeTab === "1" || activeTab === "0") ? 'none' : 'block',
              visibility: (activeTab === "1" || activeTab === "0") ? 'hidden' : 'visible',
              opacity: (activeTab === "1" || activeTab === "0") ? 0 : 1,
              pointerEvents: (activeTab === "1" || activeTab === "0") ? 'none' : 'auto',
            }}
          >
              {/* WebViewer containers - one per tab, each containing its own breadcrumbs and share buttons */}
              {/* Always render all document tab containers (not "1" or "0") - they stay in DOM and are hidden/shown via CSS */}
              {tabs.filter(tab => tab.id !== "1" && tab.id !== "0").map(tab => {
                const containerId = `webviewer-container-${tab.id}`;
                // Get document data and breadcrumbs for this tab
                const tabDocumentData = webViewerInstances.getTabDocumentData(tab.id);
                const tabBreadcrumb = tabBreadcrumbs.get(tab.id) || [];
                const isActiveTab = activeTab === tab.id;
                
                // Extract document ID from tab.id (format: "D4018049")
                const tabDocumentId = tab.id.startsWith('D') ? tab.id.substring(1) : tab.id;
                
                // Check if documentDetail matches the current tab's document
                const documentDetailId = documentDetail?.id?.toString() || documentDetail?.unique_id?.substring(1);
                const documentDetailMatchesTab = documentDetailId === tabDocumentId;
                
                // Use active tab's documentDetail only if it matches the tab, otherwise use stored data or null
                const currentDocDetail = isActiveTab 
                  ? (documentDetailMatchesTab ? documentDetail : null)
                  : tabDocumentData;
                const currentDocumentName =
                  currentDocDetail?.name || tabDocumentData?.name || tab.title || "";
                const currentDocumentType = String(
                  currentDocDetail?.file_type ||
                  tabDocumentData?.file_type ||
                  currentDocumentName.split(".").pop() ||
                  ""
                ).toLowerCase().replace(".", "");
                const isWordDocument =
                  currentDocumentType === "doc" || currentDocumentType === "docx";
                
                const isThisTabActive = activeTab === tab.id;
                const isMatterListActive = activeTab === "1" || activeTab === "0";
                const isTabVisible = isThisTabActive && !isMatterListActive;
                return (
                  <div
                    key={tab.id}
                    id={containerId}
                    style={{
                      width: '100%',
                      height: '100%',
                      border: "1px solid #DDE2E9",
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      visibility: isTabVisible ? 'visible' : 'hidden',
                      opacity: isTabVisible ? 1 : 0,
                      zIndex: isTabVisible ? 10 : 0,
                      pointerEvents: isTabVisible ? 'auto' : 'none',
                      padding :"24px",
                    }}
                  >
                    {/* Instance Loader - shows when WebViewer instance is initializing for this tab */}
                    {isInstanceLoading && isActiveTab && (
                      <InstanceLoader message="Loading Editor..." />
                    )}
                    
                    {/* Breadcrumbs and Share buttons - per tab */}
              {showActions && (
                      <DocumentContentHeaderWrapper
                        style={{
                          zIndex: 20,
                          background: '#fff',
                          position: 'relative',
                          flexShrink: 0,
                        }}
                      >
                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <Breadcrumb
                            breadcrumb={tabBreadcrumb.length > 0 ? tabBreadcrumb : (isActiveTab ? documentBreadcrumb : [])}
                      onBreadcrumbClick={(folderId, index) => {
                              const breadcrumb = tabBreadcrumb.length > 0 ? tabBreadcrumb : (isActiveTab ? documentBreadcrumb : []);
                              if (index + 1 !== breadcrumb?.length) {
                                handleBreadcrumbClick(folderId, index, breadcrumb);
                          setActiveTab("1");
                        }
                      }}
                    />
                    {/* PR A — version + last-edited chip. Renders nothing when */}
                    {/* version is missing (empty matter list, folder views, etc.) */}
                    {/* so it's safe to leave unconditionally on every doc tab. */}
                    <DocumentVersionPill
                      version={currentDocDetail?.version}
                      lastModified={currentDocDetail?.last_modified}
                      onClick={() =>
                        setVersionHistoryTarget({
                          tabId: tab.id,
                          documentRecord: currentDocDetail || tabDocumentData,
                        })
                      }
                    />
                  </div>
                  <div>
                          {currentDocDetail?.is_locked && 
                           currentDocDetail?.locked_by !== Number(localStorage.getItem("user_id")) ? (
                      <WarningLabel>
                        File is being edited by{" "}
                              <SpanName>{currentDocDetail?.locked_by_user || currentDocDetail?.locked_by_name}</SpanName>. Only{" "}
                        <SpanBold>view mode</SpanBold> is enabled
                      </WarningLabel>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: "flex-end",
                          gap: "8px",
                                alignItems: "center",
                              }}
                            >
                              {isActiveTab && autoSave && (
                                <WarningLabel>{autoSave}</WarningLabel>
                              )}
                              {shouldOpenSharePointDocument(currentDocDetail) && (
                                (isActiveTab && loadingStatus==="loading") ? (
                                  <ViewMSWrapper>Returning you to the page you last viewed. Please wait...</ViewMSWrapper>
                                ) : (
                          <ViewMSWrapper>
                            <ViewMSFileButton onClick={() => {
                              openSharePointDocument(currentDocDetail);
                            }}>
                              Edit Document
                            </ViewMSFileButton>
                            <Tooltip title="Use this after editing in Word to show the latest saved version in DMS.">
                              <span>
                                <ViewMSFileButton
                                  $quiet
                                  disabled={
                                    refreshingSharePointDocumentId === (
                                      (currentDocDetail || tabDocumentData)?.id ||
                                      ((currentDocDetail || tabDocumentData)?.unique_id
                                        ? (currentDocDetail || tabDocumentData).unique_id.substring(1)
                                        : null)
                                    )
                                  }
                                  onClick={() => {
                                    handleRefreshSharePointDocument(
                                      currentDocDetail || tabDocumentData,
                                      tab.id
                                    );
                                  }}
                                >
                                  {refreshingSharePointDocumentId === (
                                    (currentDocDetail || tabDocumentData)?.id ||
                                    ((currentDocDetail || tabDocumentData)?.unique_id
                                      ? (currentDocDetail || tabDocumentData).unique_id.substring(1)
                                      : null)
                                  )
                                    ? "Refreshing..."
                                    : "Refresh Document Changes"}
                                </ViewMSFileButton>
                              </span>
                            </Tooltip>
                          </ViewMSWrapper>
                                )
                        )}
                        {(markdownContentByTab[tab.id] || currentDocDetail?.markdown_content) && (
                          <Segmented
                            value={viewModeByTab[tab.id] || 'pdf'}
                            onChange={(val) => setViewModeByTab(prev => ({ ...prev, [tab.id]: val }))}
                            options={[
                              { label: 'PDF', value: 'pdf' },
                              { label: 'Formatted', value: 'formatted' },
                              { label: 'Source', value: 'source' },
                            ]}
                            size="small"
                          />
                        )}
                        <FinalizePdfButton
                          instance={webViewerInstances.getInstance(tab.id)}
                          documentRecord={currentDocDetail || tabDocumentData}
                          disabled={!isActiveTab}
                          onFinalized={(savedDocument) => {
                            if (!savedDocument) return;
                            const finalizedDocument = {
                              ...(webViewerInstances.getTabDocumentData(tab.id) ||
                                tab.documentRecord ||
                                {}),
                              ...savedDocument,
                            };
                            webViewerInstances.updateTabDocumentData(
                              tab.id,
                              finalizedDocument
                            );
                            setTabs((currentTabs) =>
                              mergeFinalizedDocumentIntoTabs(
                                currentTabs,
                                tab.id,
                                finalizedDocument
                              )
                            );
                            dispatch(setUpdateMeta(finalizedDocument));
                            dispatch(updateDocumentDetail(finalizedDocument));
                          }}
                        />
                        <ViewMSFileButton
                          type="button"
                          data-testid="create-work-item-button"
                          $quiet={shouldOpenSharePointDocument(currentDocDetail)}
                          disabled={!isActiveTab}
                          onClick={() => {
                            const record = currentDocDetail || tabDocumentData;
                            setSelectedDoc(record);
                            setShowWorkItemModal(true);
                          }}
                        >
                          Create Work Item
                        </ViewMSFileButton>
                        <MoreButton
                          buttonText="Share"
                          variant="secondary"
                          top={"40px"}
                          customwidth={"unset"}
                          menuOptions={[
                            {
                              label: "External Share",
                              icon: ExternalShare,
                              onClick: () => {
                                setShowExternalShareModal(true);
                                      setSelectedDoc(currentDocDetail);
                              },
                            },
                            {
                              label: "Send Message",
                              icon: SendIcon,
                              onClick: () => {
                                setSelectedDoc(currentDocDetail);
                                setShowSendMessageModal(true);
                              },
                            },
                          ]}
                        />
                        {(shareContext?.workflow_actions?.includes("approve_task") ||
                          shareContext?.workflow_actions?.includes("approve_forward") ||
                          shareContext?.workflow_actions?.includes("request_rework")) && (
                          <MoreButton
                            customwidth={"unset"}
                            buttonText="Actions"
                            variant="secondary"
                            top={"40px"}
                            menuOptions={[
                              {
                                label: "Approve",
                                icon: Approve,
                                onClick: () => {
                                        setSelectedDoc(currentDocDetail);
                                  setShowReviewActionModal("approve");
                                        openReviewActionModal("approve");
                                },
                              },
                              {
                                label: "Approve & forward to…",
                                icon: Approve,
                                onClick: () => {
                                  setSelectedDoc(currentDocDetail);
                                  openReviewActionModal("approve_forward");
                                },
                              },
                              {
                                label: "Request Rework",
                                icon: Rework,
                                onClick: () => {
                                        setSelectedDoc(currentDocDetail);
                                  setShowReviewActionModal("rework");
                                        openReviewActionModal("rework");
                                },
                              },
                            ]}
                            disabled={!shareContext?.action_enabled}
                          />
                        )}
                        {shareContext?.workflow_actions?.length === 1 && 
                         shareContext?.workflow_actions[0] === "submit" && (
                                <ConfirmButton
                            disabled={!shareContext?.submit_enabled}
                            onClick={() => {
                                    setSelectedDoc(currentDocDetail);
                              setShowReviewActionModal("submit");
                                     openReviewActionModal("submit");
                                  }}
                                > Submit </ConfirmButton>
                        )}
                        <MoreButton
                          top={"40px"}
                          customwidth={"unset"}
                          menuOptions={[
                            isWordDocument && {
                              label: "Add to Brief Bank",
                              onClick: () => {
                                setSelectedDoc(currentDocDetail || tabDocumentData);
                                setBriefBankModalOpen(true);
                              },
                            },
                            {
                              label: "Download",
                              icon: DownloadIcon,
                              onClick: () => {
                                handleDownloadDocument(
                                  currentDocDetail || tabDocumentData
                                );
                              },
                            },
                            {
                              label: "Rename",
                              icon: Rename,
                              onClick: () => {
                                setRenameEditFlag((prev) => ({
                                  ...prev,
                                        [currentDocDetail?.unique_id]: true,
                                }));
                              },
                            },
                            {
                              label: "Delete",
                              icon: Delete,
                              onClick: () => {
                                setShowDeleteModal(true);
                                      setSelectedDoc(currentDocDetail);
                                    },
                                  },
                                  (PDF_FILE_TYPES.includes(tabDocumentData?.file_type) || MS_FILE_TYPES.includes(tabDocumentData?.file_type)) &&{
                              label: "Merge Files",
                              icon: Merge,
                              onClick: () => {
                                      setSelectedFile(currentDocDetail);
                                setIsModalOpen(true);
                              },
                            },
                                  (PDF_FILE_TYPES.includes(tabDocumentData?.file_type) || MS_FILE_TYPES.includes(tabDocumentData?.file_type)) && {
                              label: "PDF Page Builder",
                              icon: Merge,
                              onClick: () => {
                                pdfTools.openPageBuilder([currentDocDetail]);
                              },
                            },
                                  MS_FILE_TYPES.includes(tabDocumentData?.file_type) && {
                              label: "Export as PDF",
                              icon: FilePropertiesIcon,
                              onClick: () => {
                                pdfTools.exportAsPdf(currentDocDetail);
                              },
                            },
                            {
                              label: "File Properties",
                              icon: FilePropertiesIcon,
                                    onClick: handleOpenFileProperties,
                                  },
                                  currentDocDetail?.is_review_notes_available && {
                              label: "Review Notes",
                              icon: ReviewNotes,
                              onClick: () => {
                                      setSelectedDoc(currentDocDetail);
                                setOpenReviewNotes(true);
                              },
                            },
                            {
                              label: "Send for E-Signature",
                              icon: ESignImage,
                              onClick: () => {
                                      setSelectedDoc(currentDocDetail);
                                setOpenESignModal(true);
                              },
                            },
                            canPlaceAttorneySignature && currentDocumentType === "pdf" && {
                              label: "Add attorney signature",
                              icon: ESignImage,
                              onClick: () => {
                                setAttorneySignatureDoc({
                                  id: tabDocumentId,
                                  name: currentDocumentName,
                                });
                              },
                            },
                            isVaAgencyMatter && {
                              label: "Submit to VA",
                              icon: SendIcon,
                              onClick: () => {
                                const selectedDocument =
                                  currentDocDetail || tabDocumentData;
                                setFileProp(selectedDocument);
                                setSelectedDoc(selectedDocument);
                                setShowSendToVAModal(true);
                              },
                            },
                          ].filter(Boolean)}
                        />
                      </div>
                    )}
                  </div>
                </DocumentContentHeaderWrapper>
              )}
                    {showActions && isActiveTab && (
                      <DocumentWorkItemBar documentId={tabDocumentId} />
                    )}
                    {/* Inner container for WebViewer - this is what gets passed to the hook */}
                    <div
                      ref={(el) => {
                        if (el) {
                          webViewerInstances.registerContainer(tab.id, el);
                        }
                      }}
                style={{
                        flex: 1,
                        position: 'relative',
                  width: '100%',
                  height: '100%',
                        overflow: 'hidden',
                        border: '1px solid rgb(221, 226, 233)',
                        display: (viewModeByTab[tab.id] && viewModeByTab[tab.id] !== 'pdf') ? 'none' : undefined,
                }}
              />
                    {(viewModeByTab[tab.id] === 'formatted' || viewModeByTab[tab.id] === 'source') && (
                      <MarkdownViewer
                        content={markdownContentByTab[tab.id] || currentDocDetail?.markdown_content}
                        mode={viewModeByTab[tab.id]}
                      />
                    )}
                  </div>
                );
              })}
            </DocumentContentArea>
        </TabViewWrapper>
      <FileProperties
        setOpen={setOpen}
        open={open}
        fileProp={fileProp}
        currentPage={currentPage}
        sort={sort}
        sortBy={sortBy}
        DrawerError={drawerError}
        setError={setdrawerError}
        showNotification={showNotification}
        setShowNotification={setShowNotification}
        setShowShareModal={setShowShareModal}
        reviewers={reviewers}
        setReviewers={setReviewers}
        handleRemindClick={(reviewData, isModal) => handleRemindClick({reviewData, isModal, setRemindStatusModal, setRemindStatusDrawer, remindInProgressIds, setRemindInProgressIds, dispatch, remindReview, setReviewers})}
        remindStatus={remindStatusDrawer}
        setRemindStatus={setRemindStatusDrawer}
        remindInProgressIds={remindInProgressIds}
      />
      <ReviewNotesModal
        openReviewNotesModal={openReviewNotes}
        setOpenReviewNotesModal={setOpenReviewNotes}
        selectedDoc={selectedDoc} />
      <AddToBriefBankModal
        open={briefBankModalOpen}
        documentId={
          selectedDoc?.id ||
          (selectedDoc?.unique_id
            ? String(selectedDoc.unique_id).replace(/^D/, "")
            : null)
        }
        documentName={selectedDoc?.name}
        onClose={() => setBriefBankModalOpen(false)}
        onAdded={() => setBriefBankModalOpen(false)}
      />
      {openESignModal &&
        <ESignModal
        handleSubmitESign={(payload) => handleSubmitESign(payload, dispatch, initiateESign, sendForESign, setdrawerError, setShowNotification, setisLoading)}
        openESignModal={openESignModal}
        setOpenESignModal={(open) => {
          setOpenESignModal(open);
          if (!open) setESignStartWithBoxes(false);
        }}
        handleSnackbar={handleSnackbar}
        selectedDoc={selectedDoc}
        startWithBoxPlacement={eSignStartWithBoxes}
        />}
      <AttorneySignatureModal
        open={Boolean(attorneySignatureDoc)}
        document={attorneySignatureDoc}
        onCancel={() => setAttorneySignatureDoc(null)}
        onSigned={() => setAttorneySignatureDoc(null)}
      />
      <SendForSignatureModal
        open={showSignatureLauncher}
        matterId={id}
        refreshKey={completedUploadsKey}
        onClose={() => setShowSignatureLauncher(false)}
        onChooseForm={(template) => {
          setShowSignatureLauncher(false);
          templateUploadButtonRef.current?.generateForSignature(template, {
            onGenerated: (document) => openSendForSignature(document),
            onBack: () => setShowSignatureLauncher(true),
          });
        }}
        onChooseDocument={(document, { placeBoxes } = {}) => {
          setShowSignatureLauncher(false);
          openSendForSignature(document, { placeBoxes });
        }}
        onUploadRequest={() => templateUploadButtonRef.current?.openFilePicker()}
      />
      {showSendToVAModal && (
        <SendToVAModal
          onClose={() => handleCloseSendToVAModal(setShowSendToVAModal, setVAFormData)}
          selectedDoc={selectedDoc}
          onNext={(formData) => handlePdfValidation(formData, setVAFormData, setShowSendToVAModal, setConfirmSubmit)}
          setShowSendToVAModal={setShowSendToVAModal}
          setConfirmSubmit={setConfirmSubmit}
          setShowGeneratedInternalFailure={()=>openModal("internalFailure")}
          initialFormData={VAFormData}
          setMessageModal={setMessageModal}
          handleSnackbar={handleSnackbar}
        />
      )}
      {showAddLetterheadModal && (
        <AddLetterheadModal
          isOpen={showAddLetterheadModal}
          onClose={() => setShowAddLetterheadModal(false)}
          selectedDoc={documentDetail}
          setShowAddLetterheadModal={setShowAddLetterheadModal}
          instanceRef={activeTab && activeTab !== "1" && activeTab !== "0" ? webViewerInstances.getInstance(activeTab) : null}
          isInstanceReady={webViewerInstances.isInstanceReady}
          setAutoSave={setAutoSave}
        />
      )}
      <ConfirmModal
        isOpen={confirmSubmit}
        title="Send File to Veterans Affairs"
        message={`File has passed the metadata checks. Please proceed to send ${selectedDoc?.name} to Veterans Affairs?`}
        cancelText="Back"
        confirmText="Submit"
        busy={isLoading}
        busyTitle="Sending to the VA"
        busyMessage="This can take a few seconds. Do not click again."
        busyText="Sending…"
        onClose={() => handleShowVaCancelModal(setConfirmCloseModal)}
        onCancel={() => handleGoBackToVa(setConfirmSubmit, setShowSendToVAModal)}
        onConfirm={() => handleConfirmSubmit(setisLoading, sendVAFormData, VAFormData, setConfirmSubmit, setVAFormData, openModal, setVaFixOffer)}
      />
      {vaFixOffer && (
        <ConfirmModal
          isOpen
          title={getVaFixOfferCopy(vaFixOffer).title}
          message={getVaFixOfferCopy(vaFixOffer).message}
          cancelText="Cancel"
          confirmText={getVaFixOfferCopy(vaFixOffer).confirmText}
          busy={isLoading}
          busyTitle="Starting the VA-ready copy"
          busyMessage="This only takes a moment. Do not click again."
          busyText="Starting…"
          onClose={() => setVaFixOffer(null)}
          onCancel={() => setVaFixOffer(null)}
          onConfirm={() => handleVaFixAndSubmit(setisLoading, compressAndSendVAFormData, VAFormData, vaFixOffer, setVaFixOffer, setVAFormData, openModal)}
        />
      )}
      <MessageModal
        open={messageModal.isOpen}
        onClose={messageModal.onClose}
        title={messageModal.title}
        message={messageModal.message}
        buttonText={messageModal.buttonText}
        icon={messageModal.icon}
        onClick={messageModal.onClick}
        variant={messageModal.variant}
      />
      {showNotification && (
        <ErrorToast
          message={drawerError}
          onClose={(id) =>
            setdrawerError((prev) => prev.filter((msg) => msg.id !== id))
          } // Hide notification when closed
        />
      )}
      {errorMessages.length > 0 && (
        <ErrorToast
          message={errorMessages}
          onClose={(id) => dispatch(removeNotification(id))} // remove when user closes
        />
      )}
      {showDeleteModal && (
        <CustomModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          heading={ selectedDoc?.type === "folder" ? "Delete Folder" : "Delete File"}
          content={
            selectedDoc?.type === "folder" ? (
              <>
                Are you sure you want to delete{" "}
                <FileNameShort title={selectedDoc?.name}>
                  {selectedDoc?.name}
                </FileNameShort>
                ? The folder will be moved to the Recycle Bin and can be
                restored later.
              </>
            ) : (
              <>
                Are you sure you want to delete{" "}
                <FileNameShort title={selectedDoc?.name}>
                 {selectedDoc?.name}
                </FileNameShort>
                ? The file will be moved to the Recycle Bin and can be restored
                later.
              </>
            )
          }
          btnTxtPrimary={
            selectedDoc?.type === "folder" ? "Delete folder" : "Delete file"
          }
          btnTxtSecondary="Cancel"
          onPrimaryClick={() => handleDelete({deleteDocument:selectedDoc, setShowDeleteModal, setisLoading, dispatch, deleteDoc, fetchMatterDetail, id, currentPage, sort, sortBy, folderId, tabs, setTabs, setdrawerError, setShowNotification, selectedKeys, getAllChildDocumentIdsByFolderId, deleteFolder, treeData, handleCloseDeletedTab, fetchMatterDetailList, setSelectedDoc})}
          onSecondaryClick={() => setShowDeleteModal(false)}
          disabled={loader}
          variant={"delete"}
        />
      )}
      {pendingUpload?.conflictType === "folder" && (
        <CustomModal
          open={confirmOverwrite}
          onClose={() => handleCancelOverwrite(setConfirmOverwrite, setPendingUpload)}
          icon={<WarningIcon />}
          variant={"warning"}
          heading={getConflictText("folder", pendingUpload?.conflictNames)}
          content={
              <StyledRadioGroup
                name="folderConflict"
                value={folderConflictOption}
                onChange={(e) => handleFolderConflictOption(setFolderConflictOption, e)}
              >
                <StyledRadio value="replace">
                  Replace the existing Folder
                </StyledRadio>
                <StyledRadio value="keep">Keep both Folders</StyledRadio>
              </StyledRadioGroup>
          }
          btnTxtPrimary="Upload"
          btnTxtSecondary="Cancel"
          onPrimaryClick={() => handleConfirmOverwrite({pendingUpload, handleProcessFiles, folderConflictOption, treeData, getAllChildDocumentIdsByFolderId, tabs, setTabs, setConfirmOverwrite, setPendingUpload})}
          onSecondaryClick={() => handleCancelOverwrite(setConfirmOverwrite, setPendingUpload)}
        />
      )}{" "}
      {pendingUpload?.conflictType === "file" && (
        <CustomModal
          open={confirmOverwrite}
          onClose={() => handleCancelOverwrite(setConfirmOverwrite, setPendingUpload)}
          icon={<WarningIcon />}
          heading="Warning: Duplicate File(s) Detected"
          variant={"warning"}
          content={
            <FileConflictContent>
              <p>{getConflictText("file", pendingUpload?.conflictNames)}</p>
            </FileConflictContent>
          }
          btnTxtPrimary="Proceed"
          btnTxtSecondary="Cancel"
          onPrimaryClick={() => handleConfirmOverwrite({pendingUpload, handleProcessFiles, folderConflictOption, treeData, getAllChildDocumentIdsByFolderId, tabs, setTabs, setConfirmOverwrite, setPendingUpload})}
          onSecondaryClick={() => handleCancelOverwrite(setConfirmOverwrite, setPendingUpload)}
        />
      )}

      {showAssignModal && (
        <AssignTaskModal
          open={Boolean(showAssignModal)}
          documentId={
            selectedDoc?.unique_id?.startsWith?.("D")
              ? selectedDoc.unique_id.substring(1)
              : selectedDoc?.id || selectedDoc?.document_id || null
          }
          matterId={id}
          onClose={() => setShowAssignModal(false)}
        />
      )}

      <CreateWorkItemModal
        open={showWorkItemModal}
        documentId={
          selectedDoc?.unique_id?.startsWith?.("D")
            ? selectedDoc.unique_id.substring(1)
            : selectedDoc?.id || selectedDoc?.document_id || null
        }
        onClose={() => setShowWorkItemModal(false)}
      />

      <SendMessageModal
        open={showSendMessageModal}
        // Same id resolution as AssignTaskModal above: list rows carry a
        // "D"-prefixed unique_id, other surfaces a bare id.
        documentId={
          selectedDoc?.unique_id?.startsWith?.("D")
            ? selectedDoc.unique_id.substring(1)
            : selectedDoc?.id || selectedDoc?.document_id || null
        }
        onClose={() => setShowSendMessageModal(false)}
      />

      {showShareModal && (
        <ShareModal
          open={showShareModal}
          onClose={() => {
            setShowShareModal(false);
          }}
          setdrawerError={setdrawerError}
          setShowNotification={setShowNotification}
          selectedDoc={selectedDoc}
          fromDocumentListing={activeTab === "1"}
          reviewers={reviewers}
          setReviewers={setReviewers}
          tabs={tabs}
          closeTab={closeTab}
          closeDrawer={() => setOpen(false)}
          handleRemindClick={(reviewData, isModal) =>
          handleRemindClick({
            reviewData,
            isModal,
            setRemindStatusModal,
            setRemindStatusDrawer,
            remindInProgressIds,
            setRemindInProgressIds,
            dispatch,
            remindReview,
            setReviewers,
            })
          }
          remindStatus={remindStatusModal}
          setRemindStatus={setRemindStatusModal}
          remindInProgressIds={remindInProgressIds}
          matterId={id}
        />
      )}
      {showReviewActionModal && reviewActionType && (
        <ReviewActionModal
          open={true}
          onClose={() => {
            setSelectedForwardRecipients([]);
            handleCloseActionModal(
              setShowReviewActionModal,
              setReviewActionType,
              setActionComment
            );
          }}
          btnTxtSecondary="Cancel"
          onPrimaryClick={() => handleReviewSubmit({selectedDoc, shareID, reviewActionType, actionComment, setConfirmCloseTab, setShowReviewActionModal, handleReviewAction, tabs, setActionComment, setReviewActionType})}
          disabled={
            reviewActionType === "approve_forward"
            && selectedForwardRecipients.length !== 1
          }
          comment={actionComment}
          setComment={setActionComment}
          config={getReviewActionConfig(reviewActionType, selectedDoc?.name)}
          recipientOptions={forwardRecipientOptions}
          selectedRecipients={selectedForwardRecipients}
          setSelectedRecipients={setSelectedForwardRecipients}
        />
      )}
      {showExternalShareModal && (
        <ShareFileModal
          isOpen={showExternalShareModal}
          onClose={() => setShowExternalShareModal(false)}
          selectedDoc={selectedDoc}
          document_id={selectedDoc.unique_id.substring(1)}
          handleSnackbar={handleSnackbar}
        />
      )}
      {showExpertShareModal && (
        <ShareWithExpertModal
          isOpen={showExpertShareModal}
          onClose={() => {
            setShowExpertShareModal(false);
            setExpertShareVersion((version) => version + 1);
          }}
          matterId={id}
          clientName={matterDetails?.matter_displayName}
        />
      )}
      {isDraggingOverRow && (
        <DropTarget name={dropTargetName} />
      )}
      {/* Confirm Cancel Action for VA */}
      <ConfirmModal
        isOpen={confirmCloseModal}
        title="Warning: This action will be discarded"
        message="This will cancel the send to VA process and all progress will be lost. Are you sure you want to proceed?"
        cancelText="Cancel"
        confirmText="Proceed"
        onCancel={() => handleGoBackToVA(setConfirmCloseModal)}
        onConfirm={() => handleConfirmVaClose(setVAFormData, setConfirmCloseModal, setConfirmSubmit)}
      />
      <ConfirmModal
        isOpen={confirmCloseTab}
        title="Warning: Open tab will be closed"
        message={
          activeTab == 1
            ? "After this action, the current file tab will be closed"
            : "The current file tab will be closed, and you will be redirected to the folder listing of this matter."
        }
        cancelText="Cancel"
        confirmText="Proceed"
        onCancel={() => handleGoBackToAction(setConfirmCloseTab, setShowReviewActionModal)}
        onConfirm={() => handleConfirmReviewAction({selectedDoc, shareID, reviewActionType, actionComment, setConfirmCloseTab, setShowReviewActionModal, handleReviewAction, setActionComment, setReviewActionType})}
      />
        <ConfirmModal
          title={modalFolderHeader}
          isOpen={showFolderModal}
          message={modalMessage}
          onConfirm={handleFolderModalConfirm}
          confirmText="OK"
          onCancel={handleFolderModalConfirm}
        />
      <GeneratePackageFromMatterModal
        open={generatePackageOpen}
        packages={matterPackages}
        folders={matterPackageFolderOptions}
        matterId={id}
        loading={matterPackagesLoading}
        generating={packageGenerating}
        previewing={packagePreviewing}
        onCancel={() => setGeneratePackageOpen(false)}
        onPreview={handlePreviewPackageFromMatter}
        onPreviewPdf={handlePreviewPackageTemplatePdf}
        onGenerate={handleGeneratePackageFromMatter}
      />
      <DocumentVersionHistoryModal
        open={Boolean(versionHistoryTarget)}
        documentId={
          versionHistoryTarget?.documentRecord?.id ||
          (versionHistoryTarget?.documentRecord?.unique_id
            ? versionHistoryTarget.documentRecord.unique_id.substring(1)
            : null)
        }
        documentName={versionHistoryTarget?.documentRecord?.name || ""}
        onClose={() => setVersionHistoryTarget(null)}
        onRestored={handleVersionRestored}
      />
      <SaveAsCollectionModal
        open={collectionModalOpen}
        documents={collectionCandidates}
        collections={collections}
        loadingCollections={loadingCollections}
        saving={savingCollection}
        onCancel={() => {
          setCollectionModalOpen(false);
          setCollectionCandidates([]);
        }}
        onSave={handleSaveAsCollection}
      />
      <PackageResultsModal
        open={!!packageMergeResult}
        result={packageMergeResult}
        busy={packageActionBusy}
        onClose={() => setPackageMergeResult(null)}
        onDownload={handleDownloadGeneratedMatterDocument}
        onRename={handleRenameGeneratedMatterDocument}
        onDelete={handleDeleteGeneratedMatterDocuments}
        onCombine={handleCombineGeneratedMatterDocuments}
      />
<FileMergeModalContainer
  open={isModalOpen}
  onClose={() => {
    setIsModalOpen(false);
    setMergeSeedFiles(null);
  }}
  treeData={treeData}
  setIsModalOpen={setIsModalOpen}
  selectedFile={selectedFile}
  setSelectedFile = {setSelectedFile}
  initialFiles={mergeSeedFiles}
  listContext={{ page: currentPage, sort_direction: sort, sort_by: sortBy }}
  navigate={navigate}
/>
{pdfTools.notification}
      <CategorizeDocumentModal
        open={categorizeModalState.open}
        onClose={handleCloseCategorize}
        mode={canUseGoldStandard ? "gold-standard" : "recategorize"}
        documentId={categorizeModalState.documentId}
        documentName={categorizeModalState.documentName}
        inferredCategory={categorizeModalState.inferredCategory}
        existingGoldStandard={categorizeGoldStandard}
      />
    </>
  );
};

export default TabView;
TabView.propTypes = {
  showSideBar: PropTypes.bool.isRequired,
  setShowSideBar: PropTypes.func.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  breadcrumb: PropTypes.array.isRequired,
  uniqueId: PropTypes.string.isRequired,
  setUniqueId: PropTypes.func.isRequired,
  treeData: PropTypes.array.isRequired,
  drawerError: PropTypes.array.isRequired,
  setdrawerError: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  checkTabLimitRef: PropTypes.shape({ current: PropTypes.func }),
  cleanupDocumentRef: PropTypes.shape({ current: PropTypes.func }),
  openTabRef: PropTypes.shape({ current: PropTypes.func }),
  setActiveTabRef: PropTypes.shape({ current: PropTypes.func }),
};